(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtc-about-us-accomplishments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-feature-grid')) {
    class DtcFeatureGrid extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.dtc-feature-grid__slider');
        this.items = this.querySelector('.dtc-feature-grid__items');
        this.nav = this.querySelector('.dtc-feature-grid__nav');
        this.paginationWrapper = this.querySelector('.dtc-feature-grid__pagination-wrapper');
        this.pagination = this.querySelector('.dtc-feature-grid__pagination');
        this.prevBtn = this.querySelector('.dtc-feature-grid__nav-btn--prev');
        this.nextBtn = this.querySelector('.dtc-feature-grid__nav-btn--next');
        this.cards = this.querySelectorAll('.dtc-feature-grid__card');
        this.dots = [];
        
        if (!this.slider) return;

        if (this.prevBtn && this.nextBtn) {
          this.prevBtn.addEventListener('click', () => this.scroll(-1));
          this.nextBtn.addEventListener('click', () => this.scroll(1));
        }

        this.slider.addEventListener('scroll', () => this.updateActiveDot());
        this._onResize = () => this.updateControls();
        window.addEventListener('resize', this._onResize);
        this.updateControls();
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }

      scroll(direction) {
        const step = this.getScrollStep();
        const maxScroll = this.getMaxScrollLeft();
        if (step <= 0 || maxScroll <= 1) return;

        if (this.dots.length <= 1) {
          const atStart = this.slider.scrollLeft <= 1;
          const atEnd = this.slider.scrollLeft >= maxScroll - 1;
          if (direction < 0 && !atStart) {
            this.slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (direction > 0 && !atEnd) {
            this.slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
          }
          return;
        }

        const nextIndex = Math.max(0, Math.min(this.dots.length - 1, this.getActiveDotIndex() + direction));
        this.scrollToIndex(nextIndex);
      }

      scrollToIndex(index) {
        const step = this.getScrollStep();
        if (step <= 0) return;
        const maxScroll = this.getMaxScrollLeft();
        const isLastDot = this.dots.length > 0 && index === this.dots.length - 1;
        const target = isLastDot ? maxScroll : Math.min(index * step, maxScroll);
        this.slider.scrollTo({ left: target, behavior: 'smooth' });
      }

      getMaxScrollLeft() {
        if (!this.items || !this.slider) return 0;
        return Math.max(0, this.items.scrollWidth - this.slider.clientWidth);
      }

      getItemsGap() {
        if (!this.items) return 0;

        const style = window.getComputedStyle(this.items);
        const gap = parseFloat(style.columnGap || style.gap);
        if (!Number.isNaN(gap) && gap >= 0) return gap;

        if (this.cards.length < 2) return 0;

        return this.cards[1].offsetLeft - this.cards[0].offsetLeft - this.cards[0].offsetWidth;
      }

      getScrollStep() {
        if (!this.cards.length) return 0;
        return this.cards[0].offsetWidth + this.getItemsGap();
      }

      getDotCount() {
        const step = this.getScrollStep();
        const maxScroll = this.getMaxScrollLeft();
        if (step <= 0 || maxScroll <= 1) return 0;

        let count = 1;
        let position = step;

        while (position < maxScroll - 1) {
          count++;
          position += step;
        }

        return count;
      }

      getActiveDotIndex() {
        const step = this.getScrollStep();
        if (step <= 0 || !this.dots.length) return 0;

        const maxScroll = this.getMaxScrollLeft();
        const scrollLeft = this.slider.scrollLeft;

        if (scrollLeft >= maxScroll - 1) {
          return this.dots.length - 1;
        }

        return Math.max(0, Math.min(this.dots.length - 1, Math.round(scrollLeft / step)));
      }

      updateControls() {
        if (!this.items || !this.cards.length) return;

        const hasOverflow = this.getMaxScrollLeft() > 1;
        if (this.nav) this.nav.classList.toggle('is-hidden', !hasOverflow);
        if (this.paginationWrapper) this.paginationWrapper.classList.toggle('is-hidden', !hasOverflow);
        if (!hasOverflow) {
          this.renderDots(0);
          return;
        }

        const dotCount = this.getDotCount();
        if (this.paginationWrapper) this.paginationWrapper.classList.toggle('is-hidden', dotCount <= 1);
        this.renderDots(dotCount <= 1 ? 0 : dotCount);
        this.updateActiveDot();
      }

      renderDots(count) {
        if (!this.pagination || this.dots.length === count) return;

        this.pagination.replaceChildren();
        this.dots = Array.from({ length: count }, (_, index) => {
          const dot = document.createElement('button');
          dot.className = 'dtc-feature-grid__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToIndex(index));
          this.pagination.appendChild(dot);
          return dot;
        });
      }

      updateActiveDot() {
        if (!this.dots.length) return;

        const dotIndex = this.getActiveDotIndex();

        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === dotIndex);
        });
      }
    }
    customElements.define('dtc-feature-grid', DtcFeatureGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-about-us-expert-endorsements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-expert-endorsements')) {
    class DtcExpertEndorsements extends HTMLElement {}
    customElements.define('dtc-expert-endorsements', DtcExpertEndorsements);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-about-us-history"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-about-us-history')) {
    class DtcAboutUsHistory extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.dtc-about-us-history__nav');
        this.navBtns = this.querySelectorAll('.dtc-about-us-history__nav-btn');
        this.cardsContainer = this.querySelector('.dtc-about-us-history__cards');
        this.cards = this.querySelectorAll('.dtc-about-us-history__card');
        this._isProgrammaticScroll = false;
        this._scrollEndTimer = null;

        this._onNavClick = (event) => {
          const btn = event.currentTarget;
          this.activateYear(btn.dataset.year, { scrollNav: true });
        };

        this._onCardsScroll = () => {
          if (this._isProgrammaticScroll) return;
          this.updateActiveNav();
        };

        this.navBtns.forEach((btn) => {
          btn.addEventListener('click', this._onNavClick);
        });

        if (this.cardsContainer) {
          this.cardsContainer.addEventListener('scroll', this._onCardsScroll, { passive: true });
        }

        const initialYear = this.dataset.initialYear;
        if (initialYear) {
          requestAnimationFrame(() => {
            this.activateYear(initialYear, { scrollNav: false });
          });
        } else {
          this.updateActiveNav();
        }

        if (window.Shopify && Shopify.designMode) {
          const section = this.closest('.shopify-section');
          if (section) {
            this._onBlockSelect = (e) => {
              const block = e.target;
              if (block.classList.contains('dtc-about-us-history__card')) {
                const index = parseInt(block.dataset.index, 10);
                if (!Number.isNaN(index)) {
                  this.scrollToCard(index);
                }
              }
            };
            section.addEventListener('shopify:block:select', this._onBlockSelect);
          }
        }
      }

      disconnectedCallback() {
        this.navBtns.forEach((btn) => {
          btn.removeEventListener('click', this._onNavClick);
        });

        if (this.cardsContainer) {
          this.cardsContainer.removeEventListener('scroll', this._onCardsScroll);
        }

        if (this._scrollEndTimer) {
          window.clearTimeout(this._scrollEndTimer);
        }

        const section = this.closest('.shopify-section');
        if (section && this._onBlockSelect) {
          section.removeEventListener('shopify:block:select', this._onBlockSelect);
        }
      }

      activateYear(year, { scrollNav = true } = {}) {
        const cards = Array.from(this.cards);
        const cardIndex = cards.findIndex((item) => item.dataset.year === year);

        this.setActiveYear(year);

        if (cardIndex >= 0) {
          this.scrollToCard(cardIndex);
        }

        if (scrollNav) {
          this.scrollNavButtonIntoView(year);
        }
      }

      setActiveYear(year) {
        this.navBtns.forEach((btn) => {
          const isActive = btn.dataset.year === year;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      scrollNavButtonIntoView(year) {
        if (!this.nav) return;

        const btn = Array.from(this.navBtns).find((item) => item.dataset.year === year);
        if (!btn || this.nav.scrollWidth <= this.nav.clientWidth) return;

        const targetScroll = btn.offsetLeft - (this.nav.clientWidth - btn.offsetWidth) / 2;
        this.nav.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: 'smooth',
        });
      }

      scrollToCard(index) {
        if (!this.cardsContainer || !this.cards[index]) return;

        const card = this.cards[index];
        const cardLeft = this.getCardOffset(index);
        const containerWidth = this.cardsContainer.clientWidth;
        const cardWidth = card.clientWidth;
        const maxScroll = Math.max(0, this.cardsContainer.scrollWidth - containerWidth);
        const targetScroll = Math.min(
          maxScroll,
          Math.max(0, cardLeft - (containerWidth - cardWidth) / 2)
        );

        this._isProgrammaticScroll = true;
        this.cardsContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth',
        });

        if (card.dataset.year) {
          this.setActiveYear(card.dataset.year);
        }

        window.clearTimeout(this._scrollEndTimer);
        this._scrollEndTimer = window.setTimeout(() => {
          this._isProgrammaticScroll = false;
          this.updateActiveNav();
        }, 400);
      }

      getCardOffset(index) {
        const card = this.cards[index];
        if (!card || !this.cardsContainer) return 0;

        return card.offsetLeft;
      }

      updateActiveNav() {
        if (!this.cardsContainer || !this.cards.length) return;

        const scrollLeft = this.cardsContainer.scrollLeft;
        const containerWidth = this.cardsContainer.clientWidth;
        const centerPosition = scrollLeft + containerWidth / 2;

        let activeIndex = 0;
        let minDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardCenter = this.getCardOffset(index) + card.clientWidth / 2;
          const distance = Math.abs(cardCenter - centerPosition);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        const activeYear = this.cards[activeIndex] ? this.cards[activeIndex].dataset.year : '';
        if (activeYear) {
          this.setActiveYear(activeYear);
        }
      }
    }

    customElements.define('dtc-about-us-history', DtcAboutUsHistory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-about-us-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-about-us-map')) {
    class DtcAboutUsMap extends HTMLElement {
      connectedCallback() {
        this._initAccordion();

        if (window.Shopify && Shopify.designMode) {
          this._sectionEl = this.closest('.shopify-section');
          this._onBlockSelect = this._handleBlockSelect.bind(this);
          this._sectionEl?.addEventListener('shopify:block:select', this._onBlockSelect);
        }
      }

      disconnectedCallback() {
        this._sectionEl?.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      _initAccordion() {
        this._accordionItems = Array.from(
          this.querySelectorAll('.dtc-about-us-map__accordion-item')
        );

        this._accordionItems.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;

            this._accordionItems.forEach((other) => {
              if (other !== item) other.open = false;
            });
          });
        });
      }

      _handleBlockSelect(event) {
        const blockId = event.detail?.blockId;
        if (!blockId) return;

        const regionItem = this.querySelector(`#shopify-block-${blockId}`);
        if (!regionItem?.classList.contains('dtc-about-us-map__accordion-item')) return;

        this._accordionItems.forEach((item) => {
          item.open = item === regionItem;
        });
        regionItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    customElements.define('dtc-about-us-map', DtcAboutUsMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-air-solution-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-air-solution-tabs')) {
    class DtcAirSolutionTabs extends HTMLElement {
      connectedCallback() {
        this._init();
        this._syncPanelsWrapHeight();
        this._panelsResizeObserver = new ResizeObserver(() => this._syncPanelsWrapHeight());
        const panelsWrap = this.querySelector('.dtc-air-solution-tabs__panels-wrap');
        if (panelsWrap) this._panelsResizeObserver.observe(panelsWrap);
        window.addEventListener('resize', this._handleResize);
        if (window.Shopify && Shopify.designMode) {
          const shopifySection = this.closest('.shopify-section');
          if (shopifySection) {
            shopifySection.addEventListener('shopify:section:select', () => this._resetToFirst());
            shopifySection.addEventListener('shopify:block:select', (e) => {
              const blockId = e.detail && e.detail.blockId;
              if (!blockId) return;
              const panel = this.querySelector(`.dtc-air-solution-tabs__panel[data-block-id="${blockId}"]`);
              if (!panel) return;
              const panelId = panel.id;
              const btn = this.querySelector(`.dtc-air-solution-tabs__nav-btn[aria-controls="${panelId}"]`);
              if (btn) this._activateTab(btn);
            });
          }
        }
      }

      disconnectedCallback() {
        this.querySelectorAll('.dtc-air-solution-tabs__nav-btn').forEach((btn) => {
          btn.removeEventListener('click', this._handleClick);
        });
        window.removeEventListener('resize', this._handleResize);
        if (this._panelsResizeObserver) {
          this._panelsResizeObserver.disconnect();
          this._panelsResizeObserver = null;
        }
        if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
      }

      _init() {
        this._handleClick = (e) => this._activateTab(e.currentTarget);
        this._handleResize = () => {
          if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
          this._resizeRaf = requestAnimationFrame(() => this._syncPanelsWrapHeight());
        };
        this.querySelectorAll('.dtc-air-solution-tabs__nav-btn').forEach((btn) => {
          btn.addEventListener('click', this._handleClick);
        });
        this._initVideos();
      }

      _initVideos() {
        this.querySelectorAll('.dtc-air-solution-tabs__video').forEach((media) => {
          const playBtn = media.querySelector('.dtc-air-solution-tabs__video-play');
          const playerWrap = media.querySelector('.dtc-air-solution-tabs__video-player');
          const closeBtn = media.querySelector('.dtc-air-solution-tabs__video-close');
          const video = media.querySelector('.dtc-air-solution-tabs__video-element');
          const iframe = media.querySelector('.dtc-air-solution-tabs__video-iframe');

          if (!playBtn || !playerWrap) return;

          playBtn.addEventListener('click', () => {
            if (playBtn.disabled) return;

            if (video) {
              let sources = [];
              try {
                sources = JSON.parse(playBtn.dataset.videoSources || '[]');
              } catch (error) {
                sources = [];
              }

              video.innerHTML = '';
              sources.forEach((source) => {
                const src = document.createElement('source');
                src.src = source.url;
                src.type = source.type;
                video.appendChild(src);
              });

              playerWrap.hidden = false;
              playBtn.hidden = true;
              video.load();
              video.play().catch(() => {});
              return;
            }

            if (iframe && playBtn.dataset.embedUrl) {
              iframe.src = playBtn.dataset.embedUrl;
              playerWrap.hidden = false;
              playBtn.hidden = true;
            }
          });

          if (closeBtn) {
            closeBtn.addEventListener('click', () => {
              if (video) {
                video.pause();
                video.innerHTML = '';
              }
              if (iframe) {
                iframe.src = '';
              }
              playerWrap.hidden = true;
              playBtn.hidden = false;
            });
          }
        });
      }

      _pausePanelVideos(panel) {
        if (!panel) return;

        panel.querySelectorAll('.dtc-air-solution-tabs__video').forEach((media) => {
          const playBtn = media.querySelector('.dtc-air-solution-tabs__video-play');
          const playerWrap = media.querySelector('.dtc-air-solution-tabs__video-player');
          const video = media.querySelector('.dtc-air-solution-tabs__video-element');
          const iframe = media.querySelector('.dtc-air-solution-tabs__video-iframe');

          if (video) {
            video.pause();
            video.innerHTML = '';
          }
          if (iframe) {
            iframe.src = '';
          }
          if (playerWrap) playerWrap.hidden = true;
          if (playBtn) playBtn.hidden = false;
        });
      }

      _syncPanelsWrapHeight() {
        const wrap = this.querySelector('.dtc-air-solution-tabs__panels-wrap');
        if (!wrap) return;

        const panels = wrap.querySelectorAll('.dtc-air-solution-tabs__panel');
        if (!panels.length) return;

        let maxHeight = 0;

        panels.forEach((panel) => {
          const saved = {
            position: panel.style.position,
            inset: panel.style.inset,
            visibility: panel.style.visibility,
            opacity: panel.style.opacity,
            pointerEvents: panel.style.pointerEvents,
            height: panel.style.height,
          };

          panel.style.position = 'relative';
          panel.style.inset = 'auto';
          panel.style.visibility = 'hidden';
          panel.style.opacity = '1';
          panel.style.pointerEvents = 'none';
          panel.style.height = 'auto';

          maxHeight = Math.max(maxHeight, panel.offsetHeight);

          panel.style.position = saved.position;
          panel.style.inset = saved.inset;
          panel.style.visibility = saved.visibility;
          panel.style.opacity = saved.opacity;
          panel.style.pointerEvents = saved.pointerEvents;
          panel.style.height = saved.height;
        });

        wrap.style.minHeight = maxHeight > 0 ? `${maxHeight}px` : '';
      }

      _activateTab(btn) {
        const root = this;
        const nextPanel = root.querySelector(`#${btn.getAttribute('aria-controls')}`);
        if (!nextPanel || nextPanel.classList.contains('is-active')) return;

        const currentPanel = root.querySelector('.dtc-air-solution-tabs__panel.is-active');

        /* Update nav buttons */
        root.querySelectorAll('.dtc-air-solution-tabs__nav-btn').forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        /* Fade out current panel */
        if (currentPanel) {
          this._pausePanelVideos(currentPanel);
          currentPanel.classList.remove('is-active');
          currentPanel.classList.add('is-leaving');
          currentPanel.setAttribute('aria-hidden', 'true');
          const onLeaveEnd = () => {
            currentPanel.classList.remove('is-leaving');
            currentPanel.removeEventListener('transitionend', onLeaveEnd);
          };
          currentPanel.addEventListener('transitionend', onLeaveEnd);
        }

        /* Fade in next panel */
        nextPanel.classList.add('is-active');
        nextPanel.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => this._syncPanelsWrapHeight());

        /* Scroll active tab into view on mobile nav */
        const nav = root.querySelector('.dtc-air-solution-tabs__nav');
        if (nav && nav.scrollWidth > nav.clientWidth) {
          const btnLeft = btn.offsetLeft;
          const btnWidth = btn.offsetWidth;
          const navWidth = nav.clientWidth;
          const targetScroll = btnLeft - (navWidth - btnWidth) / 2;
          nav.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
        }
      }

      _resetToFirst() {
        const firstBtn = this.querySelector('.dtc-air-solution-tabs__nav-btn');
        if (firstBtn) this._activateTab(firstBtn);
      }
    }
    customElements.define('dtc-air-solution-tabs', DtcAirSolutionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-article-ingredient-swap"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-article-ingredient-swap')) {
    class DtcArticleIngredientSwap extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.dtc-article-ingredient-swap__toggle');
        this.panel = this.querySelector('.dtc-article-ingredient-swap__panel');

        if (!this.toggleButton || !this.panel) return;

        this.toggleButton.addEventListener('click', () => this.togglePanel());

        if (window.Shopify && Shopify.designMode) {
          const section = this.closest('.shopify-section');

          if (section) {
            section.addEventListener('shopify:section:select', () => this.expandPanel());
          }
        }
      }

      togglePanel() {
        if (this.classList.contains('is-expanded')) {
          this.collapsePanel();
          return;
        }

        this.expandPanel();
      }

      expandPanel() {
        this.classList.add('is-expanded');
        this.panel.hidden = false;
        this.toggleButton.setAttribute('aria-expanded', 'true');
      }

      collapsePanel() {
        this.classList.remove('is-expanded');
        this.panel.hidden = true;
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }
    }

    customElements.define('dtc-article-ingredient-swap', DtcArticleIngredientSwap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-article-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-article-ingredients')) {
    const FRACTION_MAX_DENOMINATOR = 16;
    const FRACTION_EPSILON = 0.02;

    function gcd(a, b) {
      let x = Math.abs(a);
      let y = Math.abs(b);

      while (y) {
        const remainder = x % y;
        x = y;
        y = remainder;
      }

      return x || 1;
    }

    function formatFractionHtml(numerator, denominator) {
      return (
        '<span class="dtc-article-ingredients__fraction"><sup>' +
        numerator +
        '</sup>/<sub>' +
        denominator +
        '</sub></span>'
      );
    }

    function formatQuantity(value) {
      if (!Number.isFinite(value)) return '';

      const rounded = Math.round(value * 1000) / 1000;
      const whole = Math.floor(rounded + FRACTION_EPSILON);
      const decimal = rounded - whole;

      if (decimal < FRACTION_EPSILON) {
        return whole ? String(whole) : '0';
      }

      if (Math.abs(decimal - 1) < FRACTION_EPSILON) {
        return String(whole + 1);
      }

      for (let denominator = 2; denominator <= FRACTION_MAX_DENOMINATOR; denominator += 1) {
        const numerator = Math.round(decimal * denominator);

        if (Math.abs(decimal - numerator / denominator) < FRACTION_EPSILON) {
          const divisor = gcd(numerator, denominator);
          const fractionHtml = formatFractionHtml(numerator / divisor, denominator / divisor);
          return whole ? whole + ' ' + fractionHtml : fractionHtml;
        }
      }

      return parseFloat(rounded.toFixed(2)).toString();
    }

    class DtcArticleIngredients extends HTMLElement {
      connectedCallback() {
        this.scale = 1;
        this.scaleButtons = this.querySelectorAll('[data-scale]');
        this.quantityEls = this.querySelectorAll('[data-quantity-value]');
        this.yieldEl = this.querySelector('[data-yield-value]');

        this.scaleButtons.forEach((button) => {
          button.addEventListener('click', () => this.setScale(parseFloat(button.dataset.scale, 10)));
        });

        this.setScale(1);
      }

      setScale(scale) {
        this.scale = scale;

        this.scaleButtons.forEach((button) => {
          button.classList.toggle('is-active', parseFloat(button.dataset.scale, 10) === scale);
        });

        this.quantityEls.forEach((element) => {
          const baseValue = parseFloat(element.dataset.baseValue, 10);
          if (!Number.isFinite(baseValue)) return;
          this.renderQuantity(element, baseValue * scale);
        });

        if (this.yieldEl) {
          const baseServing = parseFloat(this.yieldEl.dataset.baseServing, 10);
          if (Number.isFinite(baseServing)) {
            this.yieldEl.textContent = baseServing * scale;
          }
        }
      }

      renderQuantity(element, value) {
        const formatted = formatQuantity(value);

        if (formatted.includes('dtc-article-ingredients__fraction')) {
          element.innerHTML = formatted;
          return;
        }

        element.textContent = formatted;
      }
    }

    customElements.define('dtc-article-ingredients', DtcArticleIngredients);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-article-nutrition"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('dtc-article-nutrition')) {
      class DtcArticleNutrition extends HTMLElement {
        connectedCallback() {
          this.toggleButton = this.querySelector('.dtc-article-nutrition__toggle');
          this.panel = this.querySelector('.dtc-article-nutrition__panel');

          if (!this.toggleButton || !this.panel) return;

          this.toggleButton.addEventListener('click', () => this.togglePanel());

          if (window.Shopify && Shopify.designMode) {
            const section = this.closest('.shopify-section');

            if (section) {
              section.addEventListener('shopify:section:select', () => this.expandPanel());
            }
          }
        }

        togglePanel() {
          if (this.classList.contains('is-expanded')) {
            this.collapsePanel();
            return;
          }

          this.expandPanel();
        }

        expandPanel() {
          this.classList.add('is-expanded');
          this.panel.hidden = false;
          this.toggleButton.setAttribute('aria-expanded', 'true');
        }

        collapsePanel() {
          this.classList.remove('is-expanded');
          this.panel.hidden = true;
          this.toggleButton.setAttribute('aria-expanded', 'false');
        }
      }

      customElements.define('dtc-article-nutrition', DtcArticleNutrition);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-better-air-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-better-air-product-grid')) {
    class DtcBetterAirProductGrid extends HTMLElement {
      connectedCallback() {
        this._tabs = Array.from(this.querySelectorAll('.dtc-better-air-product-grid__tab'));
        this._panels = Array.from(this.querySelectorAll('.dtc-better-air-product-grid__panel'));
        this._sliderDotRecords = [];
        this._sliderDotTimers = [];
        this._boundDotSliders = new Set();
        this._ownedSwipers = [];
        this._handleTabClick = (event) => this._activateTab(event.currentTarget);
        this._handleResize = () => {
          this._panels.forEach((panel) => this._syncPagination(panel));
          this._syncMobileDots();
        };

        this._tabs.forEach((tab) => tab.addEventListener('click', this._handleTabClick));
        this._panels.forEach((panel) => this._setupPagination(panel));
        this._ensureSliders();
        this._setupMobileDots();
        window.addEventListener('resize', this._handleResize, { passive: true });

        if (window.Shopify && Shopify.designMode) {
          this._shopifySection = this.closest('.shopify-section');
          if (this._shopifySection) {
            this._handleSectionSelect = () => {
              const firstTab = this._tabs[0];
              if (firstTab) this._activateTab(firstTab);
            };
            this._handleBlockSelect = (event) => {
              const blockId = event.detail && event.detail.blockId;
              if (!blockId) return;
              const panel = this.querySelector(`.dtc-better-air-product-grid__panel[data-block-id="${blockId}"]`);
              if (!panel) return;
              const tab = this.querySelector(`.dtc-better-air-product-grid__tab[aria-controls="${panel.id}"]`);
              if (tab) this._activateTab(tab);
            };
            this._shopifySection.addEventListener('shopify:section:select', this._handleSectionSelect);
            this._shopifySection.addEventListener('shopify:block:select', this._handleBlockSelect);
          }
        }
      }

      disconnectedCallback() {
        this._tabs.forEach((tab) => tab.removeEventListener('click', this._handleTabClick));
        this._sliderDotTimers.forEach((timer) => window.clearTimeout(timer));
        this._sliderDotRecords.forEach(({ swiper, onUpdate }) => {
          swiper.off('slideChange', onUpdate);
          swiper.off('paginationUpdate', onUpdate);
          swiper.off('resize', onUpdate);
        });
        this._ownedSwipers.forEach((swiper) => {
          if (swiper && !swiper.destroyed) swiper.destroy(true, true);
        });
        window.removeEventListener('resize', this._handleResize);
        if (this._shopifySection) {
          this._shopifySection.removeEventListener('shopify:section:select', this._handleSectionSelect);
          this._shopifySection.removeEventListener('shopify:block:select', this._handleBlockSelect);
        }
      }

      _activateTab(tab) {
        const panelId = tab.getAttribute('aria-controls');
        const nextPanel = this.querySelector(`#${panelId}`);
        if (!nextPanel) return;

        this._tabs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        this._panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        });
        nextPanel.classList.add('is-active');
        nextPanel.setAttribute('aria-hidden', 'false');
        this._syncPagination(nextPanel);
        this._updatePanelSlider(nextPanel);
        this._setupPanelDots(nextPanel);
        this._syncMobileDots();
      }

      _setupPagination(panel) {
        panel._currentPage = 1;
        this._syncPagination(panel);
      }

      _syncPagination(panel) {
        const items = Array.from(panel.querySelectorAll('.dtc-better-air-product-grid__item'));
        const pagination = panel.querySelector('[data-pagination]');

        if (this._isMobileCarousel()) {
          items.forEach((item) => {
            item.hidden = false;
          });
          if (pagination) pagination.hidden = true;
          return;
        }

        const pageSize = Number(panel.dataset.pageSize) || items.length || 1;
        const pageCount = Math.max(Math.ceil(items.length / pageSize), 1);
        const currentPage = Math.min(panel._currentPage || 1, pageCount);
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;

        items.forEach((item, index) => {
          item.hidden = index < start || index >= end;
        });
        this._updatePanelSlider(panel);

        if (!pagination) return;

        pagination.hidden = pageCount <= 1;
        if (pageCount <= 1) return;

        const prev = pagination.querySelector('[data-pagination-prev]');
        const next = pagination.querySelector('[data-pagination-next]');
        const pages = pagination.querySelector('[data-pagination-pages]');

        prev.disabled = currentPage === 1;
        next.disabled = currentPage === pageCount;

        prev.onclick = () => {
          panel._currentPage = Math.max(currentPage - 1, 1);
          this._syncPagination(panel);
          this._scrollToContainerTop();
        };
        next.onclick = () => {
          panel._currentPage = Math.min(currentPage + 1, pageCount);
          this._syncPagination(panel);
          this._scrollToContainerTop();
        };

        pages.innerHTML = '';
        for (let page = 1; page <= pageCount; page += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `dtc-better-air-product-grid__pagination-page${page === currentPage ? ' is-active' : ''}`;
          button.textContent = page;
          button.onclick = () => {
            panel._currentPage = page;
            this._syncPagination(panel);
            this._scrollToContainerTop();
          };
          pages.appendChild(button);
        }
      }

      _scrollToContainerTop() {
        const target = this.querySelector('.dtc-better-air-product-grid__container')
        if (!target) return;

        const offset = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
      }

      _updatePanelSlider(panel) {
        const slider = panel.querySelector('swiper-slider');
        if (!slider) return;
        this._ensureSlider(slider);
        if (!slider.swiper) return;
        slider.swiper.update();
        if (slider.swiper.pagination) {
          slider.swiper.pagination.render();
          slider.swiper.pagination.update();
        }
      }

      _ensureSliders() {
        const sliders = Array.from(this.querySelectorAll('.dtc-better-air-product-grid__panel.is-active .dtc-better-air-product-grid__slider'));
        sliders.forEach((slider) => this._ensureSlider(slider));
      }

      _ensureSlider(slider) {
        if (slider.swiper || slider.dataset.dtcBetterAirOwnedSwiper === 'true') return;
        if (typeof window.Swiper !== 'function') return;

        const swiperEl = slider.querySelector('.swiper');
        if (!swiperEl) return;

        let config = {};
        try {
          config = JSON.parse(slider.getAttribute('slider-config') || '{}');
        } catch (error) {
          return;
        }

        const paginationEl = slider.querySelector('[swiper-pagination]');
        if (paginationEl && config.pagination) {
          config.pagination = {
            ...config.pagination,
            el: paginationEl,
          };
        }

        slider.swiper = new window.Swiper(swiperEl, config);
        slider.dataset.dtcBetterAirOwnedSwiper = 'true';
        this._ownedSwipers.push(slider.swiper);
      }

      _setupMobileDots() {
        const sliders = Array.from(this.querySelectorAll('.dtc-better-air-product-grid__panel.is-active .dtc-better-air-product-grid__slider'));
        sliders.forEach((slider) => this._bindSliderDots(slider));
      }

      _setupPanelDots(panel) {
        const slider = panel.querySelector('.dtc-better-air-product-grid__slider');
        if (slider) this._bindSliderDots(slider);
      }

      _bindSliderDots(slider, attempts = 0) {
        if (this._boundDotSliders.has(slider)) {
          this._syncSliderDots(slider);
          return;
        }

        this._ensureSlider(slider);

        if (!slider.swiper) {
          if (attempts >= 20) return;
          const timer = window.setTimeout(() => this._bindSliderDots(slider, attempts + 1), 100);
          this._sliderDotTimers.push(timer);
          return;
        }

        const onUpdate = () => this._syncSliderDots(slider);
        slider.swiper.on('slideChange', onUpdate);
        slider.swiper.on('paginationUpdate', onUpdate);
        slider.swiper.on('resize', onUpdate);
        this._sliderDotRecords.push({ swiper: slider.swiper, onUpdate });
        this._boundDotSliders.add(slider);
        onUpdate();
      }

      _syncMobileDots() {
        const sliders = Array.from(this.querySelectorAll('.dtc-better-air-product-grid__panel.is-active .dtc-better-air-product-grid__slider'));
        sliders.forEach((slider) => this._syncSliderDots(slider));
      }

      _syncSliderDots(slider) {
        const bullets = Array.from(slider.querySelectorAll('.dtc-better-air-product-grid__dots .swiper-pagination-bullet'));
        if (!bullets.length) return;

        if (!this._isMobileCarousel() || bullets.length <= 5) {
          bullets.forEach((bullet) => bullet.classList.remove('is-hidden'));
          return;
        }

        const activeIndex = bullets.findIndex((bullet) => bullet.classList.contains('swiper-pagination-bullet-active'));
        const currentIndex = activeIndex === -1 ? 0 : activeIndex;
        let start = Math.max(currentIndex - 2, 0);
        let end = start + 4;

        if (end >= bullets.length) {
          end = bullets.length - 1;
          start = Math.max(end - 4, 0);
        }

        bullets.forEach((bullet, index) => {
          bullet.classList.toggle('is-hidden', index < start || index > end);
        });
      }

      _isMobileCarousel() {
        return window.matchMedia('(max-width: 699px)').matches;
      }
    }
    customElements.define('dtc-better-air-product-grid', DtcBetterAirProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-blog-detail-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-blog-detail-article')) {
    class DtcBlogDetailArticle extends HTMLElement {
      connectedCallback() {
        this._buildTocFromHeadings();
        this._links = Array.from(this.querySelectorAll('.dtc-blog-detail-article__toc-link'));
        this._tocSelect = this.querySelector('[data-toc-select]');
        this._tocLine = this.querySelector('[data-toc-line]');
        if (!this._links.length && !this._tocSelect?.options.length) return;
        this._initTocScroll();
        this._initTocSelect();
        this._initTocHighlight();
        this._initTocIndicator();
        requestAnimationFrame(() => this._updateTocIndicator());
      }

      _scrollToTocTarget(id, activeLink) {
        const target = document.getElementById(id);
        if (!target) return;

        this._lockTocScrollSpy();
        this._setActiveTocLink(activeLink);

        if (this._tocSelect) {
          this._tocSelect.value = id;
        }

        history.replaceState(null, '', `#${id}`);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this._scheduleTocScrollSpyUnlock();
      }

      _lockTocScrollSpy() {
        this._tocScrollLock = true;
        clearTimeout(this._tocScrollUnlockTimer);
        if (this._tocScrollEndHandler) {
          window.removeEventListener('scrollend', this._tocScrollEndHandler);
          this._tocScrollEndHandler = null;
        }
      }

      _scheduleTocScrollSpyUnlock() {
        const unlock = () => {
          if (!this._tocScrollLock) return;
          this._tocScrollLock = false;
          this._tocScrollEndHandler = null;
          clearTimeout(this._tocScrollUnlockTimer);
          this._syncTocHighlightFromScroll();
        };

        if ('onscrollend' in window) {
          this._tocScrollEndHandler = unlock;
          window.addEventListener('scrollend', this._tocScrollEndHandler, { once: true });
        }

        this._tocScrollUnlockTimer = setTimeout(unlock, 900);
      }

      _syncTocHighlightFromScroll() {
        if (!this._tocVisibility?.size) return;

        const visible = this._tocTargets
          .filter((target) => this._tocVisibility.get(target.id))
          .map((target) => ({ id: target.id, top: target.getBoundingClientRect().top }))
          .sort((a, b) => a.top - b.top);

        if (!visible.length) return;

        const activeLink = this._links.find(
          (link) => (link.getAttribute('href') || '').replace('#', '') === visible[0].id
        );
        this._setActiveTocLink(activeLink || null);

        if (this._tocSelect) {
          this._tocSelect.value = visible[0].id;
        }
      }

      _setActiveTocLink(activeLink) {
        this.querySelectorAll('.dtc-blog-detail-article__toc-item').forEach((item) => {
          const itemLink = item.querySelector('.dtc-blog-detail-article__toc-link');
          item.classList.toggle('is-active', itemLink === activeLink);
        });
        this._updateTocIndicator();
      }

      _initTocIndicator() {
        if (!this._tocLine) return;

        const tocList = this.querySelector('[data-toc-list]');
        if (!tocList || !('ResizeObserver' in window)) return;

        this._tocResizeObserver = new ResizeObserver(() => this._updateTocIndicator());
        this._tocResizeObserver.observe(tocList);
      }

      _updateTocIndicator() {
        if (!this._tocLine) return;

        const activeItem = this.querySelector('.dtc-blog-detail-article__toc-item.is-active');
        const tocList = this.querySelector('[data-toc-list]');
        if (!activeItem || !tocList) return;

        const link = activeItem.querySelector('.dtc-blog-detail-article__toc-link');
        if (!link) return;

        const listRect = tocList.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        const indicatorHeight = 26;
        const offset = linkRect.top - listRect.top;
        const top = offset + (linkRect.height - indicatorHeight) / 2;

        this._tocLine.style.setProperty('--toc-indicator-top', `${Math.max(0, top)}px`);
        this._tocLine.style.setProperty('--toc-indicator-height', `${indicatorHeight}px`);
      }

      _initTocScroll() {
        this._links.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            const id = (link.getAttribute('href') || '').replace('#', '');
            this._scrollToTocTarget(id, link);
          });
        });
      }

      _initTocSelect() {
        if (!this._tocSelect) return;

        this._tocSelect.addEventListener('change', () => {
          const id = this._tocSelect.value;
          if (!id) return;

          const activeLink = this._links.find((link) => (link.getAttribute('href') || '').replace('#', '') === id);
          this._scrollToTocTarget(id, activeLink || null);
        });
      }

      _buildTocFromHeadings() {
        const tocRoot = this.querySelector('[data-toc-root]');
        const tocList = this.querySelector('[data-toc-list]');
        const tocSelect = this.querySelector('[data-toc-select]');
        if (!tocRoot || !tocList) return;

        const includeH3 = this.dataset.tocIncludeH3 === 'true';
        const headingSelector = includeH3
          ? '.dtc-blog-detail-article__text h2, .dtc-blog-detail-article__text h3'
          : '.dtc-blog-detail-article__text h2';

        const headings = Array.from(this.querySelectorAll(headingSelector)).filter((heading) =>
          heading.textContent.trim()
        );

        if (!headings.length) {
          tocRoot.hidden = true;
          return;
        }

        const usedIds = new Set();
        tocList.innerHTML = '';
        if (tocSelect) tocSelect.innerHTML = '';

        headings.forEach((heading, index) => {
          const id = this._ensureHeadingId(heading, usedIds);
          const label = heading.textContent.trim();
          const item = document.createElement('li');
          item.className = 'dtc-blog-detail-article__toc-item';
          if (index === 0) item.classList.add('is-active');
          if (heading.tagName === 'H3') item.classList.add('dtc-blog-detail-article__toc-item--h3');

          const link = document.createElement('a');
          link.href = `#${id}`;
          link.className = 'dtc-blog-detail-article__toc-link';
          link.textContent = label;

          item.appendChild(link);
          tocList.appendChild(item);

          if (tocSelect) {
            const option = document.createElement('option');
            option.value = id;
            option.textContent = label;
            if (index === 0) option.selected = true;
            tocSelect.appendChild(option);
          }
        });

        tocRoot.hidden = false;
      }

      _ensureHeadingId(heading, usedIds) {
        if (heading.id) {
          usedIds.add(heading.id);
          return heading.id;
        }

        let base = this._slugify(heading.textContent);
        if (!base) base = 'section';

        let id = base;
        let counter = 2;
        while (usedIds.has(id) || document.getElementById(id)) {
          id = `${base}-${counter++}`;
        }

        heading.id = id;
        usedIds.add(id);
        return id;
      }

      _slugify(text) {
        return text
          .toLowerCase()
          .trim()
          .replace(/[^\w\u00C0-\u024f\s-]/g, '')
          .replace(/[\s_-]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      _initTocHighlight() {
        this._tocTargets = this._links
          .map((link) => document.getElementById((link.getAttribute('href') || '').replace('#', '')))
          .filter(Boolean);

        if (!this._tocTargets.length || !('IntersectionObserver' in window)) return;

        this._tocVisibility = new Map();

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this._tocVisibility.set(entry.target.id, entry.isIntersecting);
            });

            if (this._tocScrollLock) return;

            this._syncTocHighlightFromScroll();
          },
          { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
        );

        this._tocTargets.forEach((target) => observer.observe(target));
      }
    }
    customElements.define('dtc-blog-detail-article', DtcBlogDetailArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-coffee-story-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-coffee-story-journey')) {
    class DtcCoffeeStoryJourney extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.dtc-coffee-story-journey__item'));
        if (!this.items.length) return;

        this.mediaItems = Array.from(
          this.querySelectorAll('.dtc-coffee-story-journey__media-item')
        );
        this.progress = this.querySelector('.dtc-coffee-story-journey__progress');
        this.fill = this.querySelector('.dtc-coffee-story-journey__progress-fill');

        this.activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
        if (this.activeIndex < 0) this.activeIndex = 0;

        this._dimSteps = [1, 0.8, 0.6, 0.5, 0.4, 0.3];

        this._handleClick = this._handleClick.bind(this);
        this.addEventListener('click', this._handleClick);

        this._scrollSwitchEnabled = this.dataset.scrollSwitch !== 'false';
        this._desktopQuery = window.matchMedia('(min-width: 1000px)');
        this._lastWheelTime = 0;
        this._lastSwitchTime = 0;

        if (this._scrollSwitchEnabled) {
          this._handleWheel = this._handleWheel.bind(this);
          this.addEventListener('wheel', this._handleWheel, { passive: false });
        }

        this._updateProgress = this._updateProgress.bind(this);
        this._syncVideos = this._syncVideos.bind(this);
        window.addEventListener('resize', this._updateProgress);

        if (typeof this._desktopQuery.addEventListener === 'function') {
          this._desktopQuery.addEventListener('change', this._syncVideos);
        }

        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(this._updateProgress);
          this._observer.observe(this);
        }

        if (window.Shopify && Shopify.designMode) {
          this._section = this.closest('.shopify-section');
          this._handleBlockSelect = this._handleBlockSelect.bind(this);
          if (this._section) this._section.addEventListener('shopify:block:select', this._handleBlockSelect);
        }

        this._render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
        if (this._handleWheel) this.removeEventListener('wheel', this._handleWheel);
        window.removeEventListener('resize', this._updateProgress);
        if (this._desktopQuery && this._syncVideos && typeof this._desktopQuery.removeEventListener === 'function') {
          this._desktopQuery.removeEventListener('change', this._syncVideos);
        }
        if (this._observer) this._observer.disconnect();
        if (this._section && this._handleBlockSelect) {
          this._section.removeEventListener('shopify:block:select', this._handleBlockSelect);
        }
      }

      _handleClick(event) {
        const trigger = event.target.closest('.dtc-coffee-story-journey__trigger');
        if (!trigger) return;
        const index = Number(trigger.dataset.milestoneIndex);
        if (!Number.isNaN(index)) this._activate(index);
      }

      _handleWheel(event) {
        if (!this._desktopQuery.matches) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        if (visibleHeight < Math.min(rect.height, viewportHeight) * 0.9) return;

        const nextIndex = this.activeIndex + (event.deltaY > 0 ? 1 : -1);
        if (nextIndex < 0 || nextIndex >= this.items.length) return;

        event.preventDefault();

        const now = Date.now();
        const isNewGesture = now - this._lastWheelTime > 150;
        this._lastWheelTime = now;
        if (now - this._lastSwitchTime < (isNewGesture ? 250 : 700)) return;

        this._lastSwitchTime = now;
        this._activate(nextIndex);
      }

      _handleBlockSelect(event) {
        const item = event.target.closest('.dtc-coffee-story-journey__item');
        if (item) this._activate(this.items.indexOf(item));
      }

      _activate(index) {
        if (index < 0 || index >= this.items.length) return;
        this.activeIndex = index;
        this._render();
      }

      _render() {
        this.items.forEach((item, i) => {
          const isActive = i === this.activeIndex;
          item.classList.toggle('is-active', isActive);

          const trigger = item.querySelector('.dtc-coffee-story-journey__trigger');
          if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

          const distance = Math.abs(i - this.activeIndex);
          item.style.opacity = isActive
            ? '1'
            : String(this._dimSteps[Math.min(distance, this._dimSteps.length - 1)]);
        });

        this.mediaItems.forEach((media) => {
          media.classList.toggle('is-active', Number(media.dataset.mediaIndex) === this.activeIndex);
        });

        this._syncVideos();
        this._updateProgress();
      }

      _syncVideos() {
        const isDesktop = this._desktopQuery && this._desktopQuery.matches;
        this.querySelectorAll('.dtc-coffee-story-journey__video-wrap').forEach((wrap) => {
          const video = wrap.querySelector('video');
          const desktopItem = wrap.closest('.dtc-coffee-story-journey__media-item');
          const listItem = wrap.closest('.dtc-coffee-story-journey__item');
          const isActive = desktopItem
            ? desktopItem.classList.contains('is-active')
            : Boolean(listItem && listItem.classList.contains('is-active'));
          const inVisibleSlot = isDesktop ? Boolean(desktopItem) : !desktopItem;

          if (isActive && inVisibleSlot) {
            this._playVideo(wrap, video);
            return;
          }
          this._resetVideo(wrap, video);
        });
      }

      _playVideo(wrap, video) {
        if (!wrap || !video) return;
        wrap.classList.add('is-playing');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        const playPromise = video.play();
        if (playPromise) playPromise.catch(function () {});
      }

      _resetVideo(wrap, video) {
        if (wrap) wrap.classList.remove('is-playing');
        if (!video) return;
        video.pause();
        video.controls = false;
        try {
          video.currentTime = 0;
        } catch (error) {}
      }

      _updateProgress() {
        if (!this.progress || !this.fill) return;
        const active = this.items[this.activeIndex];
        if (!active) return;
        const barRect = this.progress.getBoundingClientRect();
        const itemRect = active.getBoundingClientRect();
        this.fill.style.top = itemRect.top - barRect.top + 'px';
        this.fill.style.height = itemRect.height + 'px';
      }
    }

    customElements.define('dtc-coffee-story-journey', DtcCoffeeStoryJourney);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-coffee-tasting-notes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-coffee-tasting-notes')) {
    class DtcCoffeeTastingNotes extends HTMLElement {
      connectedCallback() {
        this.pills = Array.from(this.querySelectorAll('.dtc-coffee-tasting-notes__pill'));
        this.cards = Array.from(this.querySelectorAll('[data-cards] .dtc-coffee-tasting-notes__card'));
        this.emptyEl = this.querySelector('[data-empty]');
        this.limit = Number(this.dataset.limit || 4);
        this.activeLabel = this.querySelector('[data-active-label]');
        this.sliceGroup = this.querySelector('[data-slices]');
        this.labelGroup = this.querySelector('[data-labels]');

        this._onClick = this._onClick.bind(this);
        this.addEventListener('click', this._onClick);

        this._drawWheel();
        this._activate(this.dataset.defaultFlavor || (this.pills[0] && this.pills[0].dataset.flavor) || '', false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        window.clearTimeout(this._labelTimer);
      }

      _onClick(event) {
        const pill = event.target.closest('.dtc-coffee-tasting-notes__pill');
        if (!pill || !this.contains(pill)) return;
        this._activate(pill.dataset.flavor, true);
      }

      _setActiveLabel(text, animate) {
        const el = this.activeLabel;
        if (!el || el.textContent.trim() === text) return;

        if (!animate) {
          el.textContent = text;
          return;
        }

        el.classList.add('is-swapping');
        window.clearTimeout(this._labelTimer);
        this._labelTimer = window.setTimeout(() => {
          el.textContent = text;
          el.classList.remove('is-swapping');
        }, 160);
      }

      _activate(flavor, animate) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const withMotion = animate && !reduced;

        this.pills.forEach((pill) => {
          const isActive = pill.dataset.flavor === flavor;
          pill.classList.toggle('is-active', isActive);
          pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          if (isActive) this._setActiveLabel(pill.dataset.label || '', withMotion);
        });

        this.querySelectorAll('.dtc-coffee-tasting-notes__slice').forEach((slice) => {
          slice.classList.toggle('is-active', slice.dataset.flavor === flavor);
        });

        const tagged = this.cards.filter((card) => {
          const flavors = (card.dataset.flavors || '').split(',').filter(Boolean);
          return flavors.indexOf(flavor) !== -1;
        });
        const anyTagged = this.cards.some((card) => (card.dataset.flavors || '').length > 0);
        const matches = anyTagged ? tagged : this.cards;
        let shown = 0;

        this.cards.forEach((card) => {
          const isMatch = matches.indexOf(card) !== -1;
          const visible = isMatch && shown < this.limit;
          card.hidden = !visible;
          card.classList.remove('is-entering');

          if (!visible) return;

          if (withMotion) {
            card.style.animationDelay = shown * 40 + 'ms';
            void card.offsetWidth;
            card.classList.add('is-entering');
          } else {
            card.style.removeProperty('animation-delay');
          }

          shown += 1;
        });

        if (this.emptyEl) this.emptyEl.hidden = shown > 0 || this.cards.length === 0;
      }

      _polar(cx, cy, radius, angleDeg) {
        const radians = ((angleDeg - 90) * Math.PI) / 180;
        return {
          x: cx + radius * Math.cos(radians),
          y: cy + radius * Math.sin(radians)
        };
      }

      _donut(cx, cy, inner, outer, start, end) {
        const startOuter = this._polar(cx, cy, outer, start);
        const endOuter = this._polar(cx, cy, outer, end);
        const large = end - start > 180 ? 1 : 0;
        const head = ['M', startOuter.x, startOuter.y, 'A', outer, outer, 0, large, 1, endOuter.x, endOuter.y];

        if (inner <= 0) {
          return head.concat(['L', cx, cy, 'Z']).join(' ');
        }

        const startInner = this._polar(cx, cy, inner, start);
        const endInner = this._polar(cx, cy, inner, end);
        return head
          .concat(['L', endInner.x, endInner.y, 'A', inner, inner, 0, large, 0, startInner.x, startInner.y, 'Z'])
          .join(' ');
      }

      _arc(cx, cy, radius, start, end, clockwise) {
        const from = this._polar(cx, cy, radius, clockwise ? start : end);
        const to = this._polar(cx, cy, radius, clockwise ? end : start);
        const large = Math.abs(end - start) > 180 ? 1 : 0;
        return [
          'M', from.x, from.y,
          'A', radius, radius, 0, large, clockwise ? 1 : 0, to.x, to.y
        ].join(' ');
      }

      _drawWheel() {
        if (!this.sliceGroup || !this.pills.length) return;

        const flavors = this.pills.map((pill) => ({
          slug: pill.dataset.flavor,
          label: pill.dataset.label || ''
        }));

        const nuttyIndex = flavors.findIndex((item) => /nutty/i.test(item.label));
        const startIndex = nuttyIndex >= 0 ? nuttyIndex : 0;
        const ordered = flavors.map((_, index) => flavors[(startIndex + index) % flavors.length]);
        const sliceAngle = 360 / ordered.length;
        const cx = 274;
        const cy = 274;
        const inner = 0;
        const outer = 246.6;
        const labelRadius = 222;
        const ns = 'http://www.w3.org/2000/svg';

        this.sliceGroup.replaceChildren();
        if (this.labelGroup) this.labelGroup.replaceChildren();

        let defs = this.querySelector('[data-label-paths]');
        if (!defs && this.labelGroup) {
          defs = document.createElementNS(ns, 'defs');
          defs.setAttribute('data-label-paths', '');
          this.labelGroup.parentNode.insertBefore(defs, this.labelGroup);
        }
        if (defs) defs.replaceChildren();

        ordered.forEach((flavor, index) => {
          const start = index * sliceAngle;
          const end = (index + 1) * sliceAngle;
          const group = document.createElementNS(ns, 'g');
          group.setAttribute('class', 'dtc-coffee-tasting-notes__slice');
          group.dataset.flavor = flavor.slug;

          const path = document.createElementNS(ns, 'path');
          path.setAttribute('class', 'dtc-coffee-tasting-notes__slice-fill');
          path.setAttribute('d', this._donut(cx, cy, inner, outer, start, end));
          group.appendChild(path);
          this.sliceGroup.appendChild(group);

          if (!this.labelGroup || !defs) return;

          const mid = (start + end) / 2;
          const clockwise = mid <= 90 || mid >= 270;
          const pathId = 'dtc-tn-' + this.dataset.uid + '-' + index;

          const labelPath = document.createElementNS(ns, 'path');
          labelPath.setAttribute('id', pathId);
          labelPath.setAttribute('d', this._arc(cx, cy, labelRadius, start, end, clockwise));
          defs.appendChild(labelPath);

          const labelWrap = document.createElementNS(ns, 'g');
          labelWrap.setAttribute('class', 'dtc-coffee-tasting-notes__slice');
          labelWrap.dataset.flavor = flavor.slug;

          const text = document.createElementNS(ns, 'text');
          text.setAttribute('class', 'dtc-coffee-tasting-notes__slice-label');
          text.setAttribute('dominant-baseline', 'middle');

          const textPath = document.createElementNS(ns, 'textPath');
          textPath.setAttribute('href', '#' + pathId);
          textPath.setAttribute('startOffset', '50%');
          textPath.setAttribute('text-anchor', 'middle');
          textPath.textContent = flavor.label;

          text.appendChild(textPath);
          labelWrap.appendChild(text);
          this.labelGroup.appendChild(labelWrap);
        });

        ordered.forEach((_, index) => {
          const edge = this._polar(cx, cy, outer, index * sliceAngle);
          const divider = document.createElementNS(ns, 'line');
          divider.setAttribute('class', 'dtc-coffee-tasting-notes__wheel-divider');
          divider.setAttribute('x1', cx);
          divider.setAttribute('y1', cy);
          divider.setAttribute('x2', edge.x);
          divider.setAttribute('y2', edge.y);
          this.sliceGroup.appendChild(divider);
        });
      }
    }

    customElements.define('dtc-coffee-tasting-notes', DtcCoffeeTastingNotes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-collection-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-collection-category-carousel')) {
    class DtcCollectionCategoryCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');

        if (!this.track) return;

        this.onScroll = this.updateControls.bind(this);
        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.dtc-collection-category-carousel__card');
        if (!card) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateControls() {
        if (!this.prev || !this.next) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
        this.prev.disabled = this.track.scrollLeft <= 0;
        this.next.disabled = this.track.scrollLeft >= maxScroll;
      }
    }

    customElements.define('dtc-collection-category-carousel', DtcCollectionCategoryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-select')) {
    class DtcCollectionCustomSelect extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.selectedLabel = this.querySelector('.selected-label');
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleInputClick = this.handleInputClick.bind(this);
      }

      connectedCallback() {
        document.addEventListener('click', this.handleDocumentClick);
        this.querySelectorAll('input').forEach((input) => input.addEventListener('click', this.handleInputClick));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
        this.querySelectorAll('input').forEach((input) => input.removeEventListener('click', this.handleInputClick));
      }

      handleDocumentClick(event) {
        if (!this.details || this.details.contains(event.target)) return;
        this.details.removeAttribute('open');
      }

      handleInputClick(event) {
        const input = event.currentTarget;
        if (this.selectedLabel) this.selectedLabel.textContent = input.getAttribute('title') || input.value;
        if (this.details) this.details.removeAttribute('open');
      }
    }

    customElements.define('custom-select', DtcCollectionCustomSelect);
  }

  if (!customElements.get('dtc-collection-product-grid')) {
    class DtcCollectionProductGrid extends HTMLElement {
      connectedCallback() {
        this.ensureFacetFiltersForm();
        this.addEventListener('input', this.deferMobileDrawerSubmit, true);
        this.addEventListener('click', this.handleMobileDrawerClose, true);
        this.addEventListener('click', this.handleMobileDrawerApply);
        this.addEventListener('click', this.handlePaginationClick);
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.deferMobileDrawerSubmit, true);
        this.removeEventListener('click', this.handleMobileDrawerClose, true);
        this.removeEventListener('click', this.handleMobileDrawerApply);
        this.removeEventListener('click', this.handlePaginationClick);
        if (this.paginationAbortController) this.paginationAbortController.abort();
      }

      deferMobileDrawerSubmit(event) {
        if (!event.target.closest('#FacetFiltersFormMobile')) return;
        event.stopImmediatePropagation();
      }

      ensureFacetFiltersForm() {
        if (customElements.get('facet-filters-form')) {
          this.patchFacetFiltersForm();
          return;
        }

        DtcCollectionProductGrid.facetsScriptPromise =
          DtcCollectionProductGrid.facetsScriptPromise ||
          new Promise((resolve, reject) => {
            const existingScript = document.querySelector('script[src*="/facets.js"], script[src*="facets.js"]');

            if (existingScript) {
              customElements.whenDefined('facet-filters-form').then(resolve);
              existingScript.addEventListener('error', reject, { once: true });
              return;
            }

            const script = document.createElement('script');
            script.src = this.dataset.facetsScriptSrc;
            script.defer = true;
            script.onload = () => customElements.whenDefined('facet-filters-form').then(resolve);
            script.onerror = reject;
            document.head.appendChild(script);
          });

        DtcCollectionProductGrid.facetsScriptPromise.then(() => this.patchFacetFiltersForm()).catch(() => {});
      }

      patchFacetFiltersForm() {
        const FacetFiltersFormConstructor = customElements.get('facet-filters-form');
        if (!FacetFiltersFormConstructor || FacetFiltersFormConstructor.dtcCollectionPatchApplied) return;

        FacetFiltersFormConstructor.mergePersistentSearchParams = function(searchParams) {
          const currentParams = new URLSearchParams(window.location.search);
          const nextParams = new URLSearchParams(searchParams);
          const managedKeys = new Set();

          ['FacetFiltersForm', 'FacetFiltersFormMobile', 'FacetSortForm', 'FacetSortDrawerForm'].forEach((formId) => {
            const form = document.getElementById(formId);
            form &&
              form.querySelectorAll('[name]').forEach((field) => {
                if (field.name) managedKeys.add(field.name);
              });
          });

          managedKeys.forEach((key) => {
            currentParams.delete(key);
          });

          nextParams.forEach((value, key) => {
            currentParams.append(key, value);
          });

          return currentParams.toString();
        };

        FacetFiltersFormConstructor.renderFilters = function(html, event) {
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const facetDetailsElements = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
          );
          const eventFilter = event?.target?.closest?.('.js-filter');
          const matchesIndex = (element) => {
            if (!eventFilter) return false;
            return element.dataset.index === eventFilter.dataset.index || element.id === eventFilter.id;
          };
          const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
          const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

          facetsToRender.forEach((element) => {
            const selector = element.dataset.index ? `.js-filter[data-index="${element.dataset.index}"]` : `#${element.id}`;
            const currentElement = document.querySelector(selector);
            if (currentElement) currentElement.innerHTML = element.innerHTML;
          });

          FacetFiltersFormConstructor.renderActiveFacets(parsedHTML);
          FacetFiltersFormConstructor.renderAdditionalElements(parsedHTML);

          if (countsToRender && eventFilter) {
            FacetFiltersFormConstructor.renderCounts(countsToRender, eventFilter);
          }
        };

        FacetFiltersFormConstructor.renderAdditionalElements = function(html) {
          ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach((selector) => {
            const sourceElement = html.querySelector(selector);
            const targetElement = document.querySelector(selector);
            if (sourceElement && targetElement) targetElement.innerHTML = sourceElement.innerHTML;
          });

          const mobileForm = document.getElementById('FacetFiltersFormMobile');
          const drawer = mobileForm?.closest('menu-drawer, filter-drawer');
          drawer?.bindEvents?.();
        };

        const originalOnSubmitForm = FacetFiltersFormConstructor.prototype.onSubmitForm;
        FacetFiltersFormConstructor.prototype.onSubmitForm = function(searchParams, event) {
          originalOnSubmitForm.call(this, FacetFiltersFormConstructor.mergePersistentSearchParams(searchParams), event);
        };

        FacetFiltersFormConstructor.dtcCollectionPatchApplied = true;
      }

      handleMobileDrawerClose(event) {
        const closeButton = event.target.closest('#FilterDrawer-Aside .drawer__close');
        if (!closeButton) return;

        const details = closeButton.closest('filter-drawer')?.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details) return;

        event.preventDefault();
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
        Array.from(document.body.classList)
          .filter((className) => className.startsWith('overflow-hidden-'))
          .forEach((className) => document.body.classList.remove(className));
      }

      handleMobileDrawerApply(event) {
        const applyButton = event.target.closest('.filter-drawer__apply');
        if (!applyButton) return;

        const form = this.querySelector('#FacetFiltersFormMobile');
        const facetForm = form?.closest('facet-filters-form');
        if (!form || !facetForm?.onSubmitHandler) return;

        event.preventDefault();
        facetForm.onSubmitHandler({
          preventDefault() {},
          target: form,
          srcElement: applyButton,
        });

        const details = applyButton.closest('filter-drawer')?.querySelector('details');
        details?.removeAttribute('open');
        details?.classList.remove('menu-opening');
      }

      async handlePaginationClick(event) {
        const link = event.target.closest('.dtc-collection-product-grid__pagination a[href]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const targetUrl = new URL(link.href, window.location.origin);
        if (targetUrl.origin !== window.location.origin) return;

        event.preventDefault();
        await this.loadPage(targetUrl);
      }

      async loadPage(targetUrl) {
        const currentGrid = this.querySelector('#product-grid');
        const container = this.querySelector('#ProductGridContainer');
        if (!currentGrid || !container) {
          window.location.href = targetUrl.href;
          return;
        }

        const requestUrl = new URL(targetUrl.href);
        requestUrl.searchParams.set('section_id', currentGrid.dataset.id);

        if (this.paginationAbortController) this.paginationAbortController.abort();
        this.paginationAbortController = new AbortController();

        container.classList.add('is-loading');
        container.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(requestUrl.toString(), {
            signal: this.paginationAbortController.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error('Pagination request failed');

          const html = await response.text();
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const nextContainer = parsedHTML.getElementById('ProductGridContainer');
          if (!nextContainer) throw new Error('Product grid container missing');

          container.innerHTML = nextContainer.innerHTML;
          this.updateHistory(targetUrl);
          this.scrollToGridTop();
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.href = targetUrl.href;
        } finally {
          container.classList.remove('is-loading');
          container.removeAttribute('aria-busy');
        }
      }

      scrollToGridTop() {
        const toolbar = this.querySelector('.dtc-collection-product-grid__toolbar');
        const offset = toolbar ? toolbar.getBoundingClientRect().top + window.scrollY - 96 : this.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
      }

      updateHistory(targetUrl) {
        const searchParams = targetUrl.search.slice(1);
        const facetFiltersForm = window.FacetFiltersForm || (typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm : null);
        if (facetFiltersForm) facetFiltersForm.searchParamsPrev = searchParams;
        window.history.pushState({ searchParams }, '', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
      }
    }

    customElements.define('dtc-collection-product-grid', DtcCollectionProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-collection-scenario-insert"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-collection-scenario-insert')) {
    class DtcCollectionScenarioInsert extends HTMLElement {
      connectedCallback() {
        this.initCarousel();
      }

      disconnectedCallback() {
        this._scenarioCarouselAbort?.abort();
      }

      initCarousel() {
        const track = this.querySelector('[data-scenario-track]');
        if (!track) return;

        this._scenarioCarouselAbort?.abort();
        this._scenarioCarouselAbort = new AbortController();
        const { signal } = this._scenarioCarouselAbort;

        const prev = this.querySelector('[data-scenario-prev]');
        const next = this.querySelector('[data-scenario-next]');
        const dots = Array.from(this.querySelectorAll('[data-scenario-dot]'));
        const cards = Array.from(track.querySelectorAll('.dtc-collection-scenario-insert__card'));
        const getStep = () => {
          const card = track.querySelector('.dtc-collection-scenario-insert__card');
          if (!card) return 0;
          const gap = parseFloat(getComputedStyle(track).gap || getComputedStyle(track).columnGap || '0');
          return card.getBoundingClientRect().width + gap;
        };
        const setActiveDot = (index) => {
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };
        const getActiveIndex = () => {
          const step = getStep();
          if (!step) return 0;
          return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step)));
        };
        const scrollToIndex = (index) => {
          const step = getStep();
          if (!step) return;
          const nextIndex = Math.max(0, Math.min(cards.length - 1, index));
          track.scrollTo({ left: nextIndex * step, behavior: 'smooth' });
          setActiveDot(nextIndex);
        };

        prev?.addEventListener('click', () => scrollToIndex(getActiveIndex() - 1), { signal });
        next?.addEventListener('click', () => scrollToIndex(getActiveIndex() + 1), { signal });
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => scrollToIndex(index), { signal });
        });
        track.addEventListener('scroll', () => setActiveDot(getActiveIndex()), { passive: true, signal });
        setActiveDot(getActiveIndex());
      }
    }

    customElements.define('dtc-collection-scenario-insert', DtcCollectionScenarioInsert);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-common-explore-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-common-explore-hero')) {
    class DtcCommonExploreHero extends HTMLElement {}
    customElements.define('dtc-common-explore-hero', DtcCommonExploreHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-common-explore-scenario-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-common-explore-scenario-cards')) {
    class DtcCommonExploreScenarioCards extends HTMLElement {
      connectedCallback() {
        this._ownedSwipers = [];
        this._retryTimer = null;
        this._initSlider();
      }

      disconnectedCallback() {
        if (this._retryTimer) window.clearTimeout(this._retryTimer);
        this._ownedSwipers.forEach((swiper) => {
          if (swiper && !swiper.destroyed) swiper.destroy(true, true);
        });
      }

      _initSlider(attempts = 0) {
        const slider = this.querySelector('.dtc-common-explore-scenario-cards__slider');
        if (!slider || slider.swiper || slider.dataset.dtcScenarioCardsOwnedSwiper === 'true') return;

        if (typeof window.Swiper !== 'function') {
          if (attempts >= 20) return;
          this._retryTimer = window.setTimeout(() => this._initSlider(attempts + 1), 100);
          return;
        }

        const swiperEl = slider.querySelector('.swiper');
        if (!swiperEl) return;

        let config = {};
        try {
          config = JSON.parse(slider.getAttribute('slider-config') || '{}');
        } catch (error) {
          return;
        }

        const paginationEl = slider.querySelector('[swiper-pagination]');
        if (paginationEl && config.pagination) {
          config.pagination = {
            ...config.pagination,
            el: paginationEl,
          };
        }

        slider.swiper = new window.Swiper(swiperEl, config);
        slider.dataset.dtcScenarioCardsOwnedSwiper = 'true';
        this._ownedSwipers.push(slider.swiper);
      }
    }
    customElements.define('dtc-common-explore-scenario-cards', DtcCommonExploreScenarioCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-common-explore-solution-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-common-explore-solution-showcase')) {
    class DtcCommonExploreSolutionShowcase extends HTMLElement {
      connectedCallback() {
        this.videoCards = Array.from(this.querySelectorAll('.dtc-common-explore-solution-showcase__video-card'));
        this.videoCards.forEach((card) => {
          const video = card.querySelector('video');
          const playButton = card.querySelector('.dtc-common-explore-solution-showcase__video-play');
          const closeButton = card.querySelector('.dtc-common-explore-solution-showcase__video-close');

          if (!video || !playButton) return;

          playButton.addEventListener('click', () => {
            video.setAttribute('controls', 'controls');
            const playPromise = video.play();

            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          });

          video.addEventListener('play', () => {
            card.classList.add('is-playing');
          });

          if (closeButton) {
            closeButton.addEventListener('click', () => {
              video.pause();
              video.currentTime = 0;
              video.removeAttribute('controls');
              card.classList.remove('is-playing');
            });
          }
        });
      }
    }
    customElements.define('dtc-common-explore-solution-showcase', DtcCommonExploreSolutionShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-community-hero"] && !Shopify.designMode) return;
  try {
    
function dtcCommunityHeroCarousel() {
  var sections = document.querySelectorAll('.dtc-community-hero');
  sections.forEach(function(section) {
    var slider = section.querySelector('.dtc-community-hero__cards');
    var dotsWrap = section.querySelector('.dtc-community-hero__dots');
    if (!slider || !dotsWrap) return;

    var dots = Array.from(dotsWrap.querySelectorAll('.dtc-community-hero__dot'));
    var cards = Array.from(slider.querySelectorAll('.dtc-community-hero__card'));
    if (!dots.length || !cards.length) return;

    function getStep() {
      if (!cards[0]) return 208;
      var gap = parseFloat(getComputedStyle(slider).gap) || 8;
      return cards[0].offsetWidth + gap;
    }

    function updateDots() {
      var step = getStep();
      if (step === 0) return;
      var idx = Math.round(slider.scrollLeft / step);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    slider.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        slider.scrollTo({ left: i * getStep(), behavior: 'smooth' });
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dtcCommunityHeroCarousel);
} else {
  dtcCommunityHeroCarousel();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-community-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-community-product-grid')) {
    class DtcCommunityProductGrid extends HTMLElement {
      connectedCallback() {
        this._items = Array.from(this.querySelectorAll('.dtc-community-product-grid__item'));
        this._pagination = this.querySelector('[data-pagination]');
        this._pages = this.querySelector('[data-pagination-pages]');
        this._prev = this.querySelector('[data-pagination-prev]');
        this._next = this.querySelector('[data-pagination-next]');
        this._currentPage = 1;

        if (this._prev) this._prev.addEventListener('click', () => this._goToPage(this._currentPage - 1));
        if (this._next) this._next.addEventListener('click', () => this._goToPage(this._currentPage + 1));

        this._syncPagination();
      }

      _syncPagination() {
        if (!this._items.length) return;

        const pageSize = Number(this.dataset.pageSize) || this._items.length;
        const shouldPaginate = this.dataset.showPagination === 'true';
        const pageCount = shouldPaginate ? Math.max(Math.ceil(this._items.length / pageSize), 1) : 1;
        this._currentPage = Math.min(Math.max(this._currentPage, 1), pageCount);

        if (!shouldPaginate) {
          this._items.forEach((item) => {
            item.hidden = false;
          });
          if (this._pagination) this._pagination.hidden = true;
          return;
        }

        const start = (this._currentPage - 1) * pageSize;
        const end = start + pageSize;

        this._items.forEach((item, index) => {
          item.hidden = index < start || index >= end;
        });

        if (!this._pagination) return;
        this._pagination.hidden = pageCount <= 1;
        if (pageCount <= 1) return;

        if (this._prev) this._prev.disabled = this._currentPage === 1;
        if (this._next) this._next.disabled = this._currentPage === pageCount;
        this._renderPages(pageCount);
      }

      _renderPages(pageCount) {
        if (!this._pages) return;
        this._pages.innerHTML = '';

        this._getPageTokens(pageCount).forEach((token) => {
          if (token === 'gap') {
            const gap = document.createElement('span');
            gap.className = 'dtc-community-product-grid__pagination-gap';
            gap.textContent = '...';
            this._pages.appendChild(gap);
            return;
          }

          const button = document.createElement('button');
          button.type = 'button';
          button.className = `dtc-community-product-grid__pagination-page${token === this._currentPage ? ' is-active' : ''}`;
          button.textContent = token;
          button.setAttribute('aria-label', `Go to page ${token}`);
          if (token === this._currentPage) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => this._goToPage(token));
          this._pages.appendChild(button);
        });
      }

      _getPageTokens(pageCount) {
        if (pageCount <= 5) {
          return Array.from({ length: pageCount }, (_, index) => index + 1);
        }

        if (this._currentPage <= 3) return [1, 2, 3, 'gap', pageCount];
        if (this._currentPage >= pageCount - 2) return [1, 'gap', pageCount - 2, pageCount - 1, pageCount];
        return [1, 'gap', this._currentPage, 'gap', pageCount];
      }

      _goToPage(page) {
        const pageSize = Number(this.dataset.pageSize) || this._items.length;
        const pageCount = Math.max(Math.ceil(this._items.length / pageSize), 1);
        this._currentPage = Math.min(Math.max(page, 1), pageCount);
        this._syncPagination();
        this._scrollToTop();
      }

      _scrollToTop() {
        const target = this.querySelector('.dtc-community-product-grid__container');
        if (!target) return;

        const offset = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
      }
    }

    customElements.define('dtc-community-product-grid', DtcCommunityProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-community-recommendation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-community-recommendation')) {
    class DtcCommunityRecommendation extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-recommendation-track]');
        this._dots = Array.from(this.querySelectorAll('[data-recommendation-dot]'));
        this._cards = Array.from(this.querySelectorAll('.dtc-community-recommendation__item'));

        if (!this._track || !this._dots.length || !this._cards.length) return;

        this._onScroll = this._handleScroll.bind(this);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this._dots.forEach((dot) => {
          dot.addEventListener('click', () => this._goTo(Number(dot.dataset.recommendationDot) || 0));
        });
      }

      disconnectedCallback() {
        if (this._track && this._onScroll) {
          this._track.removeEventListener('scroll', this._onScroll);
        }
      }

      _handleScroll() {
        window.requestAnimationFrame(() => {
          const index = this._getActiveIndex();
          this._setActiveDot(index);
        });
      }

      _getActiveIndex() {
        const firstCard = this._cards[0];
        if (!firstCard) return 0;
        const styles = window.getComputedStyle(this._track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = firstCard.offsetWidth + gap;
        return Math.max(0, Math.min(this._cards.length - 1, Math.round(this._track.scrollLeft / step)));
      }

      _goTo(index) {
        const card = this._cards[index];
        if (!card) return;
        this._track.scrollTo({ left: card.offsetLeft - this._track.offsetLeft, behavior: 'smooth' });
        this._setActiveDot(index);
      }

      _setActiveDot(index) {
        this._dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('dtc-community-recommendation', DtcCommunityRecommendation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-contact-panel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-contact-panel')) {
    class DtcContactPanel extends HTMLElement {}
    customElements.define('dtc-contact-panel', DtcContactPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-faq"] && !Shopify.designMode) return;
  try {
    
  class DtcFaq extends HTMLElement {
    connectedCallback() {
      this._bindEvents();
      this._bindEditorEvents();
    }

    _bindEvents() {
      this.querySelectorAll('[data-faq-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const item = trigger.closest('[data-faq-item]');
          if (!item) return;
          this._toggleItem(item);
        });
      });
    }

    _toggleItem(targetItem) {
      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        const answer = item.querySelector('[data-faq-answer]');
        const trigger = item.querySelector('[data-faq-trigger]');
        if (!answer || !trigger) return;

        const shouldOpen = item === targetItem ? !item.classList.contains('is-open') : false;
        item.classList.toggle('is-open', shouldOpen);
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      });
    }

    _openItemByElement(element) {
      const item = element.closest('[data-faq-item]');
      if (!item) return;

      this.querySelectorAll('[data-faq-item]').forEach((entry) => {
        const answer = entry.querySelector('[data-faq-answer]');
        const trigger = entry.querySelector('[data-faq-trigger]');
        const shouldOpen = entry === item;
        entry.classList.toggle('is-open', shouldOpen);
        if (answer) answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
        if (trigger) trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });
    }

    _bindEditorEvents() {
      if (!(window.Shopify && Shopify.designMode)) return;
      const sectionElement = this.closest('.shopify-section');
      if (!sectionElement) return;

      sectionElement.addEventListener('shopify:block:select', (event) => {
        this._openItemByElement(event.target);
      });
    }
  }

  if (!customElements.get('dtc-faq')) {
    customElements.define('dtc-faq', DtcFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-favourites-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-favourites-grid')) {
    class DtcFavouritesGrid extends HTMLElement {
      connectedCallback() {
        this._listing = this.querySelector('.dtc-favourites-grid__listing');
        this._list = this.querySelector('.dtc-favourites-grid__list');
        this._filters = this.querySelector('[data-favourites-filters]');
        this._pagination = this.querySelector('[data-favourites-pagination]');
        this._mobileQuery = window.matchMedia('(max-width: 699px)');
        this._activeType = 'all';
        this._currentPage = 1;

        if (!this._list) return;

        this._renderFavorites();
        this._setupListingResizeObserver();
        this._observer = new MutationObserver(() => this._syncPagination());
        this._observer.observe(this._list, { childList: true });
        this._onListingScroll = this._handleListingScroll.bind(this);
        if (this._listing) this._listing.addEventListener('scroll', this._onListingScroll, { passive: true });
        this._onViewportChange = () => this._syncPagination({ scrollToPage: true });
        if (this._mobileQuery.addEventListener) {
          this._mobileQuery.addEventListener('change', this._onViewportChange);
        } else {
          this._mobileQuery.addListener(this._onViewportChange);
        }
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        if (this._listingResizeObserver) this._listingResizeObserver.disconnect();
        if (this._listing && this._onListingScroll) this._listing.removeEventListener('scroll', this._onListingScroll);
        if (this._mobileQuery && this._onViewportChange) {
          if (this._mobileQuery.removeEventListener) {
            this._mobileQuery.removeEventListener('change', this._onViewportChange);
          } else {
            this._mobileQuery.removeListener(this._onViewportChange);
          }
        }
      }

      async _renderFavorites() {
        const favorites = this._getFavorites();
        this._list.innerHTML = '';

        if (favorites.length === 0) {
          this._renderEmptyState();
          this._syncPagination();
          return;
        }

        const resolved = (await Promise.all(
          favorites.map((favorite, index) => this._resolveFavorite(favorite, index))
        )).filter(Boolean);

        const products = resolved.filter((entry) => entry.kind === 'product');
        const recipes = resolved.filter((entry) => entry.kind === 'recipe');
        const ordered = this._interleaveFavorites(products, recipes);

        ordered.forEach((entry, index) => {
          try {
            if (entry.kind === 'product') {
              this._list.insertAdjacentHTML('beforeend', this._renderProductCard(entry.product, entry.favorite, index + 1));
              return;
            }

            this._list.insertAdjacentHTML('beforeend', this._renderRecipeCard(entry.favorite, index + 1));
          } catch (error) {
            // A single malformed favorite shouldn't blank out the whole grid (and
            // silently skip the empty-state fallback below). Log it and keep going.
            console.error('[dtc-favourites-grid] Failed to render a favorite card:', error);
          }
        });

        if (this._list.children.length === 0) this._renderEmptyState();
        this._renderFilters();
        this._bindRemoveButtons();
        this._syncPagination();
      }

      _isRecipe(favorite) {
        if (!favorite) return false;
        if (favorite.type === 'Recipe') return true;
        return String(favorite.id || '').startsWith('article-');
      }

      async _resolveFavorite(favorite, index) {
        if (!favorite || !favorite.handle) return null;

        if (this._isRecipe(favorite)) {
          return { kind: 'recipe', favorite, index };
        }

        try {
          const response = await fetch(`/products/${favorite.handle}.js`);
          if (!response.ok) return null;
          const product = await response.json();
          return { kind: 'product', product, favorite, index };
        } catch (error) {
          return null;
        }
      }

      _interleaveFavorites(products, recipes) {
        const ordered = [];
        let productIndex = 0;
        let recipeIndex = 0;
        let showProduct = true;

        while (productIndex < products.length || recipeIndex < recipes.length) {
          if (showProduct && productIndex < products.length) {
            ordered.push(products[productIndex]);
            productIndex += 1;
            showProduct = false;
            continue;
          }

          if (!showProduct && recipeIndex < recipes.length) {
            ordered.push(recipes[recipeIndex]);
            recipeIndex += 1;
            showProduct = true;
            continue;
          }

          if (productIndex < products.length) {
            ordered.push(products[productIndex]);
            productIndex += 1;
            showProduct = false;
            continue;
          }

          if (recipeIndex < recipes.length) {
            ordered.push(recipes[recipeIndex]);
            recipeIndex += 1;
            showProduct = true;
          }
        }

        return ordered;
      }

      _getFavorites() {
        try {
          const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
          return Array.isArray(favorites) ? favorites : [];
        } catch (error) {
          return [];
        }
      }

      _renderEmptyState() {
        this._list.innerHTML = `
          <li class="dtc-favourites-grid__empty-card">
            <h2 class="dtc-favourites-grid__empty-heading">You haven't saved any favourites yet</h2>
            <p class="dtc-favourites-grid__empty-text">You can save products and recipes for later in case you want to come back to them.</p>
            <a class="dtc-favourites-grid__empty-button" href="/collections/shop">Shop now</a>
          </li>
        `;
      }

      _renderProductCard(product, favorite, index) {
        const selectedVariant = this._getSelectedVariant(product);
        const image = product.featured_image || favorite.featured_image || '';
        const imageAlt = product.featured_image && product.featured_image.alt ? product.featured_image.alt : product.title || favorite.title || '';
        const title = this._escapeHTML(product.title || favorite.title || '');
        const url = this._escapeAttribute(product.url || favorite.url || `/products/${product.handle}`);
        const productId = String(product.id || favorite.id || '');
        const variantId = String(selectedVariant.id || productId);
        const productType = product.type || favorite.type || '';
        const productTypeAttribute = this._escapeAttribute(productType);
        const favoriteId = this._escapeAttribute(String(favorite.id || product.id));
        const productJson = this._escapeAttribute(JSON.stringify(this._buildFavoritePayload(product, favorite, selectedVariant, image)));
        const priceMarkup = this._renderPrice(product, selectedVariant);
        const badgeMarkup = this._renderProductBadges(product, favorite);
        const imageMarkup = image
          ? `
            <img
              src="${this._escapeAttribute(this._imageUrl(image, 450))}"
              srcset="${this._escapeAttribute(this._imageUrl(image, 222))} 222w, ${this._escapeAttribute(this._imageUrl(image, 444))} 444w, ${this._escapeAttribute(this._imageUrl(image, 600))} 600w"
              sizes="(max-width: 699px) calc((100vw - 44px) * 0.7184), 222px"
              alt="${this._escapeAttribute(imageAlt)}"
              width="222"
              height="222"
              loading="lazy"
              class="dtc-product-card__image"
            >
          `
          : `<div class="dtc-product-card__placeholder" aria-hidden="true"></div>`;

        return `
          <li class="dtc-favourites-grid__item" data-favorite-id="${favoriteId}" data-product-type="${productTypeAttribute}">
            <div class="dtc-product-card">
              <a class="dtc-product-card__inner" href="${url}" data-v-gtm-event="select_item" data-v-gtm-module="Favourites" data-v-gtm-button_name="Card" data-v-gtm-item-id="${this._escapeAttribute(selectedVariant.sku || String(product.id || ''))}" data-v-gtm-item-name="${title}" data-v-gtm-item-category="${productTypeAttribute}" data-v-gtm-item-variant="${this._escapeAttribute(selectedVariant.title === 'Default Title' ? '' : (selectedVariant.title || ''))}" data-v-gtm-price="${this._escapeAttribute(String((selectedVariant.price || product.price || 0) / 100))}" data-v-gtm-quantity="1" data-v-gtm-discount="${this._escapeAttribute(String(this._getDiscount(selectedVariant)))}" data-v-gtm-index="${this._escapeAttribute(String(index))}" data-v-gtm-item-list-id="favourites-grid" data-v-gtm-item-list-name="Favourites">
                <img class="dtc-product-card__spacer" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='309' height='487'/%3E" width="309" height="487" alt="" aria-hidden="true" loading="eager">
                <div class="dtc-product-card__image-wrap">${imageMarkup}</div>
                <div class="dtc-product-card__header">
                  <div class="dtc-product-card__badges">${badgeMarkup}</div>
                  <div class="dtc-product-card__favorite">
                    <add-to-favorites
                      class="dtc-favorite-button"
                      product-json="${productJson}"
                      data-v-gtm-wishlist
                      data-product-sku="${this._escapeAttribute(selectedVariant.sku || '')}"
                      data-product-id="${this._escapeAttribute(productId)}"
                      data-product-title="${title}"
                      data-product-type="${productTypeAttribute}"
                      data-variant-title="${this._escapeAttribute(selectedVariant.title || '')}"
                      data-product-price="${this._escapeAttribute(String((selectedVariant.price || product.price || 0) / 100))}"
                      data-discount="${this._escapeAttribute(String(this._getDiscount(selectedVariant)))}"
                      data-list-name="Favourites"
                      data-list-id="favourites-grid"
                      data-index="${this._escapeAttribute(String(index))}"
                    >
                      <button
                        id="Favorites-Button-${this._escapeAttribute(variantId)}"
                        type="button"
                        class="dtc-favorite-button__btn is-active"
                        data-remove-favorite
                        aria-label="Remove ${title} from favourites"
                        onclick="event.stopPropagation(); event.preventDefault();"
                      >
                        ${this._renderHeartIcon('dtc-favorite-button__icon dtc-favorite-button__icon--outline')}
                        ${this._renderHeartFilledIcon('dtc-favorite-button__icon dtc-favorite-button__icon--filled')}
                      </button>
                    </add-to-favorites>
                  </div>
                </div>
                <div class="dtc-product-card__info">
                  <div class="dtc-product-card__rating">
                    <div data-bv-show="inline_rating" data-bv-product-id="${this._escapeAttribute(productId)}" data-bv-redirect-url="${url}" data-bv-seo="false"></div>
                  </div>
                  <h3 class="dtc-product-card__title">${title}</h3>
                  <div class="dtc-product-card__price">${priceMarkup}</div>
                </div>
              </a>
            </div>
          </li>
        `;
      }

      _formatCookingTime(value) {
        if (!value) return '';
        const raw = String(value).trim();
        if (!raw) return '';

        const minutes = parseInt(raw.toLowerCase().replace(/minutes?/g, '').trim(), 10);
        if (!Number.isNaN(minutes) && minutes > 0) return `${minutes} min`;

        return raw;
      }

      _renderRecipeCard(favorite, index) {
        const title = this._escapeHTML(favorite.title || '');
        const url = this._escapeAttribute(favorite.url || '#');
        const favoriteId = this._escapeAttribute(String(favorite.id || ''));
        const favoriteButtonId = this._escapeAttribute(String(favorite.id || ''));
        const productJson = this._escapeAttribute(JSON.stringify(favorite));
        const image = favorite.featured_image || '';
        const badgeLabel = this._escapeHTML(favorite.badge_label || '');
        const cookingTime = this._escapeHTML(this._formatCookingTime(favorite.cooking_time));
        const authorName = this._escapeHTML(favorite.author_name || '');
        const imageMarkup = image
          ? `
            <img
              src="${this._escapeAttribute(this._imageUrl(image, 600))}"
              alt="${this._escapeAttribute(title)}"
              width="600"
              height="400"
              loading="lazy"
              style="display:block;width:100%;height:100%;object-fit:cover;"
            >
          `
          : `<div class="dtc-recipe-card__placeholder" aria-hidden="true"></div>`;
        const badgeMarkup = badgeLabel
          ? `
            <div class="dtc-recipe-card__media-header">
              <span class="dtc-recipe-card__badge">${badgeLabel}</span>
            </div>
          `
          : '';
        const metaMarkup = cookingTime || authorName
          ? `
            <div class="dtc-recipe-card__meta">
              ${cookingTime ? `<span>Cooking time: ${cookingTime}</span>` : ''}
              ${authorName ? `<span class="dtc-recipe-card__author">${authorName}</span>` : ''}
            </div>
          `
          : '';

        return `
          <li class="dtc-favourites-grid__item dtc-favourites-grid__item--recipe" data-favorite-id="${favoriteId}" data-product-type="Recipe">
            <article class="dtc-recipe-card dtc-favourites-grid__recipe-card">
              <div class="dtc-recipe-card__header">
                <div class="dtc-recipe-card__favorite">
                  <add-to-favorites
                    class="dtc-favorite-button"
                    product-json="${productJson}"
                    data-v-gtm-wishlist
                    data-product-sku="${favoriteId}"
                    data-product-title="${title}"
                    data-product-type="Recipe"
                    data-product-price="0"
                    data-discount="0"
                    data-list-name="Favourites"
                    data-list-id="favourites-grid"
                    data-index="${this._escapeAttribute(String(index))}"
                  >
                    <button
                      id="Favorites-Button-${favoriteButtonId}"
                      type="button"
                      class="dtc-favorite-button__btn is-active"
                      data-remove-favorite
                      aria-label="Remove ${title} from favourites"
                      onclick="event.stopPropagation(); event.preventDefault();"
                    >
                      ${this._renderHeartIcon('dtc-favorite-button__icon dtc-favorite-button__icon--outline')}
                      ${this._renderHeartFilledIcon('dtc-favorite-button__icon dtc-favorite-button__icon--filled')}
                    </button>
                  </add-to-favorites>
                </div>
              </div>
              <a class="dtc-recipe-card__link" href="${url}" data-ga4-track data-ga4-event="select_item" data-ga4-module="favourites-grid" data-button-name="Card">
                <div class="dtc-recipe-card__media">
                  ${imageMarkup}
                  ${badgeMarkup}
                </div>
                <div class="dtc-recipe-card__body">
                  ${metaMarkup}
                  <h3 class="dtc-recipe-card__title">${title}</h3>
                </div>
              </a>
            </article>
          </li>
        `;
      }

      _getSelectedVariant(product) {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        return variants.find((variant) => variant.available) || variants[0] || {};
      }

      _renderPrice(product, selectedVariant) {
        const price = Number(product.price || selectedVariant.price || 0);
        const compareAtPrice = Number(product.compare_at_price || selectedVariant.compare_at_price || 0);
        const available = product.available !== false && selectedVariant.available !== false;
        const onSale = compareAtPrice > price;
        const classes = [
          'dtc-price',
          available ? '' : 'dtc-price--sold-out',
          onSale ? 'dtc-price--on-sale' : ''
        ].filter(Boolean).join(' ');

        return `
          <div class="${classes}">
            <span class="dtc-price__current" aria-label="Regular price: ${this._escapeAttribute(this._formatMoney(price))}">
              ${this._formatMoney(price)}
            </span>
            ${onSale ? `
              <s class="dtc-price__compare" aria-label="Sale price: ${this._escapeAttribute(this._formatMoney(compareAtPrice))}">
                ${this._formatMoney(compareAtPrice)}
              </s>
            ` : ''}
            ${available ? '' : '<span class="dtc-price__sold-out">Sold out</span>'}
          </div>
        `;
      }

      _renderProductBadges(product, favorite) {
        const badges = product.dtc_badges || product.badges || favorite.dtc_badges || favorite.badges || [];
        if (!Array.isArray(badges) || badges.length === 0) return '';

        const badgeItems = badges.slice(0, 2).map((badge) => {
          const text = badge.text || badge.label || '';
          if (!text) return '';

          const color = badge.text_color || badge.color || 'var(--dtc-color-text-inverse)';
          const background = badge.bg_color || badge.background_color || 'var(--dtc-color-accent)';
          const radius = badge.border_radius || '12';

          return `
            <span
              class="dtc-product-badge__item"
              style="color:${this._escapeAttribute(color)};background-color:${this._escapeAttribute(background)};border-radius:${this._escapeAttribute(radius)}px;"
            >
              ${this._escapeHTML(text)}
            </span>
          `;
        }).join('');

        return badgeItems ? `<div class="dtc-product-badge">${badgeItems}</div>` : '';
      }

      _buildFavoritePayload(product, favorite, selectedVariant, image) {
        return {
          id: String(product.id || favorite.id || ''),
          title: product.title || favorite.title || '',
          handle: product.handle || favorite.handle || '',
          type: product.type || favorite.type || '',
          url: product.url || favorite.url || `/products/${product.handle}`,
          price: this._formatMoney(product.price || selectedVariant.price || 0),
          featured_image: this._imageUrl(image, 350),
          shop_name: favorite.shop_name || '',
          variants: product.variants || favorite.variants || [],
          product_options: favorite.product_options || []
        };
      }

      _imageUrl(image, width) {
        if (!image) return '';
        const imageUrl = typeof image === 'string' ? image : image.src || image.url || '';
        if (!imageUrl) return '';
        const separator = imageUrl.includes('?') ? '&' : '?';
        return imageUrl.includes('width=') ? imageUrl : `${imageUrl}${separator}width=${width}`;
      }

      _getDiscount(selectedVariant) {
        const price = Number(selectedVariant.price || 0);
        const compareAtPrice = Number(selectedVariant.compare_at_price || 0);
        return compareAtPrice > price ? (compareAtPrice - price) / 100 : 0;
      }

      _renderHeartIcon(className) {
        return `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 15" fill="none" class="${className}">
            <path d="M12.6562 0C11.043 0 9.63047 0.69375 8.75 1.86641C7.86953 0.69375 6.45703 0 4.84375 0C3.55955 0.00144745 2.32837 0.512235 1.4203 1.4203C0.512235 2.32837 0.00144745 3.55955 0 4.84375C0 10.3125 8.10859 14.7391 8.45391 14.9219C8.54492 14.9708 8.64665 14.9965 8.75 14.9965C8.85335 14.9965 8.95508 14.9708 9.04609 14.9219C9.39141 14.7391 17.5 10.3125 17.5 4.84375C17.4986 3.55955 16.9878 2.32837 16.0797 1.4203C15.1716 0.512235 13.9404 0.00144745 12.6562 0ZM8.75 13.6562C7.32344 12.825 1.25 9.03828 1.25 4.84375C1.25124 3.89101 1.63026 2.97765 2.30396 2.30396C2.97765 1.63026 3.89101 1.25124 4.84375 1.25C6.36328 1.25 7.63906 2.05938 8.17188 3.35938C8.21896 3.47401 8.29907 3.57205 8.40201 3.64105C8.50494 3.71005 8.62607 3.7469 8.75 3.7469C8.87393 3.7469 8.99506 3.71005 9.09799 3.64105C9.20093 3.57205 9.28104 3.47401 9.32812 3.35938C9.86094 2.05703 11.1367 1.25 12.6562 1.25C13.609 1.25124 14.5224 1.63026 15.196 2.30396C15.8697 2.97765 16.2488 3.89101 16.25 4.84375C16.25 9.03203 10.175 12.8242 8.75 13.6562Z" fill="#121A25"/>
          </svg>
        `;
      }

      _renderHeartFilledIcon(className) {
        return `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 21" fill="none" class="${className}">
            <path d="M17.7188 0C15.4602 0 13.4827 0.97125 12.25 2.61297C11.0173 0.97125 9.03984 0 6.78125 0C4.98337 0.00202643 3.25971 0.717128 1.98842 1.98842C0.717128 3.25971 0.00202643 4.98337 0 6.78125C0 14.4375 11.352 20.6347 11.8355 20.8906C11.9629 20.9592 12.1053 20.9951 12.25 20.9951C12.3947 20.9951 12.5371 20.9592 12.6645 20.8906C13.148 20.6347 24.5 14.4375 24.5 6.78125C24.498 4.98337 23.7829 3.25971 22.5116 1.98842C21.2403 0.717128 19.5166 0.00202643 17.7188 0Z" fill="#801010"/>
          </svg>
        `;
      }

      _sortFilterTypes(types) {
        const recipeType = 'Recipe';
        const productTypes = types.filter((type) => type !== recipeType);
        return types.includes(recipeType) ? [...productTypes, recipeType] : productTypes;
      }

      _getFilterLabel(type) {
        return type === 'Recipe' ? 'Recipes' : type;
      }

      _renderFilters() {
        if (!this._filters) return;

        const types = Array.from(this._list.querySelectorAll('.dtc-favourites-grid__item'))
          .map((item) => item.dataset.productType)
          .filter(Boolean);
        const uniqueTypes = this._sortFilterTypes(Array.from(new Set(types)));

        if (uniqueTypes.length === 0) {
          this._filters.hidden = true;
          this._filters.innerHTML = '';
          return;
        }

        if (this._activeType !== 'all' && !uniqueTypes.includes(this._activeType)) {
          this._activeType = 'all';
        }

        this._filters.hidden = false;
        this._filters.innerHTML = [
          `<button class="dtc-favourites-grid__filter${this._activeType === 'all' ? ' is-active' : ''}" type="button" data-filter-type="all">View all</button>`,
          ...uniqueTypes.map((type) => `
            <button class="dtc-favourites-grid__filter${this._activeType === type ? ' is-active' : ''}" type="button" data-filter-type="${this._escapeAttribute(type)}">
              ${this._escapeHTML(this._getFilterLabel(type))}
            </button>
          `)
        ].join('');

        this._filters.querySelectorAll('[data-filter-type]').forEach((button) => {
          button.addEventListener('click', () => {
            this._activeType = button.dataset.filterType || 'all';
            this._currentPage = 1;
            this._filters.querySelectorAll('[data-filter-type]').forEach((item) => item.classList.remove('is-active'));
            button.classList.add('is-active');
            this._syncPagination({ scrollToPage: true });
          });
        });
      }

      _bindRemoveButtons() {
        this.querySelectorAll('[data-remove-favorite]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const item = button.closest('.dtc-favourites-grid__item');
            const favoriteId = item && item.dataset.favoriteId;
            if (!favoriteId) return;

            const favoritesHost = button.closest('add-to-favorites');
            if (favoritesHost && typeof favoritesHost.trackRemoveFromWishlist === 'function') {
              favoritesHost.trackRemoveFromWishlist();
            }

            const nextFavorites = this._getFavorites().filter((favorite) => String(favorite.id) !== favoriteId);
            localStorage.setItem('favorites', JSON.stringify(nextFavorites));
            item.remove();
            if (this._list.children.length === 0) this._renderEmptyState();
            this._renderFilters();
            this._syncPagination({ scrollToPage: true });
          });
        });
      }

      _formatMoney(value) {
        const amount = Number(value || 0) / 100;
        const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(2)}`;
        }
      }

      _escapeHTML(value) {
        return String(value).replace(/[&<>"']/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[character]);
      }

      _escapeAttribute(value) {
        return this._escapeHTML(value);
      }

      _getPaginationParts(currentPage, totalPages) {
        if (totalPages <= 6) {
          return Array.from({ length: totalPages }, (_, index) => ({
            type: 'page',
            page: index + 1
          }));
        }

        const delta = 2;
        const range = [];

        for (let page = 1; page <= totalPages; page += 1) {
          if (
            page === 1 ||
            page === totalPages ||
            (page >= currentPage - delta && page <= currentPage + delta)
          ) {
            range.push(page);
          }
        }

        const parts = [];
        let previous = null;

        for (const page of range) {
          if (previous !== null) {
            if (page - previous === 2) {
              parts.push({ type: 'page', page: previous + 1 });
            } else if (page - previous !== 1) {
              parts.push({ type: 'ellipsis' });
            }
          }

          parts.push({ type: 'page', page });
          previous = page;
        }

        return parts;
      }

      _syncPagination(options = {}) {
        const allItems = Array.from(this._list.children);
        const items = allItems.filter((item) => {
          if (item.classList.contains('dtc-favourites-grid__empty-card')) return true;
          return this._activeType === 'all' || item.dataset.productType === this._activeType;
        });

        allItems.forEach((item) => {
          item.removeAttribute('data-mobile-page-start');
          item.style.gridColumn = '';
          item.style.gridRow = '';
          if (!items.includes(item)) item.hidden = true;
        });

        if (items.length === 0 || (items.length === 1 && items[0].classList.contains('dtc-favourites-grid__empty-card'))) {
          if (this._pagination) this._pagination.hidden = true;
          return;
        }

        const isMobile = this._mobileQuery.matches;
        const pageSize = isMobile ? 6 : Number(this._listing.dataset.pageSize) || items.length;
        const pageCount = Math.max(Math.ceil(items.length / pageSize), 1);
        this._currentPage = Math.min(this._currentPage, pageCount);
        this._lastPaginationItems = items;
        this._lastPaginationPageSize = pageSize;
        this._syncMobileLayout(items, pageSize, pageCount, isMobile);

        const start = (this._currentPage - 1) * pageSize;
        const end = start + pageSize;

        items.forEach((item, index) => {
          item.hidden = isMobile ? false : index < start || index >= end;
          item.toggleAttribute('data-mobile-page-start', isMobile && index % pageSize === 0);
        });

        if (!this._pagination) return;
        this._pagination.hidden = pageCount <= 1;
        if (pageCount <= 1) return;

        const prev = this._pagination.querySelector('[data-pagination-prev]');
        const next = this._pagination.querySelector('[data-pagination-next]');
        const pages = this._pagination.querySelector('[data-pagination-pages]');

        prev.disabled = this._currentPage === 1;
        next.disabled = this._currentPage === pageCount;
        prev.onclick = () => {
          this._currentPage = Math.max(this._currentPage - 1, 1);
          this._syncPagination({ scrollToPage: true });
        };
        next.onclick = () => {
          this._currentPage = Math.min(this._currentPage + 1, pageCount);
          this._syncPagination({ scrollToPage: true });
        };

        const pageParts = isMobile
          ? Array.from({ length: pageCount }, (_, index) => ({ type: 'page', page: index + 1 }))
          : this._getPaginationParts(this._currentPage, pageCount);

        pages.innerHTML = '';
        for (const part of pageParts) {
          if (part.type === 'ellipsis') {
            const ellipsis = document.createElement('span');
            ellipsis.className = 'dtc-favourites-grid__pagination-ellipsis';
            ellipsis.setAttribute('aria-hidden', 'true');
            ellipsis.textContent = '...';
            pages.appendChild(ellipsis);
            continue;
          }

          const button = document.createElement('button');
          button.type = 'button';
          button.className = `dtc-favourites-grid__pagination-page${part.page === this._currentPage ? ' is-active' : ''}`;
          button.textContent = part.page;
          button.setAttribute('aria-label', `Go to page ${part.page}`);
          button.onclick = () => {
            this._currentPage = part.page;
            this._syncPagination({ scrollToPage: true });
          };
          pages.appendChild(button);
        }

        if (isMobile && options.scrollToPage) this._scrollToMobilePage(items, pageSize);

        if (isMobile) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this._updateMobileListingHeight(items, pageSize));
          });
        } else if (this._listing) {
          this._listing.style.height = '';
        }

        if (options.scrollToPage) this._scrollToContentTop();
      }

      _updateMobileListingHeight(items, pageSize) {
        if (!this._listing || !this._mobileQuery.matches) {
          if (this._listing) this._listing.style.height = '';
          return;
        }

        const pageItems = items
          .filter((item) => !item.classList.contains('dtc-favourites-grid__empty-card'))
          .slice((this._currentPage - 1) * pageSize, this._currentPage * pageSize);

        if (pageItems.length === 0) {
          this._listing.style.height = '';
          return;
        }

        const listingTop = this._listing.getBoundingClientRect().top;
        let maxBottom = listingTop;

        pageItems.forEach((item) => {
          const rect = item.getBoundingClientRect();
          if (rect.height > 0) maxBottom = Math.max(maxBottom, rect.bottom);
        });

        this._listing.style.height = `${Math.ceil(maxBottom - listingTop)}px`;
      }

      _setupListingResizeObserver() {
        if (this._listingResizeObserver || !this._list) return;

        this._listingResizeObserver = new ResizeObserver(() => {
          if (!this._mobileQuery.matches || !this._lastPaginationItems) return;
          this._updateMobileListingHeight(this._lastPaginationItems, this._lastPaginationPageSize || 6);
        });
        this._listingResizeObserver.observe(this._list);
      }

      _scrollToContentTop(behavior = 'smooth') {
        const target = this.querySelector('.dtc-favourites-grid__content');
        if (!target) return;

        const offset = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, offset), behavior });
      }

      _scrollToMobilePage(items, pageSize) {
        if (!this._listing) return;

        const target = items[(this._currentPage - 1) * pageSize];
        if (!target || target.classList.contains('dtc-favourites-grid__empty-card')) return;
        const pageGap = 12;
        const pageWidth = this._listing.clientWidth;

        this._listing.scrollTo({
          left: (this._currentPage - 1) * (pageWidth + pageGap),
          behavior: 'smooth'
        });
      }

      _syncMobileLayout(items, pageSize, pageCount, isMobile) {
        if (!this._listing || !this._list) return;

        if (!isMobile) {
          this._list.style.width = '';
          this._list.style.gridTemplateColumns = '';
          this._list.style.gridTemplateRows = '';
          if (this._listing) this._listing.style.height = '';
          return;
        }

        const pageGap = 12;
        const pageWidth = this._listing.clientWidth;
        const columnWidth = (pageWidth - pageGap) / 2;

        this._list.style.width = `${pageCount * pageWidth + (pageCount - 1) * pageGap}px`;
        this._list.style.gridTemplateColumns = `repeat(${pageCount * 2}, ${columnWidth}px)`;
        this._list.style.gridTemplateRows = 'repeat(3, auto)';

        items.forEach((item, index) => {
          const pageIndex = Math.floor(index / pageSize);
          const indexInPage = index % pageSize;
          const columnIndex = indexInPage % 2;
          const rowIndex = Math.floor(indexInPage / 2);

          item.style.gridColumn = String(pageIndex * 2 + columnIndex + 1);
          item.style.gridRow = String(rowIndex + 1);
        });
      }

      _handleListingScroll() {
        if (!this._mobileQuery.matches) return;

        window.clearTimeout(this._scrollTimer);
        this._scrollTimer = window.setTimeout(() => {
          const items = Array.from(this._list.querySelectorAll('.dtc-favourites-grid__item:not([hidden])'));
          const pageCount = Math.max(Math.ceil(items.length / 6), 1);
          const pageGap = 12;
          const pageWidth = this._listing.clientWidth;
          const nextPage = Math.min(Math.max(Math.round(this._listing.scrollLeft / (pageWidth + pageGap)) + 1, 1), pageCount);

          if (nextPage !== this._currentPage) {
            this._currentPage = nextPage;
            this._syncPagination();
          }
        }, 80);
      }
    }
    customElements.define('dtc-favourites-grid', DtcFavouritesGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-footer"] && !Shopify.designMode) return;
  try {
    
class DtcFooter extends HTMLElement {
  connectedCallback() {
    this._initAccordions();
    this._handleResize = this._handleResize.bind(this);
    window.addEventListener('resize', this._handleResize, { passive: true });
    if (window.Shopify && Shopify.designMode) {
      const section = this.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:section:select', () => this._openAll());
        section.addEventListener('shopify:section:deselect', () => this._closeAll());
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._handleResize);
  }

  _initAccordions() {
    const headings = this.querySelectorAll('.dtc-footer__nav-heading');
    headings.forEach((btn) => {
      btn.addEventListener('click', () => this._toggleColumn(btn));
    });
  }

  _toggleColumn(btn) {
    /* Mobile design shows all nav links — no accordion behaviour */
    return;
  }

  _handleResize() {
    /* No accordion state to manage */
  }

  _openAll() {
    const panels = this.querySelectorAll('.dtc-footer__nav-links');
    const btns = this.querySelectorAll('.dtc-footer__nav-heading');
    panels.forEach((p) => p.classList.add('is-open'));
    btns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }

  _closeAll() {
    const panels = this.querySelectorAll('.dtc-footer__nav-links');
    const btns = this.querySelectorAll('.dtc-footer__nav-heading');
    panels.forEach((p) => p.classList.remove('is-open'));
    btns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
}

if (!customElements.get('dtc-footer')) {
  customElements.define('dtc-footer', DtcFooter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-header-top-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-header-top-bar')) {
    class DtcHeaderTopBar extends HTMLElement {
      connectedCallback() {
        if (sessionStorage.getItem(this._storageKey()) === 'dismissed') {
          return;
        }
        const btn = this.querySelector('.dtc-header-top-bar__close');
        if (btn) btn.addEventListener('click', () => this._dismiss());
      }
      _storageKey() {
        const section = this.closest('.shopify-section');
        return 'dtc-topbar-dismissed-' + (section ? section.id : 'dtc-header-top-bar');
      }
      _dismiss() {
        sessionStorage.setItem(this._storageKey(), 'dismissed');
        const section = this.closest('.shopify-section');
        if (section) {
          section.style.transition = 'max-height 0.25s ease, opacity 0.25s ease';
          section.style.overflow = 'hidden';
          section.style.maxHeight = section.offsetHeight + 'px';
          requestAnimationFrame(() => {
            section.style.maxHeight = '0';
            section.style.opacity = '0';
          });
          section.addEventListener('transitionend', () => {
            section.remove();
            window.dispatchEvent(new CustomEvent('dtc:chrome-height-change'));
          }, { once: true });
        }
      }
    }
    customElements.define('dtc-header-top-bar', DtcHeaderTopBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-mobile-nav')) {
  const DTC_NAV_PANEL_MS = 400;
  const DTC_NAV_PANEL_CLOSE_MS = 380;
  const DTC_NAV_DROP_HEIGHT_MS = 320;
  const DTC_NAV_DROP_ITEM_MS = 240;
  const DTC_NAV_DROP_STAGGER_MS = 40;
  const DTC_NAV_MEGA_STAGGER_MS = 44;
  const DTC_NAV_MEGA_DURATION_MS = 300;
  const DTC_NAV_MEGA_OPEN_DELAY_MS = 85;

  class DtcMobileNav extends HTMLElement {
    connectedCallback() {
      this._toggle = this.querySelector('.dtc-mobile-nav__toggle');
      this._drop   = this.querySelector('.dtc-mobile-nav__drop');
      if (!this._toggle || !this._drop) return;

      /* Measure header height and expose as CSS variable for panel positioning */
      this._resizeHandler = () => this._measureHeader();
      this._measureHeader();
      window.addEventListener('resize', this._resizeHandler, { passive: true });

      this._toggle.addEventListener('click', () => this._isOpen ? this._close() : this._open());

      /* Close on outside click */
      this._outsideHandler = (e) => {
        if (this._isOpen && !this.contains(e.target)) this._close();
      };
      document.addEventListener('click', this._outsideHandler, { passive: true });

      /* Close on Escape */
      this._keyHandler = (e) => {
        if (e.key === 'Escape' && this._isOpen) this._close();
      };
      document.addEventListener('keydown', this._keyHandler);

      this._initAccordion();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._outsideHandler);
      document.removeEventListener('keydown', this._keyHandler);
      window.removeEventListener('resize', this._resizeHandler);
      this._summaryCleanups?.forEach((off) => off());
      this._summaryCleanups = [];
      if (this._isOpen) this._unlockScroll();
    }

    _initAccordion() {
      this._detailsList = this.querySelectorAll('.dtc-mobile-nav__sub-details');
      this._summaryCleanups = [];

      this._detailsList.forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;

        const handler = (e) => {
          if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (details.dataset.animating) return;

          if (details.open) {
            this._animateCloseDetails(details);
            return;
          }

          const openOthers = [...this._detailsList].filter((d) => d !== details && d.open);
          if (openOthers.length) {
            this._animateCloseDetails(openOthers[0]).then(() => {
              this._animateOpenDetails(details);
            });
          } else {
            this._animateOpenDetails(details);
          }
        };

        summary.addEventListener('click', handler);
        summary.addEventListener('keydown', handler);
        this._summaryCleanups.push(() => {
          summary.removeEventListener('click', handler);
          summary.removeEventListener('keydown', handler);
        });
      });
    }

    _maxMegaDelay(items) {
      let max = 0;
      items.forEach((el) => {
        const d = parseInt(el.dataset.megaDelay || '0', 10);
        if (d > max) max = d;
      });
      return max;
    }

    _animateMegaIn(items) {
      items.forEach((el) => {
        const d = parseInt(el.dataset.megaDelay || '0', 10);
        el.style.transitionDelay = (d * DTC_NAV_MEGA_STAGGER_MS) + 'ms';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => el.classList.add('dtc-mega-anim--in'));
        });
      });
    }

    _animateMegaOut(items) {
      return new Promise((resolve) => {
        if (!items.length) {
          resolve();
          return;
        }
        const maxD = this._maxMegaDelay(items);
        items.forEach((el) => {
          const d = parseInt(el.dataset.megaDelay || '0', 10);
          const reverseDelay = (maxD - d) * DTC_NAV_MEGA_STAGGER_MS;
          el.style.transitionDelay = reverseDelay + 'ms';
          requestAnimationFrame(() => el.classList.remove('dtc-mega-anim--in'));
        });
        const total = maxD * DTC_NAV_MEGA_STAGGER_MS + DTC_NAV_MEGA_DURATION_MS;
        window.setTimeout(resolve, total);
      });
    }

    _resetMegaAnim(items) {
      items.forEach((el) => {
        el.classList.remove('dtc-mega-anim--in');
        el.style.transitionDelay = '0ms';
      });
    }

    _animateOpenDetails(details) {
      if (details.dataset.animating) return Promise.resolve();
      details.dataset.animating = 'true';
      details.open = true;

      const items = [...details.querySelectorAll('.dtc-mega-anim')];

      return new Promise((resolve) => {
        const done = () => {
          delete details.dataset.animating;
          resolve();
        };

        if (items.length) {
          this._resetMegaAnim(items);
          window.setTimeout(() => {
            this._animateMegaIn(items);
            const maxD = this._maxMegaDelay(items);
            const wait =
              DTC_NAV_MEGA_OPEN_DELAY_MS +
              maxD * DTC_NAV_MEGA_STAGGER_MS +
              DTC_NAV_MEGA_DURATION_MS;
            window.setTimeout(done, wait);
          }, DTC_NAV_MEGA_OPEN_DELAY_MS);
        } else {
          window.setTimeout(done, DTC_NAV_PANEL_MS);
        }
      });
    }

    _animateCloseDetails(details) {
      if (details.dataset.animating) return Promise.resolve();
      if (!details.open) return Promise.resolve();

      details.dataset.animating = 'true';
      const items = [...details.querySelectorAll('.dtc-mega-anim')];

      return this._animateMegaOut(items).then(() => {
        details.open = false;
        this._resetMegaAnim(items);
        return new Promise((resolve) => {
          window.setTimeout(resolve, items.length ? DTC_NAV_PANEL_CLOSE_MS : DTC_NAV_PANEL_MS);
        });
      }).then(() => {
        delete details.dataset.animating;
      });
    }

    _forceCloseAllDetails() {
      this._detailsList?.forEach((details) => {
        delete details.dataset.animating;
        details.open = false;
      });
      this._resetMegaAnim(this.querySelectorAll('.dtc-mega-anim'));
    }

    _getHeaderAnchor() {
      const section = this.closest('.shopify-section');
      return section?.querySelector('.dtc-header') || section || this.closest('.dtc-header');
    }

    _measureHeader() {
      /* Use visible bottom edge so drawer sits below logo row (and below top bar when at page top) */
      const anchor = this._getHeaderAnchor();
      const bottom = anchor ? Math.ceil(anchor.getBoundingClientRect().bottom) : 60;
      const h = Math.max(bottom, 48);
      document.documentElement.style.setProperty('--dtc-mobile-header-h', h + 'px');
    }

    _lockScroll() {
      if (this._scrollLockY != null) return;
      this._scrollLockY = window.scrollY;
      document.documentElement.classList.add('dtc-mobile-nav-scroll-lock');
      document.body.classList.add('dtc-mobile-nav-scroll-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._scrollLockY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    _unlockScroll() {
      if (this._scrollLockY == null) return;
      const y = this._scrollLockY;
      this._scrollLockY = null;
      document.documentElement.classList.remove('dtc-mobile-nav-scroll-lock');
      document.body.classList.remove('dtc-mobile-nav-scroll-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, y);
    }

    _prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _wait(ms) {
      return new Promise((resolve) => window.setTimeout(resolve, ms));
    }

    _maxDropAnimDelay(items) {
      let max = 0;
      items.forEach((el) => {
        const d = parseInt(el.dataset.delay || '0', 10);
        if (d > max) max = d;
      });
      return max;
    }

    _open() {
      if (this._closing) return;
      this._isOpen = true;
      this.classList.remove('dtc-mobile-nav--closing');
      this._toggle.setAttribute('aria-expanded', 'true');
      this._drop.setAttribute('aria-hidden', 'false');
      this._measureHeader();
      this._lockScroll();
      this._measureHeader();

      requestAnimationFrame(() => {
        this.classList.add('dtc-mobile-nav--open');
        const items = this._drop.querySelectorAll('.dtc-drop-anim');
        items.forEach((el) => {
          el.classList.remove('dtc-drop-anim--in');
          el.style.transitionDelay = '0ms';
        });
        requestAnimationFrame(() => {
          items.forEach((el) => {
            const d = parseInt(el.dataset.delay || '0', 10);
            el.style.transitionDelay = (d * DTC_NAV_DROP_STAGGER_MS) + 'ms';
            el.classList.add('dtc-drop-anim--in');
          });
        });
      });
    }

    async _close() {
      if (!this._isOpen || this._closing) return;
      this._closing = true;

      const items = [...this._drop.querySelectorAll('.dtc-drop-anim')];
      const openDetails = [...(this._detailsList || [])].filter((d) => d.open);

      if (this._prefersReducedMotion()) {
        items.forEach((el) => {
          el.classList.remove('dtc-drop-anim--in');
          el.style.transitionDelay = '0ms';
        });
        this._isOpen = false;
        this.classList.remove('dtc-mobile-nav--open');
        this._toggle.setAttribute('aria-expanded', 'false');
        this._forceCloseAllDetails();
        this._finishClose(items);
        return;
      }

      if (openDetails.length) {
        await this._animateCloseDetails(openDetails[0]);
      }

      const maxD = this._maxDropAnimDelay(items);
      items.forEach((el) => {
        const d = parseInt(el.dataset.delay || '0', 10);
        el.style.transitionDelay = ((maxD - d) * DTC_NAV_DROP_STAGGER_MS) + 'ms';
        el.classList.remove('dtc-drop-anim--in');
      });

      await this._wait(DTC_NAV_DROP_ITEM_MS + maxD * DTC_NAV_DROP_STAGGER_MS);

      this.classList.add('dtc-mobile-nav--closing');
      this._isOpen = false;
      this.classList.remove('dtc-mobile-nav--open');
      this._toggle.setAttribute('aria-expanded', 'false');

      await this._wait(DTC_NAV_DROP_HEIGHT_MS);

      this._finishClose(items);
    }

    _finishClose(items) {
      this._drop.setAttribute('aria-hidden', 'true');
      this.classList.remove('dtc-mobile-nav--closing');
      this._unlockScroll();
      this._forceCloseAllDetails();
      items.forEach((el) => {
        el.style.transitionDelay = '0ms';
      });
      this._closing = false;
    }
  }
  customElements.define('dtc-mobile-nav', DtcMobileNav);
}

if (!customElements.get('dtc-header-search-drawer')) {
  class DtcHeaderSearchDrawer extends HTMLElement {
    connectedCallback() {
      this._details = this.querySelector('.dtc-header-search-drawer__details');
      this._overlay = this.querySelector('.dtc-header-search-drawer__overlay');
      this._closeBtn = this.querySelector('.dtc-header-search-drawer__close');
      if (!this._details) return;

      this._onOverlayClick = () => this._close();
      this._onCloseClick = () => this._close();
      this._onToggle = () => {
        if (this._details.open) {
          document.documentElement.classList.add('dtc-search-drawer-scroll-lock');
          document.body.classList.add('dtc-search-drawer-scroll-lock');
          const input = this.querySelector('.dtc-header-search__input');
          window.requestAnimationFrame(() => input?.focus());
        } else {
          document.documentElement.classList.remove('dtc-search-drawer-scroll-lock');
          document.body.classList.remove('dtc-search-drawer-scroll-lock');
        }
      };
      this._onKeydown = (e) => {
        if (e.key === 'Escape' && this._details.open) this._close();
      };

      this._overlay?.addEventListener('click', this._onOverlayClick);
      this._closeBtn?.addEventListener('click', this._onCloseClick);
      this._details.addEventListener('toggle', this._onToggle);
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this._overlay?.removeEventListener('click', this._onOverlayClick);
      this._closeBtn?.removeEventListener('click', this._onCloseClick);
      this._details?.removeEventListener('toggle', this._onToggle);
      document.removeEventListener('keydown', this._onKeydown);
      document.documentElement.classList.remove('dtc-search-drawer-scroll-lock');
      document.body.classList.remove('dtc-search-drawer-scroll-lock');
    }

    _close() {
      if (!this._details?.open) return;
      this._details.open = false;
    }
  }

  customElements.define('dtc-header-search-drawer', DtcHeaderSearchDrawer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-home-hero-slider')) {
    class DtcHomeHeroSlider extends HTMLElement {
      connectedCallback() {
        this.listeners = [];
        this._advanceTimer = null;
        this._videoEndedHandler = null;
        this._mobileQuery = window.matchMedia('(max-width: 699px)');
        this._desktopQuery = window.matchMedia('(min-width: 1000px)');
        this._syncDesktopVideoLoading();
        this._startVisibleSlideVideo();
        this.waitForSwiper();
        this._syncChromeHeight();
        this._observeChromeSources();
        requestAnimationFrame(() => this._syncChromeHeight());

        this.bind(window, 'resize', () => this._syncChromeHeight());
        this.bind(window, 'dtc:chrome-height-change', () => this._syncChromeHeight());
        this.bind(this._desktopQuery, 'change', () => {
          this._syncChromeHeight();
          this._observeChromeSources();
          this._syncDesktopVideoLoading();
        });
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._syncChromeHeight());
        }

        this.bind(document, 'visibilitychange', () => {
          if (document.hidden) this._pauseAdvance();
          else this._activateSlide();
        });
        this.bind(this._mobileQuery, 'change', () => {
          this._syncDesktopVideoLoading();
          this._activateSlide();
        });

        if (window.Shopify && Shopify.designMode) {
          this.bind(document, 'shopify:block:select', (event) => {
            if (!this.contains(event.target)) return;
            const slide = event.target.closest('.swiper-slide');
            if (!slide || !this.swiper) return;
            const index = Array.from(slide.parentElement.children).indexOf(slide);
            if (index >= 0) {
              this._clearAdvance();
              this.swiper.slideToLoop ? this.swiper.slideToLoop(index) : this.swiper.slideTo(index);
            }
          });
        }
      }

      disconnectedCallback() {
        this.listeners.forEach(({ element, type, handler }) => element.removeEventListener(type, handler));
        if (this._chromeObserver) {
          this._chromeObserver.disconnect();
          this._chromeObserver = null;
        }
        if (this.timer) clearInterval(this.timer);
        this._clearAdvance();
      }

      bind(element, type, handler) {
        element.addEventListener(type, handler);
        this.listeners.push({ element, type, handler });
      }

      _isAutoplayEnabled() {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        return this.dataset.autoplay === 'true' && Number(this.dataset.slideCount) > 1 && !prefersReducedMotion;
      }

      _getInterval() {
        const delay = Number(this.dataset.autoplayInterval);
        return Number.isFinite(delay) && delay >= 1000 ? delay : 5000;
      }

      _syncChromeHeight() {
        if (!this._desktopQuery || !this._desktopQuery.matches) return;

        const section = this.closest('.shopify-section');
        if (!section) return;

        const chrome = Math.max(0, Math.round(section.getBoundingClientRect().top));
        section.style.setProperty('--dtc-home-hero-slider-chrome-height', chrome + 'px');
      }

      _observeChromeSources() {
        if (!this._desktopQuery || !this._desktopQuery.matches) return;

        const section = this.closest('.shopify-section');
        if (!section) return;

        if (!this._chromeObserver) {
          this._chromeObserver = new ResizeObserver(() => this._syncChromeHeight());
        } else {
          this._chromeObserver.disconnect();
        }

        const headerGroup =
          document.getElementById('shopify-section-group-dtc-header-group') ||
          document.querySelector('[id^="shopify-section-group-"][id*="header"]');

        if (headerGroup) {
          headerGroup.querySelectorAll('.shopify-section').forEach((el) => {
            this._chromeObserver.observe(el);
          });
        }

        let sibling = section.previousElementSibling;
        while (sibling) {
          if (sibling.classList.contains('shopify-section')) {
            this._chromeObserver.observe(sibling);
          }
          sibling = sibling.previousElementSibling;
        }
      }

      _getActiveIndex() {
        if (!this.swiper) return 0;
        return this.swiper.realIndex != null ? this.swiper.realIndex : this.swiper.activeIndex;
      }

      _getActiveSlide() {
        if (!this.swiper || !this.swiper.slides) return null;
        return this.swiper.slides[this.swiper.activeIndex] || null;
      }

      _getAllVideos() {
        return Array.from(this.querySelectorAll('video.dtc-home-hero-slider__video'));
      }

      _getSlideVideo(slide) {
        if (!slide) return null;

        const isMobile = this._mobileQuery.matches;
        const mobileLayer = slide.querySelector('.dtc-home-hero-slider__media-layer--mobile');
        const desktopLayer = slide.querySelector('.dtc-home-hero-slider__media-layer--desktop');

        if (isMobile && slide.classList.contains('dtc-home-hero-slider__slide--has-mobile-media') && mobileLayer) {
          const mobileVideo = mobileLayer.querySelector('video.dtc-home-hero-slider__video');
          if (mobileVideo) return mobileVideo;
        }

        return desktopLayer ? desktopLayer.querySelector('video.dtc-home-hero-slider__video') : null;
      }

      _getSlideByRealIndex(realIndex) {
        if (!this.swiper || !this.swiper.slides) return null;

        const slide = this.swiper.slides.find((candidate) => {
          const index = candidate.getAttribute('data-swiper-slide-index');
          return index !== null && Number(index) === realIndex;
        });

        return slide || this.swiper.slides[realIndex] || null;
      }

      _deferDesktopVideo(video) {
        if (!video || video.dataset.deferredDesktop === 'true') return;

        const sources = Array.from(video.querySelectorAll('source')).map((source) => ({
          src: source.src,
          type: source.type,
        }));

        if (sources.length) {
          video.dataset.deferredSources = JSON.stringify(sources);
          video.querySelectorAll('source').forEach((source) => source.remove());
        }

        video.removeAttribute('src');
        video.preload = 'none';
        video.pause();
        video.dataset.deferredDesktop = 'true';
      }

      _restoreDesktopVideo(video) {
        if (!video || video.dataset.deferredDesktop !== 'true') return;

        const storedSources = video.dataset.deferredSources;
        if (storedSources) {
          JSON.parse(storedSources).forEach((source) => {
            const sourceEl = document.createElement('source');
            sourceEl.src = source.src;
            if (source.type) sourceEl.type = source.type;
            video.appendChild(sourceEl);
          });
          delete video.dataset.deferredSources;
        }

        delete video.dataset.deferredDesktop;
        video.preload = 'metadata';
        video.load();
      }

      _syncDesktopVideoLoading() {
        const shouldDeferDesktop = this._mobileQuery.matches;

        this.querySelectorAll('.dtc-home-hero-slider__slide--has-mobile-media .dtc-home-hero-slider__media-layer--desktop video').forEach((video) => {
          if (shouldDeferDesktop) {
            this._deferDesktopVideo(video);
          } else {
            this._restoreDesktopVideo(video);
          }
        });
      }

      _ensureVideoAutoplayAttrs(video) {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
      }

      _bindPlayUnlock() {
        if (this._playUnlockHandler) return;

        this._playUnlockHandler = () => {
          this._playUnlockHandler = null;
          this._activateSlide();
        };

        document.addEventListener('touchstart', this._playUnlockHandler, { once: true, passive: true });
        document.addEventListener('click', this._playUnlockHandler, { once: true });
      }

      _startVisibleSlideVideo() {
        const slide = this.querySelector('.dtc-home-hero-slider__slide, .swiper-slide');
        const video = this._getSlideVideo(slide);
        if (video) this._playVideo(video);
      }

      _pauseInactiveVideos({ reset = true } = {}) {
        const activeSlide = this._getActiveSlide();

        this._getAllVideos().forEach((video) => {
          const slide = video.closest('.swiper-slide');
          if (slide === activeSlide) return;

          video.pause();
          this._setMobileCoverState(video, false);
          if (reset) {
            try {
              video.currentTime = 0;
            } catch (error) {
              /* ignore seek errors on detached sources */
            }
          }
        });
      }

      _preloadAdjacentSlides() {
        const slideCount = Number(this.dataset.slideCount);
        if (!this.swiper || slideCount <= 1) return;

        const currentIndex = this._getActiveIndex();
        const adjacentIndexes = [currentIndex - 1, currentIndex + 1];

        adjacentIndexes.forEach((index) => {
          const normalizedIndex = ((index % slideCount) + slideCount) % slideCount;
          const slide = this._getSlideByRealIndex(normalizedIndex);
          const video = this._getSlideVideo(slide);
          if (!video) return;

          if (video.preload === 'none') {
            video.preload = 'metadata';
          }

          if (video.readyState < HTMLMediaElement.HAVE_METADATA) {
            video.load();
          }
        });
      }

      _prepareVideo(video) {
        const slowConnection =
          navigator.connection &&
          (navigator.connection.saveData ||
            ['slow-2g', '2g'].includes(navigator.connection.effectiveType));

        if (video.preload === 'none') {
          video.preload = slowConnection ? 'metadata' : 'auto';
        } else if (video.preload === 'metadata' && !slowConnection) {
          video.preload = 'auto';
        }

        if (video.readyState < HTMLMediaElement.HAVE_METADATA) {
          video.load();
        }
      }

      _setMobileCoverState(video, isPlaying) {
        if (!video) return;

        const mobileLayer = video.closest('.dtc-home-hero-slider__media-layer--mobile');
        if (!mobileLayer || !mobileLayer.querySelector('.dtc-home-hero-slider__cover')) return;

        mobileLayer.classList.toggle('is-video-playing', isPlaying);
      }

      async _playVideo(video) {
        if (!video) return;

        this._ensureVideoAutoplayAttrs(video);
        this._prepareVideo(video);

        const playFromStart = async () => {
          try {
            video.currentTime = 0;
          } catch (error) {
            /* ignore seek errors */
          }

          try {
            await Promise.resolve(video.play());
            this._setMobileCoverState(video, true);
            return true;
          } catch (error) {
            this._setMobileCoverState(video, false);
            return false;
          }
        };

        const attemptPlay = async () => {
          if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
            const played = await playFromStart();
            if (!played) this._bindPlayUnlock();
            return;
          }

          await new Promise((resolve) => {
            const onReady = () => {
              video.removeEventListener('loadeddata', onReady);
              video.removeEventListener('canplay', onReady);
              resolve();
            };

            video.addEventListener('loadeddata', onReady, { once: true });
            video.addEventListener('canplay', onReady, { once: true });
          });

          const played = await playFromStart();
          if (!played) this._bindPlayUnlock();
        };

        await attemptPlay();
      }

      _clearAdvance() {
        if (this._advanceTimer) {
          clearTimeout(this._advanceTimer);
          this._advanceTimer = null;
        }

        if (this._videoEndedHandler) {
          this._videoEndedHandler.onEnded();
          this._videoEndedHandler = null;
        }
      }

      _pauseAdvance() {
        this._clearAdvance();
        const video = this._getSlideVideo(this._getActiveSlide());
        if (video) video.pause();
      }

      _advanceToNext() {
        if (!this.swiper || Number(this.dataset.slideCount) <= 1) return;
        this.swiper.slideNext();
      }

      _activateSlide() {
        this._clearAdvance();

        if (document.hidden) return;

        const slide = this._getActiveSlide();
        if (!slide) return;

        this._preloadAdjacentSlides();

        const video = this._getSlideVideo(slide);

        if (video) {
          if (this._isAutoplayEnabled()) {
            let advanced = false;

            const advance = () => {
              if (advanced) return;
              advanced = true;
              this._clearAdvance();
              this._advanceToNext();
            };

            const onEnded = () => advance();
            const onTimeUpdate = () => {
              if (video.duration && video.currentTime >= video.duration - 0.3) advance();
            };

            const cleanup = () => {
              video.removeEventListener('ended', onEnded);
              video.removeEventListener('timeupdate', onTimeUpdate);
            };

            this._videoEndedHandler = { video, onEnded: cleanup };
            video.addEventListener('ended', onEnded);
            video.addEventListener('timeupdate', onTimeUpdate);
          }

          this._playVideo(video).then(() => {
            if (this._isAutoplayEnabled() && video.paused) {
              this._advanceTimer = window.setTimeout(() => this._advanceToNext(), this._getInterval());
            }
          });
          return;
        }

        if (this._isAutoplayEnabled()) {
          this._advanceTimer = window.setTimeout(() => this._advanceToNext(), this._getInterval());
        }
      }

      waitForSwiper() {
        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl) return;

        if (swiperEl.swiper) {
          this.setup(swiperEl.swiper);
          return;
        }

        let attempts = 0;
        this.timer = setInterval(() => {
          attempts += 1;
          if (swiperEl.swiper) {
            clearInterval(this.timer);
            this.setup(swiperEl.swiper);
          } else if (attempts > 50) {
            clearInterval(this.timer);
          }
        }, 100);
      }

      setup(swiper) {
        if (this.isReady) return;
        this.isReady = true;
        this.swiper = swiper;

        if (swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop();

        const onSlideActivate = () => {
          window.requestAnimationFrame(() => this._activateSlide());
        };

        const onSlideSettle = () => {
          this._pauseInactiveVideos({ reset: true });
        };

        // carousel_navigation tracking — dot click only
        const module = this.dataset.gtmModule || 'Hero Slider';
        const dotsEl = this.querySelector('.dtc-home-hero-slider__dots');
        if (dotsEl) {
          // Capture phase: Swiper pagination click runs on bubble after slideChange;
          // record dot index before Swiper's handler so slideChange sees the clicked dot.
          dotsEl.addEventListener(
            'click',
            (e) => {
              const bullet = e.target.closest('.swiper-pagination-bullet');
              if (!bullet) return;
              const bullets = dotsEl.querySelectorAll('.swiper-pagination-bullet');
              const clickedIndex = Array.prototype.indexOf.call(bullets, bullet);
              if (clickedIndex < 0) return;
              if (swiper.realIndex === clickedIndex) return;

              this._navSource = 'dot';
              this._navDotIndex = clickedIndex + 1;
            },
            true
          );
        }

        swiper.on('slideChange', () => {
          if (this._navSource !== 'dot' || this._navDotIndex == null) return;

          const dotIndex = this._navDotIndex;
          this._navSource = null;
          this._navDotIndex = null;

          const buttonName = 'dot_' + dotIndex;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'carousel_navigation',
            event_parameters: { module: module, button_name: buttonName },
          });
        });

        swiper.on('slideChange', onSlideActivate);
        swiper.on('slideChangeTransitionEnd', onSlideSettle);
        onSlideActivate();
      }
    }

    customElements.define('dtc-home-hero-slider', DtcHomeHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home-hero"] && !Shopify.designMode) return;
  try {
    
  class DtcHomeHero extends HTMLElement {}

  if (!customElements.get('dtc-home-hero')) {
    customElements.define('dtc-home-hero', DtcHomeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-learn-topic-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-learn-topic-tabs')) {
    class DtcLearnTopicTabs extends HTMLElement {
      connectedCallback() {
        if (window.Shopify && Shopify.designMode) {
          const section = this.closest('.shopify-section');
          section.addEventListener('shopify:section:select', () => this.scrollIntoView());
        }
      }
    }
    customElements.define('dtc-learn-topic-tabs', DtcLearnTopicTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-multicolumn"] && !Shopify.designMode) return;
  try {
    
/**
 * dtc-multicolumn — grid/slider mode helpers + overlay video cards.
 */
if (!customElements.get('dtc-multicolumn')) {
  class DtcMulticolumn extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      const mode = this.dataset.sliderMode;
      const showNav = this.dataset.showNavigation === 'true';
      const extendRight = this.dataset.extendRight === 'true';
      const sectionId = this.id.replace('dtc-multicolumn-', '');

      if (extendRight && sectionId) {
        this._offsetProp = '--dtc-mc-left-offset-' + sectionId;
        this._updateLeftOffset = () => {
          const rect = this.getBoundingClientRect();
          document.documentElement.style.setProperty(
            this._offsetProp,
            rect.left + window.scrollX + 'px'
          );
        };
        this._updateLeftOffset();
        window.addEventListener('resize', this._updateLeftOffset, { passive: true });
      }

      if (mode === 'mobile_only' || mode === 'pc_only') {
        const grid = this.querySelector('[id^="dtc-multicolumn-grid-"]');
        if (grid) {
          this._grid = grid;
          this._sliderMode = mode;
          this._lastViewportWidth = window.innerWidth;
          this._shouldStripInlineStyles = () => {
            if (mode === 'mobile_only') return window.innerWidth >= 1000;
            if (mode === 'pc_only') return window.innerWidth < 1000;
            return false;
          };
          this._stripInlineStyles = () => {
            if (!this._shouldStripInlineStyles()) return;
            grid.querySelectorAll('.swiper-slide').forEach((slide) => {
              slide.style.removeProperty('width');
              slide.style.removeProperty('margin-right');
            });
          };
          this._restoreSwiperSpacing = () => {
            const swiper = this.querySelector('.swiper')?.swiper;
            if (!swiper) return;
            const width = window.innerWidth;
            if (mode === 'mobile_only' && width < 1000) {
              if (!swiper.enabled) swiper.enable();
              swiper.update();
            } else if (mode === 'pc_only' && width >= 1000) {
              if (!swiper.enabled) swiper.enable();
              swiper.update();
            }
          };
          this._stripInlineStyles();
          this._styleObserver = new MutationObserver(() => {
            if (!this._shouldStripInlineStyles()) return;
            this._stripInlineStyles();
          });
          this._styleObserver.observe(grid, {
            attributes: true,
            subtree: true,
            attributeFilter: ['style'],
          });
          this._onResizeStrip = () => {
            const width = window.innerWidth;
            const wasDesktop = this._lastViewportWidth >= 1000;
            const isDesktop = width >= 1000;
            this._lastViewportWidth = width;

            if (this._shouldStripInlineStyles()) {
              this._stripInlineStyles();
              return;
            }

            if (mode === 'mobile_only' && wasDesktop && !isDesktop) {
              this._restoreSwiperSpacing();
            } else if (mode === 'pc_only' && !wasDesktop && isDesktop) {
              this._restoreSwiperSpacing();
            } else if (this.dataset.productSliderAuto === 'true') {
              const swiper = this.querySelector('.swiper')?.swiper;
              if (swiper?.params?.enabled) {
                requestAnimationFrame(() => swiper.update());
              }
            }
          };
          window.addEventListener('resize', this._onResizeStrip, { passive: true });
        }
      }

      this._waitForSwiper(showNav);
    }

    disconnectedCallback() {
      if (this._updateLeftOffset) {
        window.removeEventListener('resize', this._updateLeftOffset);
      }
      if (this._onResizeStrip) {
        window.removeEventListener('resize', this._onResizeStrip);
      }
      if (this._styleObserver) this._styleObserver.disconnect();
      if (this._swiperTimer) clearInterval(this._swiperTimer);
      this._initialized = false;
    }

    _bindNavSync(swiper) {
      const btnPrev = this.querySelector('.dtc-multicolumn__nav-btn--prev');
      const btnNext = this.querySelector('.dtc-multicolumn__nav-btn--next');
      if (!btnPrev && !btnNext) return;

      const syncDisabled = () => {
        if (btnPrev) btnPrev.disabled = swiper.isBeginning && !swiper.params.loop;
        if (btnNext) btnNext.disabled = swiper.isEnd && !swiper.params.loop;
      };

      swiper.on('slideChange', syncDisabled);
      swiper.on('reachBeginning', syncDisabled);
      swiper.on('reachEnd', syncDisabled);
      syncDisabled();
    }

    _waitForSwiper(showNav) {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      const setup = () => {
        const swiper = swiperEl.swiper;
        if (!swiper) return;
        if (showNav) this._bindNavSync(swiper);
        if (
          this._sliderMode === 'mobile_only' &&
          window.innerWidth < 1000 &&
          typeof this._restoreSwiperSpacing === 'function'
        ) {
          const firstSlide = this._grid?.querySelector('.swiper-slide');
          const marginRight = firstSlide
            ? parseFloat(getComputedStyle(firstSlide).marginRight)
            : 0;
          if (!marginRight) this._restoreSwiperSpacing();
        }
        if (this.dataset.productSliderAuto === 'true' && swiper.params.enabled) {
          requestAnimationFrame(() => swiper.update());
        }
      };

      if (swiperEl.swiper) {
        setup();
        return;
      }

      let attempts = 0;
      this._swiperTimer = setInterval(() => {
        attempts += 1;
        if (swiperEl.swiper) {
          clearInterval(this._swiperTimer);
          this._swiperTimer = null;
          setup();
        } else if (attempts > 50) {
          clearInterval(this._swiperTimer);
          this._swiperTimer = null;
        }
      }, 100);
    }
  }

  customElements.define('dtc-multicolumn', DtcMulticolumn);
}

(function initDtcMulticolumnOverlayCards() {
  if (window.__dtcMulticolumnOverlayInit) return;
  window.__dtcMulticolumnOverlayInit = true;

  function parseSources(card, playBtn) {
    const raw = card.dataset.videoSources || (playBtn && playBtn.dataset.videoSources) || '[]';
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  function loadSources(video, sources) {
    video.innerHTML = '';
    sources.forEach((source) => {
      const src = document.createElement('source');
      src.src = source.url;
      src.type = source.type;
      video.appendChild(src);
    });
  }

  function isCardVisible(card) {
    return card._dtcOverlayVisible === true;
  }

  function attachCard(card) {
    if (card._vOverlayInit) return;
    card._vOverlayInit = true;

    const playBtn = card.querySelector('.dtc-overlay-card__play');
    const videoWrap = card.querySelector('.dtc-overlay-card__video-wrap');
    const video = card.querySelector('.dtc-overlay-card__video');
    const autoplay = card.dataset.videoAutoplay === 'true';

    if (playBtn && playBtn.dataset.videoEmbedUrl) {
      playBtn.addEventListener('click', () => {
        const embedUrl = playBtn.dataset.videoEmbedUrl;
        const sectionEl = card.closest('[id^="shopify-section-"]');
        const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
        const modal = document.getElementById('dtc-ext-video-modal-' + sectionId);
        const iframeEl = document.getElementById('dtc-ext-video-iframe-' + sectionId);
        const nativeVideo = document.getElementById('dtc-ext-video-native-' + sectionId);
        if (!modal || !iframeEl) return;
        if (nativeVideo) {
          nativeVideo.pause();
          nativeVideo.setAttribute('hidden', '');
        }
        iframeEl.removeAttribute('hidden');
        iframeEl.src = embedUrl;
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        card.classList.add('dtc-overlay-card--playing');
        modal._sourceCard = card;
      });
      return;
    }

    if (!videoWrap || !video) return;

    if (!autoplay && playBtn && playBtn.dataset.videoSources) {
      playBtn.addEventListener('click', () => {
        const sources = parseSources(card, playBtn);
        if (!sources.length) return;
        const sectionEl = card.closest('[id^="shopify-section-"]');
        const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
        const modal = document.getElementById('dtc-ext-video-modal-' + sectionId);
        const nativeVideo = document.getElementById('dtc-ext-video-native-' + sectionId);
        const iframeEl = document.getElementById('dtc-ext-video-iframe-' + sectionId);
        if (!modal || !nativeVideo) return;
        if (iframeEl) {
          iframeEl.src = '';
          iframeEl.setAttribute('hidden', '');
        }
        nativeVideo.innerHTML = '';
        sources.forEach((source) => {
          const src = document.createElement('source');
          src.src = source.url;
          src.type = source.type;
          nativeVideo.appendChild(src);
        });
        nativeVideo.removeAttribute('hidden');
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        card.classList.add('dtc-overlay-card--playing');
        modal._sourceCard = card;
        nativeVideo.load();
        nativeVideo.play().catch(() => {});
      });
      return;
    }

    function startVideo(opts) {
      const sources = parseSources(card, playBtn);
      if (!sources.length) return;

      if (!video.querySelector('source')) loadSources(video, sources);
      if (opts && opts.muted) video.muted = true;
      else if (!autoplay) video.removeAttribute('muted');

      videoWrap.removeAttribute('hidden');
      video.load();
      video.play().catch(() => {});
      card.classList.add('dtc-overlay-card--playing');
    }

    function stopVideo() {
      video.pause();
      if (!autoplay) {
        video.innerHTML = '';
        videoWrap.setAttribute('hidden', '');
      }
      card.classList.remove('dtc-overlay-card--playing');
    }

    const closeBtn = videoWrap.querySelector('.dtc-overlay-card__video-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        stopVideo();
        if (autoplay) {
          card.classList.add('dtc-overlay-card--video-dismissed');
          videoWrap.setAttribute('hidden', '');
        }
      });
    }

    if (autoplay) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function syncAutoplay() {
        if (prefersReducedMotion) return;
        if (card.classList.contains('dtc-overlay-card--video-dismissed')) return;
        if (isCardVisible(card)) {
          startVideo({ muted: true });
        } else {
          video.pause();
          if (card.classList.contains('dtc-overlay-card--video-dismissed')) {
            card.classList.remove('dtc-overlay-card--video-dismissed');
            videoWrap.removeAttribute('hidden');
          }
        }
      }

      if (!card._dtcOverlayIo) {
        card._dtcOverlayIo = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              card._dtcOverlayVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
              syncAutoplay();
            });
          },
          { threshold: [0, 0.25, 0.5, 1] }
        );
        card._dtcOverlayIo.observe(card);
      }

      const swiperEl = card.closest('.swiper');
      if (swiperEl) {
        const bindSwiper = () => {
          const swiper = swiperEl.swiper;
          if (!swiper) return;
          swiper.on('slideChangeTransitionEnd', syncAutoplay);
        };
        if (swiperEl.swiper) bindSwiper();
        else {
          let attempts = 0;
          const timer = setInterval(() => {
            attempts += 1;
            if (swiperEl.swiper) {
              clearInterval(timer);
              bindSwiper();
            } else if (attempts > 50) {
              clearInterval(timer);
            }
          }, 100);
        }
      }

      syncAutoplay();
    }
  }

  function scanCards(root) {
    root.querySelectorAll('.dtc-overlay-card').forEach(attachCard);
  }

  function initExtVideoModals() {
    document.querySelectorAll('.dtc-ext-video-modal').forEach((modal) => {
      if (modal._dtcModalInit) return;
      modal._dtcModalInit = true;

      const iframeEl = modal.querySelector('.dtc-ext-video-modal__iframe');
      const nativeVideo = modal.querySelector('.dtc-ext-video-modal__video');
      const closeBtn = modal.querySelector('.dtc-ext-video-modal__close');
      const backdrop = modal.querySelector('.dtc-ext-video-modal__backdrop');

      function closeModal() {
        if (iframeEl) {
          iframeEl.src = '';
          iframeEl.setAttribute('hidden', '');
        }
        if (nativeVideo) {
          nativeVideo.pause();
          nativeVideo.innerHTML = '';
          nativeVideo.setAttribute('hidden', '');
        }
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (modal._sourceCard) {
          modal._sourceCard.classList.remove('dtc-overlay-card--playing');
          modal._sourceCard = null;
        }
      }

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
      });
    });
  }

  function init(root) {
    scanCards(root || document);
    initExtVideoModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('dtc-overlay-card')) attachCard(node);
        else scanCards(node);
        if (node.classList?.contains('dtc-ext-video-modal') || node.querySelector?.('.dtc-ext-video-modal')) {
          initExtVideoModals();
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = document.getElementById('shopify-section-' + event.detail.sectionId);
      if (section) init(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-newsroom-featured-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-newsroom-featured-story')) {
    class DtcNewsroomFeaturedStory extends HTMLElement {}
    customElements.define('dtc-newsroom-featured-story', DtcNewsroomFeaturedStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-product-tabs')) {
    class DtcProductTabs extends HTMLElement {
      connectedCallback() {
        this._init();
        if (window.Shopify && Shopify.designMode) {
          const section = this.closest('.shopify-section');
          if (section) {
            section.addEventListener('shopify:block:select', (e) => {
              const tabIndex = e.target.dataset.tabIndex;
              if (tabIndex !== undefined) this._activateTab(parseInt(tabIndex, 10));
            });
          }
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
      }

      _init() {
        this._handleClick = this._handleClick.bind(this);
        this.addEventListener('click', this._handleClick);
        this._initBleed();
        this._initDrag();
      }

      /* Measure distance from plist right edge to viewport right, write as CSS var */
      _initBleed() {
        const update = () => {
          const bleedTargets = this.querySelectorAll(
            '.dtc-product-tabs__plist, .dtc-product-tabs__items'
          );
          bleedTargets.forEach((el) => {
            /* Temporarily reset so measurement reflects natural width */
            el.style.removeProperty('--dtc-plist-right-offset');
            const rect   = el.getBoundingClientRect();
            const offset = Math.round(window.innerWidth - rect.right);
            el.style.setProperty('--dtc-plist-right-offset', offset + 'px');
          });
        };

        update();
        window.addEventListener('resize', update);
      }

      /* ---- Mouse-drag scrolling for .dtc-product-tabs__plist ---- */
      _initDrag() {
        this.querySelectorAll('.dtc-product-tabs__plist').forEach((el) => {
          let startX   = 0;
          let scrollLeft = 0;
          let dragging = false;
          let moved    = false;

          const onDown = (e) => {
            if (e.button !== 0) return;
            dragging   = true;
            moved      = false;
            startX     = e.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;
          };

          const onMove = (e) => {
            if (!dragging) return;
            e.preventDefault();
            const x    = e.pageX - el.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 4) {
              moved = true;
              el.classList.add('is-dragging');
            }
            el.scrollLeft = scrollLeft - walk;
          };

          const onUp = () => {
            if (!dragging) return;
            dragging = false;
            el.classList.remove('is-dragging');
          };

          /* Suppress link navigation when user dragged instead of clicking */
          el.addEventListener('click', (e) => {
            if (moved) e.preventDefault();
          }, true);

          el.addEventListener('mousedown', onDown);
          window.addEventListener('mousemove', onMove);
          window.addEventListener('mouseup', onUp);
        });
      }

      _handleClick(e) {
        const navBtn = e.target.closest('.dtc-product-tabs__nav-btn');
        const accordionTrigger = e.target.closest('.dtc-product-tabs__accordion-trigger');

        if (navBtn) {
          const index = parseInt(navBtn.dataset.tabIndex, 10);
          if (!isNaN(index)) this._activateTab(index);
          return;
        }

        if (!accordionTrigger) return;

        const index = parseInt(accordionTrigger.dataset.tabIndex, 10);
        if (isNaN(index)) return;

        if (this._isMobileTabs()) {
          const item = accordionTrigger.closest('.dtc-product-tabs__accordion-item');
          if (item && item.classList.contains('is-open')) {
            this._collapseAll();
            return;
          }
        }

        this._activateTab(index);
      }

      _isMobileTabs() {
        return window.matchMedia('(max-width: 999px)').matches;
      }

      _collapseAll() {
        const root = this;

        root.querySelectorAll('.dtc-product-tabs__nav-btn').forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });

        root.querySelectorAll('.dtc-product-tabs__accordion-item').forEach((item) => {
          item.classList.remove('is-open');
        });

        root.querySelectorAll('.dtc-product-tabs__accordion-trigger').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        root.querySelectorAll('.dtc-product-tabs__panel').forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
          p.style.opacity = '';
        });
      }

      _activateTab(index) {
        const root = this;
        const buttons = root.querySelectorAll('.dtc-product-tabs__nav-btn');
        const panels  = root.querySelectorAll('.dtc-product-tabs__panel');
        const accordionItems = root.querySelectorAll('.dtc-product-tabs__accordion-item');
        const accordionTriggers = root.querySelectorAll('.dtc-product-tabs__accordion-trigger');
        const isMobile = this._isMobileTabs();

        buttons.forEach((b) => {
          const active = parseInt(b.dataset.tabIndex, 10) === index;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        accordionItems.forEach((item) => {
          const active = parseInt(item.dataset.tabIndex, 10) === index;
          item.classList.toggle('is-open', active);
        });

        accordionTriggers.forEach((trigger) => {
          const active = parseInt(trigger.dataset.tabIndex, 10) === index;
          trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
        });

        panels.forEach((p) => {
          const panelIndex = parseInt(p.id.split('-').pop(), 10);
          const active = panelIndex === index;

          if (active) {
            p.classList.add('is-active');
            p.setAttribute('aria-hidden', 'false');
            if (!isMobile) {
              p.style.opacity = '0';
              requestAnimationFrame(() => {
                requestAnimationFrame(() => { p.style.opacity = ''; });
              });
            }
          } else {
            p.classList.remove('is-active');
            p.setAttribute('aria-hidden', 'true');
            if (!isMobile) p.style.opacity = '';
          }
        });
      }
    }

    customElements.define('dtc-product-tabs', DtcProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recipe-plaza-grid"] && !Shopify.designMode) return;
  try {
    
  class DtcRecipePlazaGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.filterMode === 'server') this._initServer();
    }

    disconnectedCallback() {
      if (this._onClick) this.removeEventListener('click', this._onClick);
      if (this._onPopState) window.removeEventListener('popstate', this._onPopState);
      if (this._abortController) this._abortController.abort();
    }

    /* Server mode: Shopify still does the tag filtering and pagination across the
       whole blog, but the tagged URL is fetched through the Section Rendering API
       so only this section's markup is swapped instead of reloading the page. */
    _initServer() {
      this._sectionId = this.dataset.sectionId || '';
      this._blogUrl = (this.dataset.blogUrl || '').replace(/\/$/, '');
      if (!this._sectionId || !this._blogUrl) return;

      this._onClick = (event) => this._handleClick(event);
      this._onPopState = () => {
        const current = new URL(window.location.href);
        if (this._ownsUrl(current)) this._load(current, false);
      };

      this.addEventListener('click', this._onClick);
      window.addEventListener('popstate', this._onPopState);

      const current = new URL(window.location.href);
      if (!this._shouldAutoSelect(current)) return;

      const first = this.querySelector('a.dtc-recipe-plaza-grid__filter[href*="/tagged/"]');
      if (!first) return;

      const next = this._withPageParams(new URL(first.href, window.location.href));
      next.searchParams.delete('show_all');
      this._load(next, 'replace');
    }

    _ownsUrl(url) {
      if (url.origin !== window.location.origin) return false;
      const path = url.pathname.replace(/\/$/, '');
      return path === this._blogUrl || path.indexOf(this._blogUrl + '/tagged/') === 0;
    }

    _shouldAutoSelect(url) {
      if (!this._ownsUrl(url)) return false;
      const path = url.pathname.replace(/\/$/, '');
      if (path !== this._blogUrl) return false;
      return url.searchParams.get('show_all') !== '1';
    }

    _withPageParams(url) {
      const next = new URL(url.href, window.location.href);
      const view = new URL(window.location.href).searchParams.get('view');
      if (view) next.searchParams.set('view', view);
      return next;
    }

    _handleClick(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;

      let url;
      try {
        url = this._withPageParams(new URL(link.href, window.location.href));
      } catch (error) {
        return;
      }
      if (!this._ownsUrl(url)) return;

      event.preventDefault();
      if (url.pathname.replace(/\/$/, '').indexOf(this._blogUrl + '/tagged/') === 0) {
        url.searchParams.delete('show_all');
      }
      this._load(url, 'push');
    }

    _filterHandleFromUrl(url) {
      if (url.searchParams.get('show_all') === '1') return '';
      const path = url.pathname.replace(/\/$/, '');
      const prefix = this._blogUrl + '/tagged/';
      if (path.indexOf(prefix) !== 0) return '';
      return decodeURIComponent(path.slice(prefix.length).split('/')[0] || '');
    }

    _syncFilters(url) {
      const activeHandle = this._filterHandleFromUrl(url);
      this.querySelectorAll('a.dtc-recipe-plaza-grid__filter').forEach((el) => {
        const on = activeHandle !== '' && el.dataset.handle === activeHandle;
        el.classList.toggle('is-active', on);
        if (on) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
    }

    async _load(targetUrl, historyMode) {
      const url = new URL(targetUrl.href);
      url.searchParams.delete('section_id');
      this._syncFilters(url);

      const requestUrl = new URL(url.href);
      requestUrl.hash = '';
      requestUrl.searchParams.set('section_id', this._sectionId);

      if (this._abortController) this._abortController.abort();
      const controller = new AbortController();
      this._abortController = controller;
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(requestUrl.toString(), {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error('Recipe grid request failed');

        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = parsed.querySelector('dtc-recipe-plaza-grid');
        if (!next) throw new Error('Recipe grid markup missing');

        this.innerHTML = next.innerHTML;
        this._stripSectionParam();
        if (historyMode === true || historyMode === 'push') {
          window.history.pushState({ dtcRecipePlazaGrid: true }, '', url.toString());
        } else if (historyMode === 'replace') {
          window.history.replaceState({ dtcRecipePlazaGrid: true }, '', url.toString());
        }
        if (historyMode !== 'replace') this._scrollListIntoView();
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url.toString();
      } finally {
        if (this._abortController === controller) this.removeAttribute('aria-busy');
      }
    }

    /* Pagination URLs built during a Section Rendering request carry section_id
       forward; drop it so shared / new-tab links resolve to the full page. */
    _stripSectionParam() {
      this.querySelectorAll('a[href*="section_id="]').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        url.searchParams.delete('section_id');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }

    _scrollListIntoView() {
      const main = this.querySelector('.dtc-recipe-plaza-grid__main');
      if (!main) return;
      const top = main.getBoundingClientRect().top;
      if (top >= 0) return;
      window.scrollTo({ top: Math.max(0, top + window.scrollY - 96), behavior: 'smooth' });
    }
  }

  if (!customElements.get('dtc-recipe-plaza-grid')) {
    customElements.define('dtc-recipe-plaza-grid', DtcRecipePlazaGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recipe-plaza-origins"] && !Shopify.designMode) return;
  try {
    
  class DtcRecipePlazaOrigins extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this.addEventListener('click', this._onClick);

      if (window.Shopify && Shopify.designMode) {
        this._section = this.closest('.shopify-section');
        this._section?.addEventListener('shopify:block:select', this._onBlockSelect);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this._section?.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _onClick(event) {
      const pin = event.target.closest('[data-origin-pin]');
      if (pin) {
        this._activate(pin.dataset.originId);
        return;
      }

      const toggle = event.target.closest('.dtc-recipe-plaza-origins__toggle');
      if (!toggle) return;
      const item = toggle.closest('[data-origin-item]');
      if (item) this._toggleMobileItem(item);
    }

    _onBlockSelect(event) {
      const blockId = event.detail && event.detail.blockId;
      if (blockId) this._activate(blockId, true);
    }

    _activate(originId, forceMobileOpen) {
      if (!originId) return;

      this.querySelectorAll('[data-origin-pin]').forEach((pin) => {
        const on = pin.dataset.originId === originId;
        pin.classList.toggle('is-active', on);
        pin.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      this.querySelectorAll('[data-origin-card]').forEach((card) => {
        const on = card.dataset.originId === originId;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      const mobileItem = this.querySelector('[data-origin-item][data-origin-id="' + originId + '"]');
      if (mobileItem) this._toggleMobileItem(mobileItem, forceMobileOpen !== false);
    }

    _toggleMobileItem(item, forceOpen) {
      const wasActive = item.classList.contains('is-active');
      const shouldOpen = forceOpen === true ? true : !wasActive;

      this.querySelectorAll('[data-origin-item]').forEach((entry) => {
        entry.classList.remove('is-active');
        entry.querySelector('.dtc-recipe-plaza-origins__toggle')?.setAttribute('aria-expanded', 'false');
      });

      if (shouldOpen) {
        item.classList.add('is-active');
        item.querySelector('.dtc-recipe-plaza-origins__toggle')?.setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (!customElements.get('dtc-recipe-plaza-origins')) {
    customElements.define('dtc-recipe-plaza-origins', DtcRecipePlazaOrigins);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recipes-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-recipes-grid')) {
    class DtcRecipesGrid extends HTMLElement {
      connectedCallback() {
        this._cardsWrap = this.querySelector('[data-recipes-cards]');
        this._cards = Array.from(this.querySelectorAll('[data-recipes-card]'));
        this._sort = this.querySelector('[data-recipes-sort]');
        this._sortOptions = Array.from(this.querySelectorAll('[data-recipes-sort-option]'));
        this._sortLabels = Array.from(this.querySelectorAll('[data-recipes-sort-label]'));
        this._sortDropdowns = Array.from(this.querySelectorAll('[data-recipes-sort-dropdown]'));
        this._count = this.querySelector('[data-recipes-result-count]');
        this._empty = this.querySelector('[data-recipes-empty]');
        this._activeFacets = this.querySelector('[data-recipes-active-facets]');
        this._pagination = this.querySelector('[data-recipes-pagination]');
        this._filterDrawer = this.querySelector('[data-recipes-filter-drawer]');
        this._filterOpen = this.querySelector('[data-recipes-filter-open]');
        this._filterCloseButtons = Array.from(this.querySelectorAll('[data-recipes-filter-close]'));
        this._filterClearButtons = Array.from(this.querySelectorAll('[data-recipes-filter-clear]'));
        this._tagFilters = Array.from(this.querySelectorAll('[data-recipes-tag-filter]'));
        this._perPage = parseInt(this.dataset.cardsPerPage || '6', 10);
        if (!this._perPage || this._perPage < 1) this._perPage = 6;

        this._activeTags = [];
        this._currentPage = 1;
        this._searchQuery = '';

        this._mobileQuery = window.matchMedia('(max-width: 699px)');
        this._handleEscape = (event) => {
          if (event.key === 'Escape') this._closeFilterDrawer();
        };
        this._handleDocumentClick = (event) => this._closeSortDropdowns(event);
        this._handleRecipesSearch = (event) => {
          this._searchQuery = event.detail?.query || '';
          this._applyView({ resetPage: true });
          if (event.detail?.scroll) this._scrollToTop();
        };
        this._handlePaginationClick = (event) => {
          const target = event.target.closest('[data-page]');
          if (!target || !this._pagination?.contains(target)) return;
          const nextPage = parseInt(target.getAttribute('data-page'), 10);
          if (isNaN(nextPage) || nextPage < 1) return;
          this._currentPage = nextPage;
          this._applyView();
          this._scrollToTop();
        };
        this._handleActiveFacetsClick = (event) => {
          if (!this._activeFacets?.contains(event.target)) return;
          const tagButton = event.target.closest('[data-recipes-active-tag]');
          if (tagButton) {
            const handle = tagButton.getAttribute('data-recipes-active-tag');
            this._tagFilters.forEach((input) => {
              if (input.value === handle) input.checked = false;
            });
            this._activeTags = this._getSelectedTags();
            this._applyView({ resetPage: true });
            return;
          }
          if (event.target.closest('[data-recipes-filter-clear]')) {
            this._clearAllFilters();
          }
        };

        if (this._sort) {
          this._sort.addEventListener('change', () => {
            this._syncSortOptions(this._sort.value);
            this._applyView({ resetPage: true });
          });
        }
        this._sortOptions.forEach((option) => {
          option.addEventListener('change', () => {
            if (!option.checked) return;
            if (this._sort) this._sort.value = option.value;
            this._syncSortOptions(option.value);
            this._closeSortDropdowns();
            this._applyView({ resetPage: true });
          });
        });
        if (this._filterOpen) this._filterOpen.addEventListener('click', () => this._openFilterDrawer());
        this._filterCloseButtons.forEach((button) => {
          button.addEventListener('click', () => this._closeFilterDrawer());
        });
        this._filterClearButtons.forEach((button) => {
          button.addEventListener('click', () => this._clearAllFilters());
        });
        this._tagFilters.forEach((input) => {
          input.addEventListener('change', () => {
            this._activeTags = this._getSelectedTags();
            this._applyView({ resetPage: true });
          });
        });
        if (this._mobileQuery.addEventListener) {
          this._mobileQuery.addEventListener('change', () => this._syncFilterDrawerState());
        } else if (this._mobileQuery.addListener) {
          this._mobileQuery.addListener(() => this._syncFilterDrawerState());
        }

        this._syncFilterDrawerState();
        this._syncSortOptions(this._sort ? this._sort.value : '');
        document.addEventListener('click', this._handleDocumentClick);
        document.addEventListener('dtc-recipes:search', this._handleRecipesSearch);
        this._pagination?.addEventListener('click', this._handlePaginationClick);
        this._activeFacets?.addEventListener('click', this._handleActiveFacetsClick);

        const initial = this._readUrlState();
        this._activeTags = initial.tags;
        this._currentPage = initial.page;
        this._searchQuery = initial.q;
        if (initial.tags.length) {
          this._tagFilters.forEach((input) => {
            input.checked = initial.tags.includes(input.value);
            if (input.checked) input.closest('details')?.setAttribute('open', '');
          });
          this._activeTags = this._getSelectedTags();
        }

        this._applyView();
        if (initial.page > 1) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this._scrollToTop('auto'));
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this._handleDocumentClick);
        document.removeEventListener('keydown', this._handleEscape);
        document.removeEventListener('dtc-recipes:search', this._handleRecipesSearch);
        this._pagination?.removeEventListener('click', this._handlePaginationClick);
        this._activeFacets?.removeEventListener('click', this._handleActiveFacetsClick);
      }

      _getSelectedTags() {
        return this._tagFilters.filter((input) => input.checked).map((input) => input.value);
      }

      _readUrlState() {
        const url = new URL(window.location.href);
        let tags = (url.searchParams.get('tag') || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);

        if (!tags.length && url.pathname.indexOf('/tagged/') !== -1) {
          tags = (url.pathname.split('/tagged/')[1] || '')
            .split('+')
            .map((value) => value.trim())
            .filter(Boolean);
        }

        const page = parseInt(url.searchParams.get('page') || '1', 10);
        const q = url.searchParams.get('q') || '';
        return {
          tags,
          page: isNaN(page) || page < 1 ? 1 : page,
          q,
        };
      }

      _syncUrl(page) {
        const url = new URL(window.location.href);
        url.pathname = url.pathname.split('/tagged/')[0];

        if (this._activeTags.length) {
          url.searchParams.set('tag', this._activeTags.join(','));
        } else {
          url.searchParams.delete('tag');
        }

        if (this._searchQuery) {
          url.searchParams.set('q', this._searchQuery);
        } else {
          url.searchParams.delete('q');
        }

        if (page > 1) {
          url.searchParams.set('page', String(page));
        } else {
          url.searchParams.delete('page');
        }

        window.history.replaceState(null, '', url.toString());
      }

      _getFilteredCards() {
        const tags = this._activeTags;
        const searchQuery = (this._searchQuery || '').trim().toLowerCase();

        return this._cards.filter((card) => {
          if (tags.length) {
            const cardTags = (card.dataset.tagHandles || '').split(',').filter(Boolean);
            if (!tags.every((tag) => cardTags.includes(tag))) return false;
          }

          if (searchQuery) {
            const title = (card.dataset.title || '').toLowerCase();
            const tagsText = (card.dataset.tags || '').toLowerCase();
            if (!title.includes(searchQuery) && !tagsText.includes(searchQuery)) return false;
          }

          return true;
        });
      }

      _sortCardList(cards) {
        const value = this._sort ? this._sort.value : '';
        if (value !== 'title-asc' && value !== 'title-desc') return cards;

        const direction = value === 'title-asc' ? 1 : -1;
        return cards.slice().sort((a, b) => {
          return (a.dataset.title || '').localeCompare(b.dataset.title || '') * direction;
        });
      }

      _getPageParts(page, totalPages) {
        const before = 3;
        const after = 2;
        const edgeStart = 3;
        const parts = [];
        let prevShown = 0;

        for (let i = 1; i <= totalPages; i += 1) {
          const showPage =
            i <= edgeStart ||
            (totalPages > 1 && i >= totalPages - 1) ||
            (i >= page - before && i <= page + after);
          if (!showPage) continue;

          if (prevShown > 0 && i > prevShown + 1) {
            parts.push({ type: 'ellipsis' });
          }

          parts.push({ type: 'page', number: i, current: i === page });
          prevShown = i;
        }

        return parts;
      }

      _renderPagination(page, totalPages) {
        if (!this._pagination) return;

        if (totalPages <= 1) {
          this._pagination.hidden = true;
          this._pagination.innerHTML = '';
          return;
        }

        this._pagination.hidden = false;

        const nav = document.createElement('nav');
        nav.className = 'dtc-pagination';
        nav.setAttribute('aria-label', 'Pagination');

        const ul = document.createElement('ul');
        ul.className = 'dtc-pagination__list';

        const prevItem = document.createElement('li');
        prevItem.className = 'dtc-pagination__item';
        if (page > 1) {
          const prevBtn = document.createElement('button');
          prevBtn.type = 'button';
          prevBtn.className = 'dtc-pagination__link dtc-pagination__nav';
          prevBtn.setAttribute('data-page', String(page - 1));
          prevBtn.textContent = 'Previous';
          prevItem.appendChild(prevBtn);
        } else {
          const prevDisabled = document.createElement('span');
          prevDisabled.className = 'dtc-pagination__link dtc-pagination__nav dtc-pagination__nav--disabled';
          prevDisabled.setAttribute('aria-disabled', 'true');
          prevDisabled.textContent = 'Previous';
          prevItem.appendChild(prevDisabled);
        }
        ul.appendChild(prevItem);

        this._getPageParts(page, totalPages).forEach((part) => {
          const pageItem = document.createElement('li');
          pageItem.className = 'dtc-pagination__item';

          if (part.type === 'ellipsis') {
            const ellipsis = document.createElement('span');
            ellipsis.className = 'dtc-pagination__ellipsis';
            ellipsis.setAttribute('aria-hidden', 'true');
            ellipsis.innerHTML = '&hellip;';
            pageItem.appendChild(ellipsis);
          } else if (part.current) {
            pageItem.classList.add('dtc-pagination__item--current');
            const current = document.createElement('span');
            current.className = 'dtc-pagination__link dtc-pagination__current';
            current.setAttribute('aria-current', 'page');
            current.textContent = String(part.number);
            pageItem.appendChild(current);
          } else {
            const pageBtn = document.createElement('button');
            pageBtn.type = 'button';
            pageBtn.className = 'dtc-pagination__link';
            pageBtn.setAttribute('data-page', String(part.number));
            pageBtn.textContent = String(part.number);
            pageItem.appendChild(pageBtn);
          }

          ul.appendChild(pageItem);
        });

        const nextItem = document.createElement('li');
        nextItem.className = 'dtc-pagination__item';
        if (page < totalPages) {
          const nextBtn = document.createElement('button');
          nextBtn.type = 'button';
          nextBtn.className = 'dtc-pagination__link dtc-pagination__nav';
          nextBtn.setAttribute('data-page', String(page + 1));
          nextBtn.textContent = 'Next';
          nextItem.appendChild(nextBtn);
        } else {
          const nextDisabled = document.createElement('span');
          nextDisabled.className = 'dtc-pagination__link dtc-pagination__nav dtc-pagination__nav--disabled';
          nextDisabled.setAttribute('aria-disabled', 'true');
          nextDisabled.textContent = 'Next';
          nextItem.appendChild(nextDisabled);
        }
        ul.appendChild(nextItem);

        nav.appendChild(ul);
        this._pagination.innerHTML = '';
        this._pagination.appendChild(nav);
      }

      _renderActiveFacets() {
        if (!this._activeFacets) return;

        const checked = this._tagFilters.filter((input) => input.checked);
        if (!checked.length) {
          this._activeFacets.hidden = true;
          this._activeFacets.innerHTML = '';
          return;
        }

        this._activeFacets.hidden = false;
        this._activeFacets.innerHTML = checked
          .map((input) => {
            const label =
              input.closest('label')?.querySelector('.dtc-recipes-grid__facet-label-text')?.textContent?.trim() ||
              input.value;
            return (
              `<button type="button" class="dtc-recipes-grid__active-pill" data-recipes-active-tag="${input.value}">` +
              `<span>${label}</span>` +
              '<span class="dtc-recipes-grid__active-pill-remove" aria-hidden="true"></span>' +
              '<span class="sr-only">Remove filter</span>' +
              '</button>'
            );
          })
          .join('') + '<button type="button" class="dtc-recipes-grid__active-clear" data-recipes-filter-clear>Clear all</button>';
      }

      _applyView(options = {}) {
        if (!this._cards.length) return;

        let filtered = this._sortCardList(this._getFilteredCards());
        const totalPages = Math.max(1, Math.ceil(filtered.length / this._perPage));

        if (options.resetPage) {
          this._currentPage = 1;
        } else if (this._currentPage > totalPages) {
          this._currentPage = totalPages;
        }

        const start = (this._currentPage - 1) * this._perPage;
        const end = start + this._perPage;

        filtered.forEach((card) => {
          this._cardsWrap.appendChild(card);
        });

        this._cards.forEach((card) => {
          card.hidden = true;
        });

        let visibleOnPage = 0;
        filtered.forEach((card, index) => {
          const onPage = index >= start && index < end;
          card.hidden = !onPage;
          if (onPage) visibleOnPage += 1;
        });

        if (this._count) this._count.textContent = filtered.length;
        if (this._empty) this._empty.hidden = filtered.length > 0;

        this._renderActiveFacets();
        this._renderPagination(this._currentPage, totalPages);
        this._syncUrl(this._currentPage);

        if (visibleOnPage === 0 && filtered.length > 0 && !options.resetPage) {
          this._currentPage = 1;
          this._applyView({ resetPage: true });
        }
      }

      _clearAllFilters() {
        this._tagFilters.forEach((input) => {
          input.checked = false;
        });
        this._activeTags = [];
        this._applyView({ resetPage: true });
      }

      _openFilterDrawer() {
        if (!this._filterDrawer) return;
        this.classList.add('is-filter-drawer-open');
        this._filterDrawer.removeAttribute('aria-hidden');
        this._filterOpen?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this._handleEscape);
      }

      _closeFilterDrawer() {
        if (!this._filterDrawer) return;
        this.classList.remove('is-filter-drawer-open');
        this._filterOpen?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this._handleEscape);
        this._syncFilterDrawerState();
      }

      _syncSortOptions(value) {
        const placeholder = this.dataset.sortPlaceholder || 'Sort by';
        let label = placeholder;

        if (value && this._sort) {
          const selectOption = Array.from(this._sort.options).find((option) => option.value === value);
          if (selectOption) label = selectOption.textContent.trim();
        }

        this._sortOptions.forEach((option) => {
          option.checked = option.value === value;
        });
        this._sortLabels.forEach((sortLabel) => {
          sortLabel.textContent = label;
        });
      }

      _closeSortDropdowns(event) {
        this._sortDropdowns.forEach((dropdown) => {
          if (event && dropdown.contains(event.target)) return;
          dropdown.removeAttribute('open');
        });
      }

      _syncFilterDrawerState() {
        if (!this._filterDrawer) return;
        if (this._mobileQuery.matches && !this.classList.contains('is-filter-drawer-open')) {
          this._filterDrawer.setAttribute('aria-hidden', 'true');
        } else {
          this._filterDrawer.removeAttribute('aria-hidden');
        }
      }

      _scrollToTop(behavior = 'smooth') {
        const target = this.querySelector('.dtc-recipes-grid__main');
        if (!target) return;
        const offset = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, offset), behavior });
      }
    }

    customElements.define('dtc-recipes-grid', DtcRecipesGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recipes-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-recipes-hero')) {
    class DtcRecipesHero extends HTMLElement {
      connectedCallback() {
        this._input = this.querySelector('[data-recipes-search-input]');
        this._form = this.querySelector('.dtc-recipes-hero__search');
        if (this._form) {
          this._form.addEventListener('submit', (event) => {
            event.preventDefault();
            const query = (this._input?.value || '').trim();
            document.dispatchEvent(
              new CustomEvent('dtc-recipes:search', {
                detail: { query, scroll: true },
              })
            );
          });
        }
        this.querySelectorAll('[data-recipes-search-chip]').forEach((chip) => {
          chip.addEventListener('click', () => this._applyChip(chip));
        });

        const initialQuery = new URL(window.location.href).searchParams.get('q') || '';
        if (this._input && initialQuery) this._input.value = initialQuery;
      }

      _applyChip(chip) {
        if (!this._input) return;
        this._input.value = chip.dataset.recipesSearchChip || '';
        document.dispatchEvent(
          new CustomEvent('dtc-recipes:search', {
            detail: { query: this._input.value.trim(), scroll: true },
          })
        );
      }
    }

    customElements.define('dtc-recipes-hero', DtcRecipesHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recipes-product-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-recipes-product-categories')) {
    class DtcRecipesProductCategories extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-recipes-product-categories-track]');
        this._dots = Array.from(this.querySelectorAll('[data-recipes-product-categories-dot]'));
        this._cards = Array.from(this.querySelectorAll('.dtc-recipes-product-categories__item'));

        if (!this._track || !this._dots.length || !this._cards.length) return;

        this._onScroll = this._handleScroll.bind(this);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this._dots.forEach((dot) => {
          dot.addEventListener('click', () => this._goTo(Number(dot.dataset.recipesProductCategoriesDot) || 0));
        });
      }

      disconnectedCallback() {
        if (this._track && this._onScroll) {
          this._track.removeEventListener('scroll', this._onScroll);
        }
      }

      _handleScroll() {
        window.requestAnimationFrame(() => {
          this._setActiveDot(this._getActiveIndex());
        });
      }

      _getActiveIndex() {
        const firstCard = this._cards[0];
        if (!firstCard) return 0;
        const styles = window.getComputedStyle(this._track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = firstCard.offsetWidth + gap;
        return Math.max(0, Math.min(this._cards.length - 1, Math.round(this._track.scrollLeft / step)));
      }

      _goTo(index) {
        const card = this._cards[index];
        if (!card) return;
        this._track.scrollTo({ left: card.offsetLeft - this._track.offsetLeft, behavior: 'smooth' });
        this._setActiveDot(index);
      }

      _setActiveDot(index) {
        this._dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('dtc-recipes-product-categories', DtcRecipesProductCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-salient-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-salient-features')) {
    class DtcSalientFeatures extends HTMLElement {}
    customElements.define('dtc-salient-features', DtcSalientFeatures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-scientific"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-scientific')) {
    class DtcScientific extends HTMLElement {
      connectedCallback() {
        this._onClick = this._handleClick.bind(this);
        this._onMouseEnter = this._pauseAutoplay.bind(this);
        this._onMouseLeave = this._startAutoplay.bind(this);
        this._onFocusIn = this._pauseAutoplay.bind(this);
        this._onFocusOut = this._handleFocusOut.bind(this);
        this._onVisibilityChange = this._handleVisibilityChange.bind(this);
        this._onTouchStart = this._handleTouchStart.bind(this);
        this._onTouchMove = this._handleTouchMove.bind(this);
        this._onTouchEnd = this._handleTouchEnd.bind(this);
        this.addEventListener('click', this._onClick);
        this.addEventListener('mouseenter', this._onMouseEnter);
        this.addEventListener('mouseleave', this._onMouseLeave);
        this.addEventListener('focusin', this._onFocusIn);
        this.addEventListener('focusout', this._onFocusOut);
        document.addEventListener('visibilitychange', this._onVisibilityChange);
        this._initVideos();
        this._initSwipe();
        this._refreshSlides();
        this.goTo(this._getActiveIndex());
        this._startAutoplay();

        if (window.Shopify && Shopify.designMode) {
          this._sectionEl = this.closest('.shopify-section');
          if (this._sectionEl) {
            this._onSectionLoad = () => {
              this._initVideos();
              this._initSwipe();
              this._refreshSlides();
              this.goTo(0);
              this._startAutoplay();
            };
            this._sectionEl.addEventListener('shopify:section:load', this._onSectionLoad);
          }
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('mouseenter', this._onMouseEnter);
        this.removeEventListener('mouseleave', this._onMouseLeave);
        this.removeEventListener('focusin', this._onFocusIn);
        this.removeEventListener('focusout', this._onFocusOut);
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        this._destroySwipe();
        if (this._transitionTimer) {
          window.clearTimeout(this._transitionTimer);
          this._transitionTimer = null;
        }
        this._slideTransitioning = false;
        this._pauseAutoplay();
        if (this._sectionEl && this._onSectionLoad) {
          this._sectionEl.removeEventListener('shopify:section:load', this._onSectionLoad);
        }
      }

      _refreshSlides() {
        this.slides = Array.from(this.querySelectorAll('.dtc-scientific__slide'));
        this.dots = Array.from(this.querySelectorAll('.dtc-scientific__dot'));
      }

      _initVideos() {
        this.querySelectorAll('.dtc-scientific__media').forEach((media) => {
          if (media._dtcScientificVideoInit) return;
          media._dtcScientificVideoInit = true;

          const playBtn = media.querySelector('[data-video-sources]');
          const videoWrap = media.querySelector('.dtc-scientific__video-wrap');
          const video = media.querySelector('.dtc-scientific__video');
          const closeBtn = media.querySelector('.dtc-scientific__video-close');

          if (!playBtn || !videoWrap || !video) return;

          playBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            let sources = [];
            try {
              sources = JSON.parse(playBtn.dataset.videoSources || '[]');
            } catch (error) {
              sources = [];
            }
            if (!sources.length) return;

            this._pauseAutoplay();
            video.innerHTML = '';
            sources.forEach((source) => {
              const src = document.createElement('source');
              src.src = source.url;
              src.type = source.type;
              video.appendChild(src);
            });

            videoWrap.hidden = false;
            playBtn.hidden = true;
            video.load();
            video.play().catch(() => {});
          });

          if (closeBtn) {
            closeBtn.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              video.pause();
              videoWrap.hidden = true;
              playBtn.hidden = false;
              this._startAutoplay();
            });
          }
        });
      }

      _resetSlideVideo(slide) {
        const video = slide.querySelector('.dtc-scientific__video');
        const videoWrap = slide.querySelector('.dtc-scientific__video-wrap');
        const playBtn = slide.querySelector('[data-video-sources]');
        if (!video) return;

        video.pause();
        video.innerHTML = '';
        if (videoWrap) videoWrap.hidden = true;
        if (playBtn) playBtn.hidden = false;
      }

      _initSwipe() {
        this._destroySwipe();
        this._refreshSlides();

        if (this.slides.length < 2) return;

        const surface = this.querySelector('.dtc-scientific__panel');
        if (!surface) return;

        this._swipeSurface = surface;
        this._swipeThreshold = 50;
        this._touchStartX = 0;
        this._touchStartY = 0;
        this._touchActive = false;
        this._swipeAxisLocked = false;

        surface.addEventListener('touchstart', this._onTouchStart, { passive: true });
        surface.addEventListener('touchmove', this._onTouchMove, { passive: false });
        surface.addEventListener('touchend', this._onTouchEnd);
        surface.addEventListener('touchcancel', this._onTouchEnd);
      }

      _destroySwipe() {
        if (!this._swipeSurface) return;

        this._swipeSurface.removeEventListener('touchstart', this._onTouchStart);
        this._swipeSurface.removeEventListener('touchmove', this._onTouchMove);
        this._swipeSurface.removeEventListener('touchend', this._onTouchEnd);
        this._swipeSurface.removeEventListener('touchcancel', this._onTouchEnd);
        this._swipeSurface = null;
        this._touchActive = false;
        this._swipeAxisLocked = false;
      }

      _isSwipeInteractiveTarget(target) {
        return Boolean(
          target instanceof Element &&
            target.closest('a, button, input, textarea, select, label, video')
        );
      }

      _handleTouchStart(event) {
        if (
          this.slides.length < 2 ||
          this._hasActiveVideo() ||
          event.touches.length !== 1 ||
          this._isSwipeInteractiveTarget(event.target)
        ) {
          return;
        }

        const touch = event.touches[0];
        this._touchStartX = touch.clientX;
        this._touchStartY = touch.clientY;
        this._touchActive = true;
        this._swipeAxisLocked = false;
        this._pauseAutoplay();
      }

      _handleTouchMove(event) {
        if (!this._touchActive || event.touches.length !== 1) return;

        const touch = event.touches[0];
        const deltaX = touch.clientX - this._touchStartX;
        const deltaY = touch.clientY - this._touchStartY;

        if (!this._swipeAxisLocked) {
          if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
            this._touchActive = false;
            return;
          }

          if (Math.abs(deltaX) > 10) {
            this._swipeAxisLocked = true;
          }
        }

        if (this._swipeAxisLocked && event.cancelable) {
          event.preventDefault();
        }
      }

      _handleTouchEnd(event) {
        if (!this._touchActive) {
          this._startAutoplay();
          return;
        }

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this._touchStartX;

        this._touchActive = false;

        if (this._swipeAxisLocked && Math.abs(deltaX) >= this._swipeThreshold) {
          const direction = deltaX < 0 ? 1 : -1;
          this.goTo(this._getActiveIndex() + direction);
        }

        this._swipeAxisLocked = false;
        this._startAutoplay();
      }

      _getActiveIndex() {
        const activeSlide = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        return activeSlide >= 0 ? activeSlide : 0;
      }

      _handleClick(event) {
        const nav = event.target.closest('[data-nav]');
        if (nav && this.contains(nav)) {
          event.preventDefault();
          const direction = nav.getAttribute('data-nav') === 'next' ? 1 : -1;
          this.goTo(this._getActiveIndex() + direction);
          this._startAutoplay();
          return;
        }

        const dot = event.target.closest('[data-dot-index]');
        if (dot && this.contains(dot)) {
          event.preventDefault();
          const index = Number(dot.getAttribute('data-dot-index'));
          if (!Number.isNaN(index)) {
            this.goTo(index);
            this._startAutoplay();
          }
        }
      }

      _isAutoplayEnabled() {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        return this.dataset.autoplay === 'true' && this.slides.length > 1 && !prefersReducedMotion;
      }

      _getAutoplayDelay() {
        const delay = Number(this.dataset.autoplayInterval);
        return Number.isFinite(delay) && delay >= 1000 ? delay : 5000;
      }

      _hasActiveVideo() {
        return Boolean(this.querySelector('.dtc-scientific__video-wrap:not([hidden])'));
      }

      _hasFocus() {
        return document.activeElement instanceof Element && this.contains(document.activeElement);
      }

      _startAutoplay() {
        this._pauseAutoplay();
        this._refreshSlides();

        if (!this._isAutoplayEnabled() || document.hidden || this._hasActiveVideo()) return;

        this._autoplayTimer = window.setInterval(() => {
          if (document.hidden || this.matches(':hover') || this._hasFocus() || this._hasActiveVideo()) return;
          this.goTo(this._getActiveIndex() + 1);
        }, this._getAutoplayDelay());
      }

      _pauseAutoplay() {
        if (!this._autoplayTimer) return;
        window.clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }

      _handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this._startAutoplay();
      }

      _handleVisibilityChange() {
        if (document.hidden) {
          this._pauseAutoplay();
          return;
        }

        this._startAutoplay();
      }

      _getSlideDirection(fromIndex, toIndex, total) {
        let diff = toIndex - fromIndex;
        if (diff > total / 2) diff -= total;
        if (diff < -total / 2) diff += total;
        if (diff > 0) return 1;
        if (diff < 0) return -1;
        return 0;
      }

      _clearSlideTransitionClasses(slide) {
        slide.classList.remove(
          'is-slide-enter-next',
          'is-slide-enter-prev',
          'is-slide-leave-next',
          'is-slide-leave-prev'
        );
      }

      _updateDots(activeIndex) {
        this.dots.forEach((dot, i) => {
          const isActive = i === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      _applySlideState(activeIndex) {
        this.slides.forEach((slide, i) => {
          const isActive = i === activeIndex;
          this._clearSlideTransitionClasses(slide);
          slide.classList.toggle('is-active', isActive);
          slide.hidden = !isActive;
          if (!isActive) this._resetSlideVideo(slide);
        });
        this._updateDots(activeIndex);
      }

      _finishSlideTransition(fromSlide, toSlide, activeIndex) {
        if (fromSlide && fromSlide !== toSlide) {
          this._clearSlideTransitionClasses(fromSlide);
          fromSlide.classList.remove('is-active');
          fromSlide.hidden = true;
          this._resetSlideVideo(fromSlide);
        }

        if (toSlide) {
          this._clearSlideTransitionClasses(toSlide);
          toSlide.classList.add('is-active');
          toSlide.hidden = false;
        }

        this._updateDots(activeIndex);
        this._slideTransitioning = false;
        this._startAutoplay();
      }

      goTo(index) {
        this._refreshSlides();
        const total = this.slides.length;
        if (total < 1) return;

        const activeIndex = total < 2 ? 0 : ((index % total) + total) % total;
        const fromIndex = this._getActiveIndex();

        if (fromIndex === activeIndex) return;

        if (this._slideTransitioning) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion || total < 2) {
          this._applySlideState(activeIndex);
          return;
        }

        const fromSlide = this.slides[fromIndex];
        const toSlide = this.slides[activeIndex];
        const direction = this._getSlideDirection(fromIndex, activeIndex, total);
        const forward = direction > 0;
        const enterClass = forward ? 'is-slide-enter-next' : 'is-slide-enter-prev';
        const leaveClass = forward ? 'is-slide-leave-next' : 'is-slide-leave-prev';

        this._slideTransitioning = true;
        this._pauseAutoplay();
        this._updateDots(activeIndex);
        this._clearSlideTransitionClasses(fromSlide);
        this._clearSlideTransitionClasses(toSlide);

        toSlide.hidden = false;
        toSlide.classList.remove('is-active');
        toSlide.classList.add(enterClass);

        fromSlide.classList.add(leaveClass);

        requestAnimationFrame(() => {
          fromSlide.classList.remove('is-active');
          toSlide.classList.add('is-active');

          requestAnimationFrame(() => {
            toSlide.classList.remove(enterClass);
          });
        });

        const finish = () => {
          if (!this._slideTransitioning) return;
          if (this._transitionTimer) {
            window.clearTimeout(this._transitionTimer);
            this._transitionTimer = null;
          }
          if (toSlide) toSlide.removeEventListener('transitionend', onTransitionEnd);
          this._finishSlideTransition(fromSlide, toSlide, activeIndex);
        };

        const onTransitionEnd = (event) => {
          if (event.target !== toSlide) return;
          if (event.propertyName !== 'transform' && event.propertyName !== 'opacity') return;
          finish();
        };

        toSlide.addEventListener('transitionend', onTransitionEnd);
        this._transitionTimer = window.setTimeout(finish, 480);
      }
    }

    customElements.define('dtc-scientific', DtcScientific);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-social-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-social-stories')) {
  class DtcSocialStories extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.dtc-social-stories__track-wrap');
      this._dots = this.querySelectorAll('.dtc-social-stories__dot');
      this._isDragging = false;
      this._startX = 0;
      this._scrollStart = 0;

      if (this._track) {
        this._bindScroll();
        this._bindDrag();
      }
    }

    disconnectedCallback() {
      const t = this._track;
      if (!t) return;
      t.removeEventListener('scroll', this._onScroll);
      t.removeEventListener('pointerdown', this._onPointerDown);
      t.removeEventListener('pointermove', this._onPointerMove);
      t.removeEventListener('pointerup', this._onPointerUp);
      t.removeEventListener('pointercancel', this._onPointerUp);
    }

    _bindScroll() {
      this._onScroll = () => this._updateDots();
      this._track.addEventListener('scroll', this._onScroll, { passive: true });
    }

    _bindDrag() {
      const t = this._track;

      this._onPointerDown = (e) => {
        /* Ignore right-click and touch (touch handled natively) */
        if (e.pointerType === 'touch') return;
        this._isDragging = true;
        this._startX = e.clientX;
        this._scrollStart = t.scrollLeft;
        t.setPointerCapture(e.pointerId);
        t.classList.add('is-dragging');
      };

      this._onPointerMove = (e) => {
        if (!this._isDragging) return;
        const dx = e.clientX - this._startX;
        t.scrollLeft = this._scrollStart - dx;
      };

      this._onPointerUp = (e) => {
        if (!this._isDragging) return;
        this._isDragging = false;
        t.classList.remove('is-dragging');
      };

      t.addEventListener('pointerdown', this._onPointerDown);
      t.addEventListener('pointermove', this._onPointerMove);
      t.addEventListener('pointerup', this._onPointerUp);
      t.addEventListener('pointercancel', this._onPointerUp);

      /* Prevent click-through after drag */
      t.addEventListener('click', (e) => {
        if (Math.abs(t.scrollLeft - this._scrollStart) > 4) e.stopPropagation();
      }, true);
    }

    _updateDots() {
      if (!this._dots.length) return;
      const t = this._track;
      const max = t.scrollWidth - t.clientWidth;
      if (max <= 0) return;
      const ratio = t.scrollLeft / max;
      const total = this._dots.length;
      const active = Math.round(ratio * (total - 1));
      this._dots.forEach((dot, i) => {
        dot.classList.toggle('dtc-social-stories__dot--active', i === active);
      });
    }
  }
  customElements.define('dtc-social-stories', DtcSocialStories);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-tech-feature-accordion"] && !Shopify.designMode) return;
  try {
    
  class DtcTechFeatureAccordion extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('[data-feature-item]'));
      this._backgrounds = Array.from(this.querySelectorAll('[data-bg-index]'));
      this._activeIndex = this._items.findIndex((item) => item.classList.contains('is-open'));
      this._bindEvents();
      this._bindEditorEvents();
    }

    disconnectedCallback() {
      this._unbindEditorEvents();
    }

    _bindEvents() {
      this._items.forEach((item) => {
        item.addEventListener('click', () => {
          const index = Number(item.dataset.featureIndex);
          if (Number.isNaN(index)) return;

          if (this._activeIndex === index) {
            this._deactivate();
          } else {
            this._activate(index);
          }
        });
      });
    }

    _deactivate() {
      this._activeIndex = -1;

      this._items.forEach((item) => {
        const description = item.querySelector('[data-feature-description]');

        item.classList.remove('is-open');
        item.setAttribute('aria-selected', 'false');

        if (description) {
          description.setAttribute('aria-hidden', 'true');
        }
      });
    }

    _activate(index) {
      this._activeIndex = index;

      this._items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        const description = item.querySelector('[data-feature-description]');

        item.classList.toggle('is-open', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (description) {
          description.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }
      });

      this._backgrounds.forEach((background) => {
        const isActive = Number(background.dataset.bgIndex) === index;
        background.classList.toggle('is-active', isActive);
      });
    }

    _bindEditorEvents() {
      if (!window.Shopify || !Shopify.designMode) return;

      this._shopifySection = this.closest('.shopify-section');
      if (!this._shopifySection) return;

      this._handleBlockSelect = (event) => {
        const targetItem = event.target && event.target.closest('[data-feature-item]');
        if (!targetItem) return;

        const index = Number(targetItem.dataset.featureIndex);
        if (!Number.isNaN(index)) {
          this._activate(index);
        }
      };

      this._shopifySection.addEventListener('shopify:block:select', this._handleBlockSelect);
    }

    _unbindEditorEvents() {
      if (this._shopifySection && this._handleBlockSelect) {
        this._shopifySection.removeEventListener('shopify:block:select', this._handleBlockSelect);
      }
    }
  }

  if (!customElements.get('dtc-tech-feature-accordion')) {
    customElements.define('dtc-tech-feature-accordion', DtcTechFeatureAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-terms-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-terms-content')) {
    class DtcTermsContent extends HTMLElement {}
    customElements.define('dtc-terms-content', DtcTermsContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-testimonial-bento"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseSources(card, playBtn) {
    try {
      return JSON.parse(playBtn.getAttribute('data-video-sources') || '[]');
    } catch (e) {
      return [];
    }
  }

  function loadSources(video, sources) {
    video.innerHTML = '';
    sources.forEach(function (source) {
      var el = document.createElement('source');
      el.src = source.url;
      el.type = source.type;
      video.appendChild(el);
    });
  }

  function initVideoCard(card) {
    var playBtn = card.querySelector('.dtc-testimonial-bento__play');
    var videoWrap = card.querySelector('.dtc-testimonial-bento__video-wrap');
    var closeBtn = card.querySelector('.dtc-testimonial-bento__video-close');
    var video = card.querySelector('.dtc-testimonial-bento__video-player');
    if (!playBtn || !videoWrap || !video) return;

    function startVideo() {
      var sources = parseSources(card, playBtn);
      if (!sources.length) return;
      if (!video.querySelector('source')) loadSources(video, sources);
      videoWrap.removeAttribute('hidden');
      video.load();
      video.play().catch(function () {});
      card.classList.add('dtc-testimonial-bento__video-card--playing');
    }

    function stopVideo() {
      video.pause();
      video.innerHTML = '';
      videoWrap.setAttribute('hidden', '');
      card.classList.remove('dtc-testimonial-bento__video-card--playing');
    }

    playBtn.addEventListener('click', startVideo);
    if (closeBtn) closeBtn.addEventListener('click', stopVideo);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.dtc-testimonial-bento__video-card .dtc-testimonial-bento__play').forEach(function (btn) {
      var card = btn.closest('.dtc-testimonial-bento__video-card');
      if (card) initVideoCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-trusted-stats"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-trusted-stats')) {
  class DtcTrustedStats extends HTMLElement {
    connectedCallback() {
      this._observed = false;
      this._io = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting || this._observed) return;
          this._observed = true;
          this._io.disconnect();
          this._animateAll();
        },
        { threshold: 0.25 }
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    _animateAll() {
      const numbers = this.querySelectorAll('.dtc-trusted-stats__number[data-target]');
      numbers.forEach((el) => this._countUp(el));
    }

    _countUp(el) {
      const target = parseFloat(el.dataset.target);
      const suffix = el.dataset.suffix || '';
      const prefix = el.dataset.prefix || '';

      if (!target || isNaN(target)) return;

      const duration = 1800;
      const start = performance.now();
      const isFloat = target % 1 !== 0;

      const tick = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        /* Ease-out cubic */
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;

        el.textContent = prefix + (isFloat ? current.toFixed(1) : Math.floor(current)) + suffix;

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = prefix + (isFloat ? target.toFixed(1) : target) + suffix;
        }
      };

      requestAnimationFrame(tick);
    }
  }

  customElements.define('dtc-trusted-stats', DtcTrustedStats);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-user-manual-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-user-manual-grid')) {
    class DtcUserManualGrid extends HTMLElement {}
    customElements.define('dtc-user-manual-grid', DtcUserManualGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-user-manuals-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-user-manuals-grid')) {
    class DtcUserManualGrid extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-collection-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
        this.productsPerPage = parseInt(this.dataset.productsPerPage, 10) || 9;
        this.handleTrigger = this.handleTrigger.bind(this);
        this.handlePagination = this.handlePagination.bind(this);

        this.triggers.forEach((trigger) => trigger.addEventListener('click', this.handleTrigger));
        this.addEventListener('click', this.handlePagination);
        this.panels.forEach((panel) => this.initPanelPagination(panel));
        this.applyInitialSelection();
      }

      disconnectedCallback() {
        this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleTrigger));
        this.removeEventListener('click', this.handlePagination);
      }

      initPanelPagination(panel) {
        const items = Array.from(panel.querySelectorAll('[data-manual-grid-item]'));
        const nav = panel.querySelector('[data-manual-grid-pagination]');
        const totalPages = Math.max(1, Math.ceil(items.length / this.productsPerPage));

        panel.dataset.totalPages = String(totalPages);
        panel.dataset.currentPage = '1';

        if (!items.length || !nav || totalPages <= 1) {
          items.forEach((item) => item.removeAttribute('hidden'));
          nav?.setAttribute('hidden', '');
          return;
        }

        nav.removeAttribute('hidden');
        this.setPanelPage(panel, 1, false);
      }

      buildPageParts(currentPage, totalPages) {
        if (totalPages <= 5) {
          return Array.from({ length: totalPages }, (_, index) => ({ type: 'page', value: index + 1 }));
        }

        const pageSet = new Set([1, 2, 3, totalPages, currentPage, currentPage - 1, currentPage + 1]);
        const pages = [...pageSet].filter((page) => page >= 1 && page <= totalPages).sort((a, b) => a - b);
        const parts = [];
        let previousPage = 0;

        pages.forEach((page) => {
          if (page - previousPage > 1) parts.push({ type: 'ellipsis' });
          parts.push({ type: 'page', value: page });
          previousPage = page;
        });

        return parts;
      }

      renderPaginationNav(nav, currentPage, totalPages) {
        const previousLabel = this.dataset.paginationPrevious || 'Previous';
        const nextLabel = this.dataset.paginationNext || 'Next';
        const parts = this.buildPageParts(currentPage, totalPages);
        const moduleName = this.querySelector('[data-v-gtm-module]')?.getAttribute('data-v-gtm-module') || 'Article Section';

        nav.replaceChildren();

        const desktop = document.createElement('div');
        desktop.className = 'dtc-user-manual-grid__pagination-desktop';

        const previousButton = document.createElement('button');
        previousButton.type = 'button';
        previousButton.className = `dtc-user-manual-grid__pagination-link${currentPage === 1 ? ' dtc-user-manual-grid__pagination-link--muted' : ''}`;
        previousButton.dataset.paginationAction = 'prev';
        previousButton.setAttribute('aria-label', previousLabel);
        previousButton.textContent = `← ${previousLabel.replace(/ page$/i, '')}`;
        desktop.appendChild(previousButton);

        const pagesWrap = document.createElement('div');
        pagesWrap.className = 'dtc-user-manual-grid__pagination-pages';

        parts.forEach((part) => {
          if (part.type === 'ellipsis') {
            const ellipsis = document.createElement('span');
            ellipsis.className = 'dtc-user-manual-grid__pagination-ellipsis';
            ellipsis.setAttribute('aria-hidden', 'true');
            ellipsis.textContent = '...';
            pagesWrap.appendChild(ellipsis);
            return;
          }

          const pageButton = document.createElement('button');
          pageButton.type = 'button';
          pageButton.className = `dtc-user-manual-grid__pagination-page${part.value === currentPage ? ' is-active' : ''}`;
          pageButton.dataset.paginationPage = String(part.value);
          pageButton.dataset.vGtmEvent = 'turn_page';
          pageButton.dataset.vGtmContentType = moduleName;
          pageButton.dataset.vGtmContentName = String(part.value);
          pageButton.setAttribute('aria-label', `Page ${part.value}`);
          pageButton.setAttribute('aria-current', part.value === currentPage ? 'page' : 'false');
          pageButton.textContent = String(part.value);
          pagesWrap.appendChild(pageButton);
        });

        desktop.appendChild(pagesWrap);

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = `dtc-user-manual-grid__pagination-link${currentPage === totalPages ? ' dtc-user-manual-grid__pagination-link--muted' : ''}`;
        nextButton.dataset.paginationAction = 'next';
        nextButton.setAttribute('aria-label', nextLabel);
        nextButton.textContent = `${nextLabel.replace(/ page$/i, '')} →`;
        desktop.appendChild(nextButton);

        const dots = document.createElement('div');
        dots.className = 'dtc-user-manual-grid__pagination-dots';
        dots.setAttribute('role', 'group');
        dots.setAttribute('aria-label', 'Pagination');

        for (let page = 1; page <= totalPages; page++) {
          const dotButton = document.createElement('button');
          dotButton.type = 'button';
          dotButton.className = `dtc-user-manual-grid__pagination-dot${page === currentPage ? ' is-active' : ''}`;
          dotButton.dataset.paginationPage = String(page);
          dotButton.dataset.vGtmEvent = 'turn_page';
          dotButton.dataset.vGtmContentType = moduleName;
          dotButton.dataset.vGtmContentName = String(page);
          dotButton.setAttribute('aria-label', `Page ${page}`);
          dotButton.setAttribute('aria-current', page === currentPage ? 'page' : 'false');
          dots.appendChild(dotButton);
        }

        nav.appendChild(desktop);
        nav.appendChild(dots);
      }

      setPanelPage(panel, page, shouldScroll) {
        const items = Array.from(panel.querySelectorAll('[data-manual-grid-item]'));
        const totalPages = parseInt(panel.dataset.totalPages, 10) || 1;
        const currentPage = Math.min(Math.max(page, 1), totalPages);
        const startIndex = (currentPage - 1) * this.productsPerPage;
        const endIndex = startIndex + this.productsPerPage;

        items.forEach((item, index) => {
          item.toggleAttribute('hidden', index < startIndex || index >= endIndex);
        });

        panel.dataset.currentPage = String(currentPage);

        const nav = panel.querySelector('[data-manual-grid-pagination]');
        if (nav && totalPages > 1) this.renderPaginationNav(nav, currentPage, totalPages);

        if (!shouldScroll) return;

        const layout = this.querySelector('.dtc-user-manual-grid__body');
        layout?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      handlePagination(event) {
        const control = event.target.closest('[data-pagination-action], [data-pagination-page]');
        if (!control || !this.contains(control)) return;

        const panel = control.closest('[data-collection-panel]');
        if (!panel?.classList.contains('is-active')) return;

        const currentPage = parseInt(panel.dataset.currentPage, 10) || 1;
        const totalPages = parseInt(panel.dataset.totalPages, 10) || 1;
        let nextPage = currentPage;

        if (control.dataset.paginationAction === 'prev') nextPage = currentPage - 1;
        if (control.dataset.paginationAction === 'next') nextPage = currentPage + 1;
        if (control.dataset.paginationPage) nextPage = parseInt(control.dataset.paginationPage, 10);

        if (nextPage < 1 || nextPage > totalPages || nextPage === currentPage) return;

        this.setPanelPage(panel, nextPage, true);
        this.updateUrl({ page: nextPage });
      }

      updateUrl({ collection, page }) {
        const currentUrl = new URL(window.location.href);

        if (collection) currentUrl.searchParams.set('collection', collection);

        if (page && page > 1) {
          currentUrl.searchParams.set('page', String(page));
        } else {
          currentUrl.searchParams.delete('page');
        }

        window.history.pushState(null, '', currentUrl.toString());
      }

      applyInitialSelection() {
        const params = new URLSearchParams(window.location.search);
        const collectionHandle = params.get('collection') || this.dataset.selectedCollection;
        const initialPage = parseInt(params.get('page'), 10) || 1;
        const hasTrigger = this.triggers.some((trigger) => trigger.dataset.collectionTrigger === collectionHandle);
        const targetHandle = hasTrigger ? collectionHandle : this.triggers[0]?.dataset.collectionTrigger;

        if (!targetHandle) return;

        this.selectCollection(targetHandle, false);

        const panel = this.panels.find((item) => item.dataset.collectionPanel === targetHandle);
        if (panel) this.setPanelPage(panel, initialPage, false);
      }

      handleTrigger(event) {
        this.selectCollection(event.currentTarget.dataset.collectionTrigger, true);
      }

      selectCollection(collectionHandle, shouldUpdateUrl) {
        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.collectionTrigger === collectionHandle;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.collectionPanel === collectionHandle;
          panel.toggleAttribute('hidden', !isActive);
          panel.classList.toggle('is-active', isActive);
        });

        const panel = this.panels.find((item) => item.dataset.collectionPanel === collectionHandle);
        if (panel) this.setPanelPage(panel, 1, false);

        if (!shouldUpdateUrl) return;

        this.updateUrl({ collection: collectionHandle, page: 1 });
      }
    }

    customElements.define('dtc-user-manuals-grid', DtcUserManualGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vacuum-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vacuum-comparison')) {
    class DtcVacuumComparison extends HTMLElement {
      connectedCallback() {
        this._bound = this._onResize.bind(this);
        window.addEventListener('resize', this._bound);

        this._initColumnNav();
        this._run();
        document.fonts.ready.then(() => this._run());
        window.addEventListener('load', () => this._run(), { once: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._bound);
      }

      _onResize() {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this._run(), 80);
      }

      _run() {
        if (window.innerWidth >= 700) {
          this._syncRowHeights();
          this._positionGlow();
        }
        this._updateNavBtns();
      }

      /* ---- Column carousel nav (mobile + desktop many-cols) ---- */

      _initColumnNav() {
        const columns = this.querySelector('.dtc-vacuum-comparison__columns');
        if (!columns || columns.dataset.navInit === 'true') return;
        columns.dataset.navInit = 'true';

        const track = this.querySelector('.dtc-vacuum-comparison__mobile-header-track');
        const prevBtns = Array.from(this.querySelectorAll(
          '.dtc-vacuum-comparison__mobile-nav-btn--prev, .dtc-vacuum-comparison__desktop-nav-btn--prev'
        ));
        const nextBtns = Array.from(this.querySelectorAll(
          '.dtc-vacuum-comparison__mobile-nav-btn--next, .dtc-vacuum-comparison__desktop-nav-btn--next'
        ));
        if (!prevBtns.length || !nextBtns.length) return;

        const scrollStep = (direction) => {
          const step = this._getColumnScrollStep(columns);
          columns.scrollBy({ left: direction * step, behavior: 'smooth' });
          if (track && window.innerWidth < 700) {
            track.scrollBy({ left: direction * step, behavior: 'smooth' });
          }
        };

        prevBtns.forEach(btn => btn.addEventListener('click', () => scrollStep(-1)));
        nextBtns.forEach(btn => btn.addEventListener('click', () => scrollStep(1)));

        columns.addEventListener('scroll', () => {
          if (track && window.innerWidth < 700) {
            track.scrollLeft = columns.scrollLeft;
          }
          clearTimeout(this._scrollTimer);
          this._scrollTimer = setTimeout(() => this._updateNavBtns(), 120);
        }, { passive: true });

        this._updateNavBtns();
      }

      _getColumnScrollStep(columns) {
        if (window.innerWidth >= 700 && this.classList.contains('dtc-vacuum-comparison--cols-many')) {
          const col = columns.querySelector('.dtc-vacuum-comparison__col');
          return col ? col.offsetWidth : columns.offsetWidth;
        }
        return columns.offsetWidth;
      }

      _updateNavBtns() {
        const columns = this.querySelector('.dtc-vacuum-comparison__columns');
        if (!columns) return;

        const scrollLeft = Math.round(columns.scrollLeft);
        const maxScroll  = columns.scrollWidth - columns.offsetWidth;
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft >= maxScroll - 1;

        this.querySelectorAll(
          '.dtc-vacuum-comparison__mobile-nav-btn--prev, .dtc-vacuum-comparison__desktop-nav-btn--prev'
        ).forEach(btn => { btn.disabled = atStart; });

        this.querySelectorAll(
          '.dtc-vacuum-comparison__mobile-nav-btn--next, .dtc-vacuum-comparison__desktop-nav-btn--next'
        ).forEach(btn => { btn.disabled = atEnd; });
      }

      /* ---- Glow position (desktop) ---- */

      _positionGlow() {
        const glow = this.querySelector('.dtc-vacuum-comparison__featured-glow');
        const featured = this.querySelector('.dtc-vacuum-comparison__col--featured');
        if (!glow || !featured) return;

        const sectionRect = this.getBoundingClientRect();
        const colRect = featured.getBoundingClientRect();
        if (sectionRect.width === 0) return;

        const centerX = (colRect.left - sectionRect.left + colRect.width / 2) / sectionRect.width * 100;
        glow.style.setProperty('--glow-x', centerX + '%');
      }

      /* ---- Desktop row height sync ---- */

      _syncRowHeights() {
        const labelCells = Array.from(this.querySelectorAll('.dtc-vacuum-comparison__label-cell'));
        const cols       = Array.from(this.querySelectorAll('.dtc-vacuum-comparison__col'));
        if (!labelCells.length || !cols.length) return;

        const rowCount = labelCells.length;
        const colCells = cols.map(col =>
          Array.from(col.querySelectorAll('.dtc-vacuum-comparison__data-cell'))
        );
        const infoSlots = ['info-name', 'info-btn', 'info-desc'].map(slot =>
          cols.map(col => col.querySelector(`.dtc-vacuum-comparison__${slot}`))
        );

        /* Reset heights */
        labelCells.forEach(c => { c.style.height = ''; });
        colCells.forEach(cells => cells.forEach(c => { c.style.height = ''; }));
        infoSlots.forEach(blocks => blocks.forEach(b => { if (b) b.style.height = ''; }));

        /* Sync info sub-blocks */
        infoSlots.forEach(blocks => {
          const maxH = blocks.reduce((m, b) =>
            b ? Math.max(m, b.getBoundingClientRect().height) : m, 0
          );
          blocks.forEach(b => { if (b) b.style.height = maxH + 'px'; });
        });

        /* Sync data rows */
        for (let i = 0; i < rowCount; i++) {
          let maxH = labelCells[i] ? labelCells[i].getBoundingClientRect().height : 0;
          colCells.forEach(cells => {
            if (cells[i]) maxH = Math.max(maxH, cells[i].getBoundingClientRect().height);
          });
          if (labelCells[i]) labelCells[i].style.height = maxH + 'px';
          colCells.forEach(cells => {
            if (cells[i]) cells[i].style.height = maxH + 'px';
          });
        }
      }
    }

    customElements.define('dtc-vacuum-comparison', DtcVacuumComparison);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vacuum-cost-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vacuum-cost-comparison')) {
    class DtcVacuumCostComparison extends HTMLElement {
      connectedCallback() {
        this._onResize = () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => this._run(), 80);
        };
        this._initColumnNav();
        window.addEventListener('resize', this._onResize, { passive: true });
        this._run();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
      }

      _run() {
        if (window.innerWidth >= 700) {
          this._syncDesktopRowHeights();
        }
        this._updateNavBtns();
      }

      _initColumnNav() {
        if (this.dataset.navInit === 'true') return;
        this.dataset.navInit = 'true';

        const mobileCols = this.querySelector('.dtc-vacuum-cost-comparison__mobile-cols');
        const desktopCols = this.querySelector('.dtc-vacuum-cost-comparison__desktop-cols');
        const track = this.querySelector('.dtc-vacuum-cost-comparison__mobile-header-track');

        const prevBtns = Array.from(this.querySelectorAll(
          '.dtc-vacuum-cost-comparison__mobile-nav-btn--prev, .dtc-vacuum-cost-comparison__desktop-nav-btn--prev'
        ));
        const nextBtns = Array.from(this.querySelectorAll(
          '.dtc-vacuum-cost-comparison__mobile-nav-btn--next, .dtc-vacuum-cost-comparison__desktop-nav-btn--next'
        ));
        if (!prevBtns.length || !nextBtns.length) return;

        const getActiveColumns = () => {
          if (window.innerWidth >= 700 && this.classList.contains('dtc-vacuum-cost-comparison--cols-many')) {
            return desktopCols;
          }
          return mobileCols;
        };

        const scrollStep = (direction) => {
          const columns = getActiveColumns();
          if (!columns) return;
          const step = this._getColumnScrollStep(columns);
          columns.scrollBy({ left: direction * step, behavior: 'smooth' });
          if (track && columns === mobileCols) {
            track.scrollBy({ left: direction * step, behavior: 'smooth' });
          }
        };

        prevBtns.forEach((btn) => btn.addEventListener('click', () => scrollStep(-1)));
        nextBtns.forEach((btn) => btn.addEventListener('click', () => scrollStep(1)));

        [mobileCols, desktopCols].filter(Boolean).forEach((columns) => {
          columns.addEventListener('scroll', () => {
            if (track && columns === mobileCols) {
              track.scrollLeft = columns.scrollLeft;
            }
            clearTimeout(this._scrollTimer);
            this._scrollTimer = setTimeout(() => this._updateNavBtns(), 120);
          }, { passive: true });
        });

        this._updateNavBtns();
      }

      _getColumnScrollStep(columns) {
        if (window.innerWidth >= 700 && this.classList.contains('dtc-vacuum-cost-comparison--cols-many')) {
          const col = columns.querySelector('.dtc-vacuum-cost-comparison__desktop-col');
          return col ? col.offsetWidth : columns.offsetWidth;
        }
        return columns.offsetWidth;
      }

      _updateNavBtns() {
        const columns =
          window.innerWidth >= 700 && this.classList.contains('dtc-vacuum-cost-comparison--cols-many')
            ? this.querySelector('.dtc-vacuum-cost-comparison__desktop-cols')
            : this.querySelector('.dtc-vacuum-cost-comparison__mobile-cols');
        if (!columns) return;

        const scrollLeft = Math.round(columns.scrollLeft);
        const maxScroll = columns.scrollWidth - columns.offsetWidth;
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft >= maxScroll - 1;

        this.querySelectorAll(
          '.dtc-vacuum-cost-comparison__mobile-nav-btn--prev, .dtc-vacuum-cost-comparison__desktop-nav-btn--prev'
        ).forEach((btn) => { btn.disabled = atStart; });

        this.querySelectorAll(
          '.dtc-vacuum-cost-comparison__mobile-nav-btn--next, .dtc-vacuum-cost-comparison__desktop-nav-btn--next'
        ).forEach((btn) => { btn.disabled = atEnd; });
      }

      _syncDesktopRowHeights() {
        if (!this.classList.contains('dtc-vacuum-cost-comparison--cols-many')) return;

        const labelCells = Array.from(
          this.querySelectorAll('.dtc-vacuum-cost-comparison__desktop-labels .dtc-vacuum-cost-comparison__label-cell')
        );
        const cols = Array.from(this.querySelectorAll('.dtc-vacuum-cost-comparison__desktop-col'));
        if (!labelCells.length || !cols.length) return;

        const colCells = cols.map((col) =>
          Array.from(col.querySelectorAll('.dtc-vacuum-cost-comparison__data-cell'))
        );
        const headers = cols.map((col) =>
          col.querySelector('.dtc-vacuum-cost-comparison__col-header')
        );
        const labelHeader = this.querySelector(
          '.dtc-vacuum-cost-comparison__desktop-labels .dtc-vacuum-cost-comparison__label-header'
        );

        labelCells.forEach((c) => { c.style.height = ''; });
        colCells.forEach((cells) => cells.forEach((c) => { c.style.height = ''; }));
        headers.forEach((h) => { if (h) h.style.height = ''; });
        if (labelHeader) labelHeader.style.height = '';

        const headerMax = headers.reduce(
          (m, h) => (h ? Math.max(m, h.getBoundingClientRect().height) : m),
          0
        );
        headers.forEach((h) => { if (h) h.style.height = headerMax + 'px'; });
        if (labelHeader) labelHeader.style.height = headerMax + 'px';

        labelCells.forEach((label, i) => {
          const rowCells = colCells.map((cells) => cells[i]).filter(Boolean);
          const maxH = Math.max(
            label.getBoundingClientRect().height,
            ...rowCells.map((c) => c.getBoundingClientRect().height)
          );
          label.style.height = maxH + 'px';
          rowCells.forEach((c) => { c.style.height = maxH + 'px'; });
        });
      }
    }
    customElements.define('dtc-vacuum-cost-comparison', DtcVacuumCostComparison);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vacuum-landing-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vacuum-landing-hero')) {
    class DtcVacuumLandingHero extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.listeners = [];
        this.waitForSwiper();

        if (window.Shopify && Shopify.designMode) {
          this.bind(document, 'shopify:block:select', (event) => this.onBlockSelect(event));
        }
      }

      disconnectedCallback() {
        this.listeners.forEach(({ element, type, handler }) => element.removeEventListener(type, handler));
        if (this.timer) clearInterval(this.timer);
        if (this.resizeTimer) clearTimeout(this.resizeTimer);
      }

      waitForSwiper() {
        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl) return;

        if (swiperEl.swiper) {
          this.setup(swiperEl.swiper);
          return;
        }

        let attempts = 0;
        this.timer = setInterval(() => {
          attempts += 1;
          if (swiperEl.swiper) {
            clearInterval(this.timer);
            this.setup(swiperEl.swiper);
          } else if (attempts > 50) {
            clearInterval(this.timer);
          }
        }, 100);
      }

      setup(swiper) {
        if (this.isReady) return;
        this.isReady = true;
        this.swiper = swiper;

        this.querySelectorAll('.dtc-vacuum-landing-hero__media img').forEach((img) => {
          const onLoad = () => this.syncLayout();
          if (img.complete) return;
          this.bind(img, 'load', onLoad);
        });

        this.syncLayout();
        this.bind(window, 'resize', () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.syncLayout(), 120);
        });
        swiper.on('slideChange', () => {
          this.syncLayout();
        });
        this.syncLayout();
      }

      syncLayout() {
        if (!this.swiper) return;

        if (typeof this.swiper.updateAutoHeight === 'function') {
          this.swiper.updateAutoHeight(0);
        }

        this.swiper.update();
      }

      onBlockSelect(event) {
        if (!this.sectionId || String(event.detail.sectionId) !== String(this.sectionId)) return;

        const blockId = event.detail.blockId;
        const slide = this.querySelector(`[data-block-id="${blockId}"]`);
        if (!slide || !this.swiper) return;

        const index = Array.from(slide.parentElement.children).indexOf(slide);
        if (index < 0) return;

        if (this.swiper.params.loop) {
          this.swiper.slideToLoop(index);
        } else {
          this.swiper.slideTo(index);
        }
      }

      bind(element, type, handler) {
        element.addEventListener(type, handler);
        this.listeners.push({ element, type, handler });
      }
    }

    customElements.define('dtc-vacuum-landing-hero', DtcVacuumLandingHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-app-download-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vesync-app-download-bar')) {
    class DtcVesyncAppDownloadBar extends HTMLElement {}
    customElements.define('dtc-vesync-app-download-bar', DtcVesyncAppDownloadBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-app-download"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vesync-app-download')) {
    class DtcVesyncAppDownload extends HTMLElement {}
    customElements.define('dtc-vesync-app-download', DtcVesyncAppDownload);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-app-feature-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-app-feature-accordion')) {
    class DtcAppFeatureAccordion extends HTMLElement {
      connectedCallback() {
        const prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this._detailsItems = Array.from(
          this.querySelectorAll('details.dtc-app-feature-accordion__item')
        );

        this._detailsItems.forEach((details) => {
          this._initAccordionItem(details, prefersReducedMotion);
        });

        this._downloadButton = this.querySelector('.dtc-app-feature-accordion__download');
        if (this._downloadButton) {
          this._onDownloadClick = (event) => {
            const ua = navigator.userAgent || navigator.vendor || window.opera || '';
            const isAndroid = /android/i.test(ua);
            const isIOS =
              /iPad|iPhone|iPod/.test(ua) ||
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

            if (isAndroid) {
              event.preventDefault();
              window.open(this._downloadButton.dataset.androidUrl, '_blank', 'noopener,noreferrer');
            } else if (isIOS) {
              event.preventDefault();
              window.open(this._downloadButton.dataset.iosUrl, '_blank', 'noopener,noreferrer');
            }
          };
          this._downloadButton.addEventListener('click', this._onDownloadClick);
        }
      }

      _closeOtherItems(current, prefersReducedMotion) {
        this._detailsItems.forEach((detail) => {
          if (detail === current || !detail.hasAttribute('open')) return;

          const panel = detail.querySelector('[data-dtc-app-accordion-panel]');
          if (!panel || prefersReducedMotion) {
            detail.removeAttribute('open');
            panel?.classList.remove('is-open');
            return;
          }

          panel.classList.remove('is-open');

          let completed = false;
          const finish = () => {
            if (completed) return;
            completed = true;
            detail.removeAttribute('open');
          };

          const onTransitionEnd = (event) => {
            if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
            panel.removeEventListener('transitionend', onTransitionEnd);
            finish();
          };

          panel.addEventListener('transitionend', onTransitionEnd);
          setTimeout(finish, 450);
        });
      }

      _initAccordionItem(details, prefersReducedMotion) {
        const summary = details.querySelector('.dtc-app-feature-accordion__summary');
        const panel = details.querySelector('[data-dtc-app-accordion-panel]');
        if (!summary || !panel) return;

        let transitionCleanup = null;

        const cleanupTransition = () => {
          if (!transitionCleanup) return;
          transitionCleanup();
          transitionCleanup = null;
        };

        const setOpenState = (isOpen) => {
          cleanupTransition();
          if (isOpen) {
            details.setAttribute('open', '');
            panel.classList.add('is-open');
          } else {
            details.removeAttribute('open');
            panel.classList.remove('is-open');
          }
        };

        const waitForPanelTransition = (onComplete) => {
          let completed = false;

          const finish = () => {
            if (completed) return;
            completed = true;
            cleanupTransition();
            onComplete();
          };

          const onTransitionEnd = (event) => {
            if (event.target !== panel) return;
            if (
              event.propertyName !== 'grid-template-rows' &&
              event.propertyName !== 'opacity'
            ) {
              return;
            }
            finish();
          };

          panel.addEventListener('transitionend', onTransitionEnd);
          const fallbackTimer = setTimeout(finish, 450);
          transitionCleanup = () => {
            panel.removeEventListener('transitionend', onTransitionEnd);
            clearTimeout(fallbackTimer);
          };
        };

        if (details.hasAttribute('open')) {
          panel.classList.add('is-open');
        }

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          const willOpen = !details.hasAttribute('open');

          if (prefersReducedMotion) {
            if (willOpen) {
              this._closeOtherItems(details, true);
            }
            setOpenState(willOpen);
            return;
          }

          if (willOpen) {
            this._closeOtherItems(details, false);
            details.setAttribute('open', '');
            panel.classList.remove('is-open');
            panel.offsetHeight;
            panel.classList.add('is-open');
            return;
          }

          panel.classList.remove('is-open');
          waitForPanelTransition(() => {
            details.removeAttribute('open');
          });
        });
      }

      disconnectedCallback() {
        if (this._downloadButton && this._onDownloadClick) {
          this._downloadButton.removeEventListener('click', this._onDownloadClick);
        }
      }
    }
    customElements.define('dtc-app-feature-accordion', DtcAppFeatureAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-app-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vesync-app-hero')) {
    class DtcVesyncAppHero extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('.dtc-vesync-app-hero__media');
        this.video = this.querySelector('.dtc-vesync-app-hero__media-video');
        this.playButton = this.querySelector('.dtc-vesync-app-hero__play:not(.dtc-vesync-app-hero__play--static)');

        if (!this.media || !this.video || !this.playButton) return;

        this.handleToggleClick = this.handleToggleClick || this._toggleVideo.bind(this);
        this.handleSyncState = this.handleSyncState || this._syncState.bind(this);

        this.playButton.addEventListener('click', this.handleToggleClick);
        this.video.addEventListener('click', this.handleToggleClick);
        this.video.addEventListener('play', this.handleSyncState);
        this.video.addEventListener('pause', this.handleSyncState);
        this.video.addEventListener('ended', this.handleSyncState);
        this._syncState();
      }

      _toggleVideo(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (this.video.paused || this.video.ended) {
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => this._syncState());
          }
        } else {
          this.video.pause();
        }
      }

      _syncState() {
        const isPlaying = !this.video.paused && !this.video.ended;
        this.media.classList.toggle('is-playing', isPlaying);
        this.video.controls = false;
        this.playButton.setAttribute(
          'aria-label',
          isPlaying ? this.playButton.dataset.pauseLabel : this.playButton.dataset.playLabel
        );
      }
    }
    customElements.define('dtc-vesync-app-hero', DtcVesyncAppHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-ecosystem-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vesync-ecosystem-cards')) {
    class DtcVesyncEcosystemCards extends HTMLElement {}
    customElements.define('dtc-vesync-ecosystem-cards', DtcVesyncEcosystemCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-vesync-integrations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-vesync-integrations')) {
    class DtcVesyncIntegrations extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.dtc-vesync-integrations__media').forEach((media) => {
          if (media._dtcVesyncIntegrationsInit) return;
          media._dtcVesyncIntegrationsInit = true;

          const playBtn = media.querySelector('.dtc-vesync-integrations__play');
          const videoWrap = media.querySelector('.dtc-vesync-integrations__video-wrap');
          const video = media.querySelector('.dtc-vesync-integrations__video');
          const closeBtn = media.querySelector('.dtc-vesync-integrations__video-close');

          if (!playBtn || !videoWrap || !video) return;

          playBtn.addEventListener('click', () => {
            let sources = [];
            try {
              sources = JSON.parse(playBtn.dataset.videoSources || '[]');
            } catch (error) {
              sources = [];
            }
            if (!sources.length) return;

            video.innerHTML = '';
            sources.forEach((source) => {
              const src = document.createElement('source');
              src.src = source.url;
              src.type = source.type;
              video.appendChild(src);
            });

            videoWrap.hidden = false;
            playBtn.hidden = true;
            video.load();
            video.play().catch(() => {});
          });

          if (closeBtn) {
            closeBtn.addEventListener('click', () => {
              video.pause();
              videoWrap.hidden = true;
              playBtn.hidden = false;
            });
          }
        });
      }
    }

    customElements.define('dtc-vesync-integrations', DtcVesyncIntegrations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtc-video')) {
    class DtcVideo extends HTMLElement {
      connectedCallback() {
        const media = this.querySelector('.dtc-video__media');
        if (!media || media._dtcVideoInit) return;
        media._dtcVideoInit = true;

        const playBtn = media.querySelector('.dtc-video__play');
        const playerWrap = media.querySelector('.dtc-video__player');
        const video = media.querySelector('.dtc-video__video');
        const iframe = media.querySelector('.dtc-video__iframe');
        const closeBtn = media.querySelector('.dtc-video__close');

        if (!playBtn || !playerWrap) return;

        const getUploadedSources = () => {
          const mobileQuery = window.matchMedia('(max-width: 699px)');
          const mobileSources = playBtn.dataset.videoSourcesMobile || '[]';
          const desktopSources = playBtn.dataset.videoSourcesDesktop || '[]';
          const raw = mobileQuery.matches ? mobileSources : desktopSources;

          try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            return [];
          }
        };

        const resetPlayer = () => {
          playerWrap.hidden = true;
          playBtn.hidden = false;

          if (video) {
            video.pause();
            video.innerHTML = '';
          }

          if (iframe) {
            iframe.src = '';
          }
        };

        playBtn.addEventListener('click', () => {
          if (video) {
            const sources = getUploadedSources();
            if (!sources.length) return;

            video.innerHTML = '';
            sources.forEach((source) => {
              const src = document.createElement('source');
              src.src = source.url;
              src.type = source.type;
              video.appendChild(src);
            });

            playerWrap.hidden = false;
            playBtn.hidden = true;
            video.load();
            video.play().catch(() => {});
            return;
          }

          if (iframe && playBtn.dataset.embedUrl) {
            iframe.src = playBtn.dataset.embedUrl;
            playerWrap.hidden = false;
            playBtn.hidden = true;
          }
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', resetPlayer);
        }
      }
    }

    customElements.define('dtc-video', DtcVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-why-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseSources(card, playBtn) {
    var raw = (playBtn && playBtn.dataset.videoSources) || card.dataset.videoSources || '[]';
    try {
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  function loadSources(video, sources) {
    video.innerHTML = '';
    sources.forEach(function (s) {
      var src = document.createElement('source');
      src.src = s.url;
      src.type = s.type;
      video.appendChild(src);
    });
  }

  function initImageCard(card) {
    if (card._dtcWhyTrustVideoInit) return;
    card._dtcWhyTrustVideoInit = true;

    var autoplay = card.dataset.videoAutoplay === 'true';
    var video = card.querySelector('.dtc-why-trust__card-video');
    if (!video) return;

    if (autoplay) {
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.25, 0.5] }
      );
      observer.observe(card);
      return;
    }

    var playBtn = card.querySelector('.dtc-why-trust__card-play');
    var videoWrap = card.querySelector('.dtc-why-trust__card-video-wrap');
    var closeBtn = card.querySelector('.dtc-why-trust__card-video-close');
    if (!playBtn || !videoWrap) return;

    function startVideo() {
      var sources = parseSources(card, playBtn);
      if (!sources.length) return;
      if (!video.querySelector('source')) loadSources(video, sources);
      videoWrap.removeAttribute('hidden');
      video.load();
      video.play().catch(function () {});
      card.classList.add('dtc-why-trust__card--playing');
    }

    function stopVideo() {
      video.pause();
      video.innerHTML = '';
      videoWrap.setAttribute('hidden', '');
      card.classList.remove('dtc-why-trust__card--playing');
    }

    playBtn.addEventListener('click', startVideo);
    if (closeBtn) closeBtn.addEventListener('click', stopVideo);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.dtc-why-trust__card--image[data-video-autoplay], .dtc-why-trust__card--image .dtc-why-trust__card-play').forEach(function (el) {
      var card = el.classList.contains('dtc-why-trust__card--image') ? el : el.closest('.dtc-why-trust__card--image');
      if (card) initImageCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header'); 
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const overlayHeader = document.querySelector('sticky-header.header-wrapper');
      // alert(overlayHeader.getAttribute('data-index'));
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return; 
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
       if (overlayHeader.getAttribute('data-index') != null) { overlayHeader.classList.remove('header--overlayHeader');} 
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
       if (overlayHeader.getAttribute('data-index') != null) { overlayHeader.classList.remove('header--overlayHeader');} 
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
         if (overlayHeader.getAttribute('data-index') != null) { overlayHeader.classList.add('header--overlayHeader');}
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-with-slider"] && !Shopify.designMode) return;
  try {
    
  var contentSwiper = new Swiper('.slider-content', {
    direction: 'vertical',
    mousewheel: true,
    effect: 'slide',
    speed: 1000,
    slidesPerView: 3,
    centeredSlides: true,
    loop: true, // Not recommended to enable!!!
    // autoplay:{
    //   delay:5000,
    // },
    pagination: {
      el: '.swiper-pagination-slider',
      clickable: true,
    },
  });
  var sliderimageSwiper = new Swiper('.slider-image-blocks-container', {
    mousewheel: true,
    speed: 1000,
    loop: true, // Not recommended to enable!!!
    longSwipesRatio: 0.01,
    // grabCursor: true,
    watchSlidesProgress: true,
    parallax: true,
    lazy: {
      loadPrevNext: true,
    },
  });
  sliderimageSwiper.controller.control = contentSwiper;
  contentSwiper.controller.control = sliderimageSwiper;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-main"]) return;
  try {
    
// https://platformapi.vesync.com
  const API_BASE_URL = 'https://platformapi.vesync.com';
  const CAPTCHA_API_URL =
    `${API_BASE_URL}/globalPlatform/api/advertisingPlatform/v1/getAdvertisingCaptcha`;
  const SUBMIT_API_URL =
    `${API_BASE_URL}/globalPlatform/api/advertisingPlatform/v1/advertisingEmailUnsubscribe`;

  class SupportCaptchaForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.support-captcha-form__form');
      this.emailInput = this.form.querySelector('[name="email"]');
      this.captchaInput = this.form.querySelector('[name="captcha"]');
      this.imageEl = this.querySelector('.support-captcha-form__image');
      this.refreshBtn = this.querySelector('.support-captcha-form__refresh');
      this.submitBtn = this.querySelector('.support-captcha-form__submit');
      this.errorEl = this.querySelector('.support-captcha-form__message--error');
      this.successEl = this.querySelector('.support-captcha-form__message--success');
      this.captchaKey = '';
      this.isSubmitting = false;
      this._captchaExpireTimer = null;

      this._onSubmit = this._onSubmit.bind(this);
      this._onRefresh = this._onRefresh.bind(this);
      this._onEmailInput = this._onEmailInput.bind(this);

      this.form.addEventListener('submit', this._onSubmit);
      this.refreshBtn.addEventListener('click', this._onRefresh);
      this.emailInput.addEventListener('input', this._onEmailInput);

      this.loadCaptcha();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this._onSubmit);
      this.refreshBtn?.removeEventListener('click', this._onRefresh);
      this.emailInput?.removeEventListener('input', this._onEmailInput);
      this._clearCaptchaExpireTimer();
    }

    _isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    _setFieldError(input, hasError) {
      if (!input) return;
      input.classList.toggle('is-invalid', hasError);
      if (hasError) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }
    }

    _clearFieldErrors() {
      this._setFieldError(this.emailInput, false);
      this._setFieldError(this.captchaInput, false);
    }

    _onEmailInput() {
      const email = this.emailInput.value.trim();
      if (this.emailInput.classList.contains('is-invalid') && (email === '' || this._isValidEmail(email))) {
        this._setFieldError(this.emailInput, false);
      }
    }

    _getTerminalId() {
      const storageKey = 'support-terminal-id';
      let terminalId = '';

      try {
        terminalId = window.localStorage.getItem(storageKey) || '';
      } catch (error) {
        terminalId = '';
      }

      if (!terminalId) {
        terminalId =
          typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : `web-${Date.now()}`;

        try {
          window.localStorage.setItem(storageKey, terminalId);
        } catch (error) {
          // Ignore storage failures and keep the generated ID for this session.
        }
      }

      return terminalId;
    }

    _buildRequestContext(method) {
      return {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles',
        acceptLanguage: document.documentElement.lang || 'en',
        osInfo: 'Web',
        clientInfo: navigator.userAgent || 'Shopify',
        clientType: 'web',
        clientVersion: '1.0.0',
        terminalId: this._getTerminalId(),
        appID: 'rxrovonj',
        sourceAppID: 'cosori-shopify',
        traceId: `WEB${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        method,
        reqTimestamp: Date.now(),
        token: '',
        module: '',
        debugMode: false,
        invokeType: '',
        accountID: '',
      };
    }

    _buildApiRequest(method, data = {}) {
      return {
        context: this._buildRequestContext(method),
        data,
      };
    }

    _clearCaptchaExpireTimer() {
      if (this._captchaExpireTimer) {
        clearTimeout(this._captchaExpireTimer);
        this._captchaExpireTimer = null;
      }
    }

    _scheduleCaptchaExpiry(expireSeconds) {
      this._clearCaptchaExpireTimer();

      if (!expireSeconds || expireSeconds <= 0) return;

      this._captchaExpireTimer = setTimeout(() => {
        this.captchaKey = '';
      }, expireSeconds * 1000);
    }

    _resolveCaptchaImage(base64) {
      if (!base64) return '';

      if (base64.startsWith('data:') || base64.startsWith('http')) {
        return base64;
      }

      return `data:image/png;base64,${base64}`;
    }

    _clearMessages() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
      this.successEl.hidden = true;
      this.successEl.textContent = '';
    }

    _showError(message) {
      this.successEl.hidden = true;
      this.successEl.textContent = '';
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    _showSuccess(message) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
      this.successEl.textContent = message;
      this.successEl.hidden = false;
    }

    _setLoading(isLoading) {
      this.isSubmitting = isLoading;
      this.submitBtn.disabled = isLoading;
      this.submitBtn.classList.toggle('is-loading', isLoading);
      this.querySelector('.support-captcha-form__submit-text').hidden = isLoading;
      this.querySelector('.support-captcha-form__submit-loading').hidden = !isLoading;
    }

    _setCaptchaLoading(isLoading) {
      this.refreshBtn.disabled = isLoading;
      this.refreshBtn.classList.toggle('is-loading', isLoading);
    }

    async loadCaptcha({ clearMessages = true } = {}) {
      this._setCaptchaLoading(true);
      if (clearMessages) {
        this._clearMessages();
      }
      this._clearCaptchaExpireTimer();
      this.captchaKey = '';

      try {
        const response = await fetch(CAPTCHA_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(this._buildApiRequest('getAdvertisingCaptcha')),
        });

        const body = await response.json().catch(() => ({}));

        if (!response.ok || body.code !== 0) {
          throw new Error(body.msg || 'Failed to load verification code.');
        }

        const result = body.result || {};
        const imageSrc = this._resolveCaptchaImage(result.captchaImageBase64);

        if (!result.captchaKey || !imageSrc) {
          throw new Error('Verification image is unavailable.');
        }

        this.captchaKey = result.captchaKey;
        this.imageEl.src = imageSrc;
        this.imageEl.hidden = false;
        this.captchaInput.value = '';
        this._scheduleCaptchaExpiry(result.expireSeconds);
      } catch (error) {
        this.imageEl.hidden = true;
        const message =
          error?.message === 'Failed to fetch'
            ? 'Unable to load verification code. Please check your connection and try again.'
            : error.message || 'Failed to load verification code. Please try again.';
        this._showError(message);
      } finally {
        this._setCaptchaLoading(false);
      }
    }

    _onRefresh() {
      if (this.isSubmitting) return;
      this.loadCaptcha();
    }

    async _onSubmit(event) {
      event.preventDefault();

      if (this.isSubmitting) return;

      this._clearMessages();
      this._clearFieldErrors();

      const email = this.emailInput.value.trim();
      const captchaCode = this.captchaInput.value.trim();

      if (!email) {
        this._showError('Please enter your email address.');
        return;
      }

      if (!this._isValidEmail(email)) {
        this._setFieldError(this.emailInput, true);
        this._showError('This email is invalid');
        return;
      }

      if (!captchaCode) {
        this._showError('Please enter the verification code.');
        return;
      }

      if (!this.captchaKey) {
        this._showError('Verification code expired. Please refresh and try again.');
        await this.loadCaptcha({ clearMessages: false });
        return;
      }

      this._setLoading(true);

      try {
        const response = await fetch(SUBMIT_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(
            this._buildApiRequest('advertisingEmailUnsubscribe', {
              email,
              captchaKey: this.captchaKey,
              captchaCode,
            })
          ),
        });

        const body = await response.json().catch(() => ({}));

        if (!response.ok || body.code !== 0) {
          throw new Error(body.msg || 'Submission failed. Please try again.');
        }

        // this.form.reset();
        this._clearFieldErrors();
        await this.loadCaptcha({ clearMessages: false });
        this._showSuccess('Submitted successfully!');
      } catch (error) {
        this._showError(error.message || 'Submission failed. Please try again.');
        await this.loadCaptcha({ clearMessages: false });
      } finally {
        this._setLoading(false);
      }
    }
  }

  if (!customElements.get('support-captcha-form')) {
    customElements.define('support-captcha-form', SupportCaptchaForm);
  }

  } catch(e) { console.error(e); }
})();
})();
